
      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("dUYS2", function(module, exports) {

parcelRequire("ihxXg");




// Need to disable this because this affects how files are bundled together
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $fd10e50337bcb934$var$lazyImports = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    (parcelRequire("2I68T"));
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    (parcelRequire("7lk3V"));
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    (parcelRequire("lDIQ7"));
};
// We set this global variable to ensure it is available to all environments
// and then overwrite its value to TRUE in the JiraSPA entries: SSR and non-SSR
$parcel$global.__SPA__ = false;

});
parcelRegister("ihxXg", function(module, exports) {

var $d2S0J = parcelRequire("d2S0J");

var $hGtke = parcelRequire("hGtke");

var $5HqKn = parcelRequire("5HqKn");

var $7oY9g = parcelRequire("7oY9g");

var $cWTNU = parcelRequire("cWTNU");
if (!(0, $7oY9g.default)('fe_platform_error_tracking_enabled_sentry')) (0, $5HqKn.installGlobalHandler)();
(0, $hGtke.installErrorHandler)((0, $cWTNU.platformErrorHandler));
(0, $d2S0J.default)();

});
parcelRegister("5HqKn", function(module, exports) {
$parcel$export(module.exports, "installGlobalHandler", () => $2ac4973e429d30e5$export$7da675e3dd1bd6b5);

var $bQ0b4 = parcelRequire("bQ0b4");
const $2ac4973e429d30e5$export$7da675e3dd1bd6b5 = ()=>false ? undefined : (0, $bQ0b4.installGlobalHandler)();

});
parcelRegister("bQ0b4", function(module, exports) {
$parcel$export(module.exports, "installGlobalHandler", () => $b4c94cfb888234a3$export$7da675e3dd1bd6b5);

var $kINbm = parcelRequire("kINbm");
var $38t4T = parcelRequire("38t4T");
var $kvkQX = parcelRequire("kvkQX");

var $5fWuD = parcelRequire("5fWuD");
var $gwUes = parcelRequire("gwUes");
var $gOI8F = parcelRequire("gOI8F");
var $jPpPM = parcelRequire("jPpPM");

var $lopBx = parcelRequire("lopBx");

var $aYncF = parcelRequire("aYncF");

var $7jTnu = parcelRequire("7jTnu");

var $hWeHP = parcelRequire("hWeHP");

var $j0R8U = parcelRequire("j0R8U");

var $1G7kx = parcelRequire("1G7kx");
const $b4c94cfb888234a3$var$SENTRY_URL = 'https://12742a0abbd1484686195dca8ba74be6@o55978.ingest.sentry.io/5988809';
const $b4c94cfb888234a3$var$FRONTEND_RESOURCES = [
    // Our DEV and PROD environments in Micros Static
    /https:\/\/jira-frontend.*\..*\.atl-paas\.net\//,
    // For devs using `yarn start`
    /atlastunnel/,
    /localhost/,
    // Old S3 DEV environment
    /https:\/\/d398cwy4pffc4s\.cloudfront\.net\//,
    // Monolith staging|hello|ap|us environment
    /https:\/\/(d25s903c0x7s6j|dgjotco7y2aa|d9x1z07c483jl|d1vkjhvgh6tvn1).cloudfront.net\//,
    // Old S3 PROD environment
    /https:\/\/d2oj435jmh0qvz\.cloudfront\.net\//,
    // Automation S3 dev|staging|prod environment
    /https:\/\/(d3r49bgl1frqoy|d2v2wiwzx86dg|d283vu6e5qi87p).cloudfront.net\//
];
// https://docs.sentry.io/platforms/javascript/#removing-an-integration
// Remove Breadcrumbs integration from the Sentry default integrations
// we will re-add it manually with custom options
const $b4c94cfb888234a3$var$getFilteredIntegrations = (integrations)=>integrations.filter(({ name: name })=>name !== 'Breadcrumbs');
// This is used to mark which frames of the stacktrace are part of our app. They will be
// displayed in a different UI in Sentry.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b4c94cfb888234a3$var$rewriteFramesIteratee = (frame)=>{
    const curFrame = frame;
    if (curFrame.filename) curFrame.in_app = $b4c94cfb888234a3$var$FRONTEND_RESOURCES.some((resource)=>resource.test(frame.filename));
    return curFrame;
};
const $b4c94cfb888234a3$var$getSentryEnvironment = ()=>{
    if ((0, $7jTnu.fg)('jira-bypass-sentry-environment-filter')) return 'dev';
    return (0, $aYncF.getTenantContext_DEPRECATED_DO_NOT_USE)().environment ?? 'no-environment';
};
/**
 * Initializes Sentry for error logging with configurations tailored to the application's environment. It ensures error
 * reports are not duplicated if Sentry is already active, and sets up custom handling for errors and breadcrumbs,
 * enhancing error reporting with specific application context like bundler version, build variant, and user information.
 *
 * We import this code early in SSR static fallback (in entry-fs/), to catch errors in that code. However, it is
 * compiled in a different Parcel build, so typical bundler deduplication doesn't work and this script is run twice
 * (from different script tags), so we prevent double-init here using a global (only read+written here).
 *
 * IMPORTANT: fg calls in the modern SSR static fallback will always serve the default value, because we need to init
 * Sentry and other error tracking before bootstrap code that loads feature gate values. In code below here, please
 * clean up fg's quickly to avoid fallback values being served for an extended time.
 */ const $b4c94cfb888234a3$export$7da675e3dd1bd6b5 = ()=>{
    // @ts-expect-error global to communicate between multiple copies of this file. Should not be accessed elsewhere.
    if (globalThis.__JIRA_SENTRY_INSTALLED) return;
    // @ts-expect-error global to communicate between multiple copies of this file. Should not be accessed elsewhere.
    globalThis.__JIRA_SENTRY_INSTALLED = true;
    // Check for sentry already enabled to be defensive in case two fragments are loaded in the same page, we
    // don't want duplicated error reports
    const sentryClient = (0, $kINbm.getCurrentHub)().getClient();
    if (sentryClient && sentryClient.getOptions().enabled) return;
    let environment = $b4c94cfb888234a3$var$getSentryEnvironment();
    if (environment === 'prod') environment = 'production';
    const tags = {
        region: (0, $hWeHP.default)('ajs-region') || 'unknown'
    };
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.BUNDLER_VERSION) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const bundlerVersionTag = window.BUNDLER_VERSION.includes('@') ? window.BUNDLER_VERSION : `webpack@${window.BUNDLER_VERSION}`;
        tags.bundler = bundlerVersionTag;
    }
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.BUILD_VARIANT) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    tags.variant = window.BUILD_VARIANT;
    const config = {
        // This is evaluated against the *first* frame of the stack trace.
        // If it doesn't match, the error is not sent.
        allowUrls: $b4c94cfb888234a3$var$FRONTEND_RESOURCES,
        beforeSend: (0, $1G7kx.normaliseSentryEvent),
        // Sentry dom adds more attrs (like title, alt...) to breadcrumbs
        // but they might contain UGC/PII so we need to force strip them
        beforeBreadcrumb: (0, $j0R8U.normaliseSentryBreadcrumbs),
        dsn: (0, $lopBx.isFedRamp)() ? undefined : $b4c94cfb888234a3$var$SENTRY_URL,
        environment: environment,
        initialScope: {
            tags: tags,
            user: {
                id: (0, $aYncF.getTenantContext_DEPRECATED_DO_NOT_USE)().atlassianAccountId ?? undefined
            }
        },
        integrations: (integrations)=>[
                ...$b4c94cfb888234a3$var$getFilteredIntegrations(integrations),
                new (0, $kvkQX.Integrations).Breadcrumbs({
                    // only enable breadcrumbs for dom (UI clicks and inputs)
                    // include 'data-test-id', 'data-testid' in the breadcrumbs if they are found
                    dom: {
                        serializeAttribute: (0, $j0R8U.SERIALIZABLE_ATTRIBUTES),
                        maxStringLength: 300
                    },
                    fetch: false,
                    xhr: false,
                    console: false,
                    history: false,
                    sentry: false
                }),
                new (0, $gwUes.Dedupe)(),
                new (0, $gOI8F.ExtraErrorData)(),
                new (0, $jPpPM.RewriteFrames)({
                    iteratee: $b4c94cfb888234a3$var$rewriteFramesIteratee
                }),
                ...(0, $7jTnu.fg)('jira-capture-console-errors-in-sentry') ? [
                    new (0, $5fWuD.CaptureConsole)({
                        levels: [
                            'error'
                        ]
                    })
                ] : []
            ],
        maxBreadcrumbs: 15,
        release: globalThis.BUILD_KEY,
        dist: globalThis.BUILD_VARIANT || 'default'
    };
    (0, $38t4T.init)(config);
    // Returning this value to prevent tree shaking in SSR
    return 'sentry-init';
};

});
parcelRegister("38t4T", function(module, exports) {
$parcel$export(module.exports, "defaultIntegrations", () => $2488acb788027f49$export$5ef831fccfce35e5);
$parcel$export(module.exports, "init", () => $2488acb788027f49$export$2cd8252107eb640b);

var $3vr70 = parcelRequire("3vr70");
var $3idHc = parcelRequire("3idHc");
var $kINbm = parcelRequire("kINbm");
var $8WCUT = parcelRequire("8WCUT");
var $71uQM = parcelRequire("71uQM");
var $hTs4r = parcelRequire("hTs4r");
var $bQI3R = parcelRequire("bQI3R");

var $6g60L = parcelRequire("6g60L");
var $6lJZW = parcelRequire("6lJZW");
var $amn5g = parcelRequire("amn5g");
var $fsPAv = parcelRequire("fsPAv");

var $lt7A0 = parcelRequire("lt7A0");

var $bl0Xy = parcelRequire("bl0Xy");

var $3FkMI = parcelRequire("3FkMI");

var $fK4F3 = parcelRequire("fK4F3");

var $lo7wK = parcelRequire("lo7wK");

var $jFqF2 = parcelRequire("jFqF2");

var $11Thk = parcelRequire("11Thk");

var $fTNUR = parcelRequire("fTNUR");

var $jWbWT = parcelRequire("jWbWT");

var $7JgVP = parcelRequire("7JgVP");

var $3SNJd = parcelRequire("3SNJd");

var $1FjJN = parcelRequire("1FjJN");
/** @deprecated Use `getDefaultIntegrations(options)` instead. */ const $2488acb788027f49$export$5ef831fccfce35e5 = [
    (0, $hTs4r.inboundFiltersIntegration)(),
    (0, $3idHc.functionToStringIntegration)(),
    (0, $jWbWT.browserApiErrorsIntegration)(),
    (0, $fK4F3.breadcrumbsIntegration)(),
    (0, $jFqF2.globalHandlersIntegration)(),
    (0, $fTNUR.linkedErrorsIntegration)(),
    (0, $lo7wK.dedupeIntegration)(),
    (0, $11Thk.httpContextIntegration)()
];
/** Get the default integrations for the browser SDK. */ function $2488acb788027f49$export$5783b2920b1d62b9(_options) {
    // We return a copy of the defaultIntegrations here to avoid mutating this
    return [
        // eslint-disable-next-line deprecation/deprecation
        ...$2488acb788027f49$export$5ef831fccfce35e5
    ];
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $2488acb788027f49$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $2488acb788027f49$export$5783b2920b1d62b9();
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === 'string') options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $3FkMI.WINDOW).SENTRY_RELEASE && (0, $3FkMI.WINDOW).SENTRY_RELEASE.id) options.release = (0, $3FkMI.WINDOW).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $amn5g.stackParserFromStackParserOptions)(options.stackParser || (0, $7JgVP.defaultStackParser)),
        integrations: (0, $8WCUT.getIntegrationsToSetup)(options),
        transport: options.transport || ((0, $fsPAv.supportsFetch)() ? (0, $3SNJd.makeFetchTransport) : (0, $1FjJN.makeXHRTransport))
    };
    (0, $bQI3R.initAndBind)((0, $lt7A0.BrowserClient), clientOptions);
    if (options.autoSessionTracking) $2488acb788027f49$var$startSessionTracking();
}
const $2488acb788027f49$export$3a8fd680da42627b = (// eslint-disable-next-line deprecation/deprecation
options = {}, // eslint-disable-next-line deprecation/deprecation
hub = (0, $kINbm.getCurrentHub)())=>{
    // doesn't work without a document (React Native)
    if (!(0, $3FkMI.WINDOW).document) {
        (0, $bl0Xy.DEBUG_BUILD) && (0, $6lJZW.logger).error('Global document not defined in showReportDialog call');
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (0, $bl0Xy.DEBUG_BUILD) && (0, $6lJZW.logger).error('DSN not configured for showReportDialog call');
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
    const script = (0, $3FkMI.WINDOW).document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = (0, $71uQM.getReportDialogEndpoint)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === '__sentry_reportdialog_closed__') try {
                onClose();
            } finally{
                (0, $3FkMI.WINDOW).removeEventListener('message', reportDialogClosedMessageHandler);
            }
        };
        (0, $3FkMI.WINDOW).addEventListener('message', reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $3FkMI.WINDOW).document.head || (0, $3FkMI.WINDOW).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $bl0Xy.DEBUG_BUILD) && (0, $6lJZW.logger).error('Not injecting report dialog. No injection point found in HTML');
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $2488acb788027f49$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $2488acb788027f49$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2488acb788027f49$export$4997ffc0176396a6(fn) {
    return (0, $3FkMI.wrap)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $2488acb788027f49$var$startSessionTracking() {
    if (typeof (0, $3FkMI.WINDOW).document === 'undefined') {
        (0, $bl0Xy.DEBUG_BUILD) && (0, $6lJZW.logger).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $3vr70.startSession)({
        ignoreDuration: true
    });
    (0, $3vr70.captureSession)();
    // We want to create a session for every navigation as well
    (0, $6g60L.addHistoryInstrumentationHandler)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $3vr70.startSession)({
                ignoreDuration: true
            });
            (0, $3vr70.captureSession)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $2488acb788027f49$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $3vr70.getClient)();
    if (client) client.captureUserFeedback(feedback);
}

});
parcelRegister("3idHc", function(module, exports) {
$parcel$export(module.exports, "functionToStringIntegration", () => $265dad34a5fd4856$export$7918117e9202e4fb);
$parcel$export(module.exports, "FunctionToString", () => $265dad34a5fd4856$export$da4704525c20ae79);

var $3dFJR = parcelRequire("3dFJR");

var $3vr70 = parcelRequire("3vr70");

var $8WCUT = parcelRequire("8WCUT");
let $265dad34a5fd4856$var$originalFunctionToString;
const $265dad34a5fd4856$var$INTEGRATION_NAME = 'FunctionToString';
const $265dad34a5fd4856$var$SETUP_CLIENTS = new WeakMap();
const $265dad34a5fd4856$var$_functionToStringIntegration = ()=>{
    return {
        name: $265dad34a5fd4856$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $265dad34a5fd4856$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $3dFJR.getOriginalFunction)(this);
                    const context = $265dad34a5fd4856$var$SETUP_CLIENTS.has((0, $3vr70.getClient)()) && originalFunction !== undefined ? originalFunction : this;
                    return $265dad34a5fd4856$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $265dad34a5fd4856$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $265dad34a5fd4856$export$7918117e9202e4fb = (0, $8WCUT.defineIntegration)($265dad34a5fd4856$var$_functionToStringIntegration);
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $265dad34a5fd4856$export$da4704525c20ae79 = (0, $8WCUT.convertIntegrationFnToClass)($265dad34a5fd4856$var$INTEGRATION_NAME, $265dad34a5fd4856$export$7918117e9202e4fb);

});
parcelRegister("8WCUT", function(module, exports) {
$parcel$export(module.exports, "getIntegrationsToSetup", () => $6831ed87625f4209$export$68bc4c01ab8ae766);
$parcel$export(module.exports, "setupIntegrations", () => $6831ed87625f4209$export$51abed9797baa598);
$parcel$export(module.exports, "setupIntegration", () => $6831ed87625f4209$export$e7390a03b70a6f2f);
$parcel$export(module.exports, "afterSetupIntegrations", () => $6831ed87625f4209$export$35abcfd71227c6ca);
$parcel$export(module.exports, "convertIntegrationFnToClass", () => $6831ed87625f4209$export$afa219bf23651160);
$parcel$export(module.exports, "defineIntegration", () => $6831ed87625f4209$export$2323046b9414659f);

var $kgI9H = parcelRequire("kgI9H");
var $6lJZW = parcelRequire("6lJZW");

var $fZ2r3 = parcelRequire("fZ2r3");

var $1feQE = parcelRequire("1feQE");

var $3vr70 = parcelRequire("3vr70");

var $kINbm = parcelRequire("kINbm");
const $6831ed87625f4209$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $6831ed87625f4209$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $6831ed87625f4209$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') integrations = (0, $kgI9H.arrayify)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $6831ed87625f4209$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $6831ed87625f4209$var$findIndex(finalIntegrations, (integration)=>integration.name === 'Debug');
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $6831ed87625f4209$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $6831ed87625f4209$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $6831ed87625f4209$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $6831ed87625f4209$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($6831ed87625f4209$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce((0, $1feQE.addGlobalEventProcessor), (0, $kINbm.getCurrentHub));
        $6831ed87625f4209$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (client.on && typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (client.addEventProcessor && typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function $6831ed87625f4209$export$2d8f5188773bcddd(integration) {
    const client = (0, $3vr70.getClient)();
    if (!client || !client.addIntegration) {
        (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $6831ed87625f4209$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function $6831ed87625f4209$export$afa219bf23651160(name, fn) {
    return Object.assign(function ConvertedIntegration(...args) {
        return fn(...args);
    }, {
        id: name
    });
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $6831ed87625f4209$export$2323046b9414659f(fn) {
    return fn;
}

});


parcelRegister("71uQM", function(module, exports) {
$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", () => $51d08ea3e3dabc25$export$9964600bfe84e6a3);
$parcel$export(module.exports, "getReportDialogEndpoint", () => $51d08ea3e3dabc25$export$671c7ed8e40a7a57);

var $cLBIh = parcelRequire("cLBIh");
var $3dFJR = parcelRequire("3dFJR");
const $51d08ea3e3dabc25$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $51d08ea3e3dabc25$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $51d08ea3e3dabc25$var$_getIngestEndpoint(dsn) {
    return `${$51d08ea3e3dabc25$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $51d08ea3e3dabc25$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $3dFJR.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $51d08ea3e3dabc25$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $51d08ea3e3dabc25$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === 'string' ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === 'string' || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$51d08ea3e3dabc25$var$_getIngestEndpoint(dsn)}?${$51d08ea3e3dabc25$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $51d08ea3e3dabc25$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $cLBIh.makeDsn)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$51d08ea3e3dabc25$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $cLBIh.dsnToString)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}

});
parcelRegister("cLBIh", function(module, exports) {
$parcel$export(module.exports, "dsnToString", () => $94b720db496a5659$export$44d472fbb931a776);
$parcel$export(module.exports, "makeDsn", () => $94b720db496a5659$export$128827c3562ec0cb);

var $fUFQt = parcelRequire("fUFQt");

var $6lJZW = parcelRequire("6lJZW");
/** Regular expression used to parse a Dsn. */ const $94b720db496a5659$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $94b720db496a5659$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $94b720db496a5659$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $94b720db496a5659$export$b892860177f70a30(str) {
    const match = $94b720db496a5659$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $6lJZW.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host, port = '', lastPath] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $94b720db496a5659$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $94b720db496a5659$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $94b720db496a5659$var$validateDsn(dsn) {
    if (!(0, $fUFQt.DEBUG_BUILD)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $6lJZW.logger).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $6lJZW.logger).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$94b720db496a5659$var$isValidProtocol(protocol)) {
        (0, $6lJZW.logger).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $6lJZW.logger).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $94b720db496a5659$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $94b720db496a5659$export$b892860177f70a30(from) : $94b720db496a5659$var$dsnFromComponents(from);
    if (!components || !$94b720db496a5659$var$validateDsn(components)) return undefined;
    return components;
}

});


parcelRegister("hTs4r", function(module, exports) {
$parcel$export(module.exports, "inboundFiltersIntegration", () => $d06d58f921047467$export$cb3c5c2ceb9818ba);
$parcel$export(module.exports, "InboundFilters", () => $d06d58f921047467$export$2ffbb5359dcc6be4);

var $kgI9H = parcelRequire("kgI9H");
var $6lJZW = parcelRequire("6lJZW");
var $4RzNY = parcelRequire("4RzNY");

var $fZ2r3 = parcelRequire("fZ2r3");

var $8WCUT = parcelRequire("8WCUT");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $d06d58f921047467$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/
];
const $d06d58f921047467$var$DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ const $d06d58f921047467$var$INTEGRATION_NAME = 'InboundFilters';
const $d06d58f921047467$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $d06d58f921047467$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $d06d58f921047467$var$_mergeOptions(options, clientOptions);
            return $d06d58f921047467$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $d06d58f921047467$export$cb3c5c2ceb9818ba = (0, $8WCUT.defineIntegration)($d06d58f921047467$var$_inboundFiltersIntegration);
/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $d06d58f921047467$export$2ffbb5359dcc6be4 = (0, $8WCUT.convertIntegrationFnToClass)($d06d58f921047467$var$INTEGRATION_NAME, $d06d58f921047467$export$cb3c5c2ceb9818ba);
function $d06d58f921047467$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $d06d58f921047467$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || [],
            ...internalOptions.disableTransactionDefaults ? [] : $d06d58f921047467$var$DEFAULT_IGNORE_TRANSACTIONS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $d06d58f921047467$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $d06d58f921047467$var$_isSentryError(event)) {
        (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $kgI9H.getEventDescription)(event)}`);
        return true;
    }
    if ($d06d58f921047467$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $kgI9H.getEventDescription)(event)}`);
        return true;
    }
    if ($d06d58f921047467$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $kgI9H.getEventDescription)(event)}`);
        return true;
    }
    if ($d06d58f921047467$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $kgI9H.getEventDescription)(event)}.\nUrl: ${$d06d58f921047467$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$d06d58f921047467$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $kgI9H.getEventDescription)(event)}.\nUrl: ${$d06d58f921047467$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $d06d58f921047467$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $d06d58f921047467$var$_getPossibleEventMessages(event).some((message)=>(0, $4RzNY.stringMatchesSomePattern)(message, ignoreErrors));
}
function $d06d58f921047467$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== 'transaction' || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $4RzNY.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function $d06d58f921047467$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $d06d58f921047467$var$_getEventFilterUrl(event);
    return !url ? false : (0, $4RzNY.stringMatchesSomePattern)(url, denyUrls);
}
function $d06d58f921047467$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $d06d58f921047467$var$_getEventFilterUrl(event);
    return !url ? true : (0, $4RzNY.stringMatchesSomePattern)(url, allowUrls);
}
function $d06d58f921047467$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    if ((0, $fZ2r3.DEBUG_BUILD) && possibleMessages.length === 0) (0, $6lJZW.logger).error(`Could not extract message for event ${(0, $kgI9H.getEventDescription)(event)}`);
    return possibleMessages;
}
function $d06d58f921047467$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $d06d58f921047467$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $d06d58f921047467$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $d06d58f921047467$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).error(`Cannot extract url for event ${(0, $kgI9H.getEventDescription)(event)}`);
        return null;
    }
}

});

parcelRegister("bQI3R", function(module, exports) {
$parcel$export(module.exports, "initAndBind", () => $8a06baaaa3ce2e6f$export$5333c3f1c58d9bc1);

var $6lJZW = parcelRequire("6lJZW");

var $fZ2r3 = parcelRequire("fZ2r3");

var $3vr70 = parcelRequire("3vr70");

var $kINbm = parcelRequire("kINbm");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $8a06baaaa3ce2e6f$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $fZ2r3.DEBUG_BUILD) (0, $6lJZW.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $6lJZW.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $3vr70.getCurrentScope)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $8a06baaaa3ce2e6f$export$ecb76f41d43c0e43(client);
    $8a06baaaa3ce2e6f$var$initializeClient(client);
}
/**
 * Make the given client the current client.
 */ function $8a06baaaa3ce2e6f$export$ecb76f41d43c0e43(client) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $kINbm.getCurrentHub)();
    // eslint-disable-next-line deprecation/deprecation
    const top = hub.getStackTop();
    top.client = client;
    top.scope.setClient(client);
}
/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */ function $8a06baaaa3ce2e6f$var$initializeClient(client) {
    if (client.init) client.init();
    else if (client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
    client.setupIntegrations();
}

});

parcelRegister("6g60L", function(module, exports) {
$parcel$export(module.exports, "addHistoryInstrumentationHandler", () => $48e8e66873fd2079$export$3f18c56c58114e75);

var $3dFJR = parcelRequire("3dFJR");



var $aFn2S = parcelRequire("aFn2S");

var $fwWJJ = parcelRequire("fwWJJ");

var $6i9I9 = parcelRequire("6i9I9");
const $48e8e66873fd2079$var$WINDOW = (0, $aFn2S.GLOBAL_OBJ);
let $48e8e66873fd2079$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $48e8e66873fd2079$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $6i9I9.addHandler)(type, handler);
    (0, $6i9I9.maybeInstrument)(type, $48e8e66873fd2079$var$instrumentHistory);
}
function $48e8e66873fd2079$var$instrumentHistory() {
    if (!(0, $fwWJJ.supportsHistory)()) return;
    const oldOnPopState = $48e8e66873fd2079$var$WINDOW.onpopstate;
    $48e8e66873fd2079$var$WINDOW.onpopstate = function(...args) {
        const to = $48e8e66873fd2079$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $48e8e66873fd2079$var$lastHref;
        $48e8e66873fd2079$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $6i9I9.triggerHandlers)('history', handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $48e8e66873fd2079$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $48e8e66873fd2079$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $6i9I9.triggerHandlers)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $3dFJR.fill)($48e8e66873fd2079$var$WINDOW.history, 'pushState', historyReplacementFunction);
    (0, $3dFJR.fill)($48e8e66873fd2079$var$WINDOW.history, 'replaceState', historyReplacementFunction);
}

});
parcelRegister("fwWJJ", function(module, exports) {
$parcel$export(module.exports, "supportsHistory", () => $b4e7680ed5576b3d$export$67fc34576016d6ec);

var $aFn2S = parcelRequire("aFn2S");
// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $b4e7680ed5576b3d$var$WINDOW = (0, $aFn2S.getGlobalObject)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $b4e7680ed5576b3d$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chromeVar = $b4e7680ed5576b3d$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = 'history' in $b4e7680ed5576b3d$var$WINDOW && !!$b4e7680ed5576b3d$var$WINDOW.history.pushState && !!$b4e7680ed5576b3d$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});

parcelRegister("6i9I9", function(module, exports) {
$parcel$export(module.exports, "addHandler", () => $494bf4f3e7409cef$export$a4e09611e30da72e);
$parcel$export(module.exports, "maybeInstrument", () => $494bf4f3e7409cef$export$e18d6c5462c01368);
$parcel$export(module.exports, "triggerHandlers", () => $494bf4f3e7409cef$export$b18c893e424d3127);

var $fUFQt = parcelRequire("fUFQt");

var $6lJZW = parcelRequire("6lJZW");

var $amn5g = parcelRequire("amn5g");
// We keep the handlers globally
const $494bf4f3e7409cef$var$handlers = {};
const $494bf4f3e7409cef$var$instrumented = {};
/** Add a handler function. */ function $494bf4f3e7409cef$export$a4e09611e30da72e(type, handler) {
    $494bf4f3e7409cef$var$handlers[type] = $494bf4f3e7409cef$var$handlers[type] || [];
    $494bf4f3e7409cef$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $494bf4f3e7409cef$export$b17eab759a1cb5fe() {
    Object.keys($494bf4f3e7409cef$var$handlers).forEach((key)=>{
        $494bf4f3e7409cef$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $494bf4f3e7409cef$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$494bf4f3e7409cef$var$instrumented[type]) {
        instrumentFn();
        $494bf4f3e7409cef$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $494bf4f3e7409cef$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $494bf4f3e7409cef$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $fUFQt.DEBUG_BUILD) && (0, $6lJZW.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $amn5g.getFunctionName)(handler)}\nError:`, e);
    }
}

});


parcelRegister("fsPAv", function(module, exports) {
$parcel$export(module.exports, "supportsFetch", () => $b4217ccfa1db06c9$export$edf3cb81fd7d2a3e);
$parcel$export(module.exports, "isNativeFetch", () => $b4217ccfa1db06c9$export$18cf36ed71d733e7);
$parcel$export(module.exports, "supportsNativeFetch", () => $b4217ccfa1db06c9$export$c82d238e23c40b21);

var $fUFQt = parcelRequire("fUFQt");

var $6lJZW = parcelRequire("6lJZW");

var $aFn2S = parcelRequire("aFn2S");
// eslint-disable-next-line deprecation/deprecation
const $b4217ccfa1db06c9$var$WINDOW = (0, $aFn2S.getGlobalObject)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $b4217ccfa1db06c9$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $b4217ccfa1db06c9$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $b4217ccfa1db06c9$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $b4217ccfa1db06c9$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in $b4217ccfa1db06c9$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $b4217ccfa1db06c9$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $b4217ccfa1db06c9$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$b4217ccfa1db06c9$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($b4217ccfa1db06c9$export$18cf36ed71d733e7($b4217ccfa1db06c9$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $b4217ccfa1db06c9$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $b4217ccfa1db06c9$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $fUFQt.DEBUG_BUILD) && (0, $6lJZW.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $b4217ccfa1db06c9$export$531055a6c684a70a() {
    return 'ReportingObserver' in $b4217ccfa1db06c9$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $b4217ccfa1db06c9$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$b4217ccfa1db06c9$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("lt7A0", function(module, exports) {
$parcel$export(module.exports, "BrowserClient", () => $fa122f98ec465c81$export$1df9218a526d318d);

var $2XwhW = parcelRequire("2XwhW");
var $1NMDh = parcelRequire("1NMDh");

var $fF6rH = parcelRequire("fF6rH");
var $cLBIh = parcelRequire("cLBIh");
var $bUvh9 = parcelRequire("bUvh9");
var $6lJZW = parcelRequire("6lJZW");

var $bl0Xy = parcelRequire("bl0Xy");

var $iRG6Q = parcelRequire("iRG6Q");

var $3FkMI = parcelRequire("3FkMI");

var $6377k = parcelRequire("6377k");
/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $fa122f98ec465c81$export$1df9218a526d318d extends (0, $1NMDh.BaseClient) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $3FkMI.WINDOW).SENTRY_SDK_SOURCE || (0, $bUvh9.getSDKSource)();
        (0, $2XwhW.applySdkMetadata)(options, 'browser', [
            'browser'
        ], sdkSource);
        super(options);
        if (options.sendClientReports && (0, $3FkMI.WINDOW).document) (0, $3FkMI.WINDOW).document.addEventListener('visibilitychange', ()=>{
            if ((0, $3FkMI.WINDOW).document.visibilityState === 'hidden') this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $iRG6Q.eventFromException)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = 'info', hint) {
        return (0, $iRG6Q.eventFromMessage)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $bl0Xy.DEBUG_BUILD) && (0, $6lJZW.logger).warn('SDK not enabled, will not capture user feedback.');
            return;
        }
        const envelope = (0, $6377k.createUserFeedbackEnvelope)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $bl0Xy.DEBUG_BUILD) && (0, $6lJZW.logger).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $bl0Xy.DEBUG_BUILD) && (0, $6lJZW.logger).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $bl0Xy.DEBUG_BUILD) && (0, $6lJZW.logger).log('Sending outcomes:', outcomes);
        const envelope = (0, $fF6rH.createClientReportEnvelope)(outcomes, this._options.tunnel && (0, $cLBIh.dsnToString)(this._dsn));
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
}

});
parcelRegister("2XwhW", function(module, exports) {
$parcel$export(module.exports, "applySdkMetadata", () => $227a233ba412a14a$export$b9f95b027256052c);

var $7IBdF = parcelRequire("7IBdF");
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $227a233ba412a14a$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $7IBdF.SDK_VERSION)
            })),
        version: (0, $7IBdF.SDK_VERSION)
    };
    options._metadata = metadata;
}

});

parcelRegister("1NMDh", function(module, exports) {
$parcel$export(module.exports, "BaseClient", () => $15001778090acaba$export$4f22f74eddb7716a);

var $9CzI9 = parcelRequire("9CzI9");
var $kgI9H = parcelRequire("kgI9H");
var $2Jaqc = parcelRequire("2Jaqc");
var $6lJZW = parcelRequire("6lJZW");
var $cLBIh = parcelRequire("cLBIh");
var $dtmqq = parcelRequire("dtmqq");
var $lxc2k = parcelRequire("lxc2k");

var $71uQM = parcelRequire("71uQM");

var $fZ2r3 = parcelRequire("fZ2r3");

var $i0zSS = parcelRequire("i0zSS");

var $3vr70 = parcelRequire("3vr70");

var $kINbm = parcelRequire("kINbm");

var $8WCUT = parcelRequire("8WCUT");

var $9Ji56 = parcelRequire("9Ji56");

var $bHHGA = parcelRequire("bHHGA");

var $13IdK = parcelRequire("13IdK");

var $2biSp = parcelRequire("2biSp");
const $15001778090acaba$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $15001778090acaba$export$4f22f74eddb7716a {
    /**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   */ /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Indicates whether this client's integrations have been set up. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $cLBIh.makeDsn)(options.dsn);
        else (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $71uQM.getEnvelopeEndpointWithUrlEncodedAuth)(this._dsn, options);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $kgI9H.checkOrSetAlreadyCaught)(exception)) {
            (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).log($15001778090acaba$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const eventMessage = (0, $2Jaqc.isParameterizedString)(message) ? message : String(message);
        const promisedEvent = (0, $2Jaqc.isPrimitive)(message) ? this.eventFromMessage(eventMessage, level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $kgI9H.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).log($15001778090acaba$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hint, capturedSpanScope || scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === 'string')) (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).warn('Discarded session because of missing or non-string release');
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $bHHGA.updateSession)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            if (this.metricsAggregator) this.metricsAggregator.flush();
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $dtmqq.resolvedSyncPromise)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            if (this.metricsAggregator) this.metricsAggregator.close();
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */ setupIntegrations(forceInitialize) {
        if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) this._setupIntegrations();
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled()) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegrationById(integrationId) {
        return this.getIntegrationByName(integrationId);
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $8WCUT.setupIntegration)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $8WCUT.afterSetupIntegrations)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $i0zSS.createEventEnvelope)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $9CzI9.addItemToEnvelope)(env, (0, $9CzI9.createAttachmentEnvelopeItem)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
        const promise = this._sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $i0zSS.createSessionEnvelope)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, eventOrCount) {
        if (this._options.sendClientReports) {
            // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
            // If event is passed as third argument, we assume this is a count of 1
            const count = typeof eventOrCount === 'number' ? eventOrCount : 1;
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /**
   * @inheritDoc
   */ captureAggregateMetrics(metricBucketItems) {
        (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).log(`Flushing aggregated metrics, number of metrics: ${metricBucketItems.length}`);
        const metricsEnvelope = (0, $9Ji56.createMetricEnvelope)(metricBucketItems, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(metricsEnvelope);
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-expect-error We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $8WCUT.setupIntegrations)(this, integrations);
        (0, $8WCUT.afterSetupIntegrations)(this, integrations);
        // TODO v8: We don't need this flag anymore
        this._integrationsInitialized = true;
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $bHHGA.updateSession)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $dtmqq.SyncPromise)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope, isolationScope = (0, $kINbm.getIsolationScope)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        return (0, $2biSp.prepareEvent)(options, event, hint, scope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            const propagationContext = {
                ...isolationScope.getPropagationContext(),
                ...scope ? scope.getPropagationContext() : undefined
            };
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: {
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    },
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $13IdK.getDynamicSamplingContextFromClient)(trace_id, this, scope);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $fZ2r3.DEBUG_BUILD) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === 'log') (0, $6lJZW.logger).log(sentryError.message);
                else (0, $6lJZW.logger).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $15001778090acaba$var$isTransactionEvent(event);
        const isError = $15001778090acaba$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            this.recordDroppedEvent('sample_rate', 'error', event);
            return (0, $dtmqq.rejectedSyncPromise)(new (0, $lxc2k.SentryError)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, 'log'));
        }
        const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, scope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory, event);
                throw new (0, $lxc2k.SentryError)('An event processor returned `null`, will not send event.', 'log');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $15001778090acaba$var$processBeforeSend(options, prepared, hint);
            return $15001778090acaba$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory, event);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw new (0, $lxc2k.SentryError)(`${beforeSendLabel} returned \`null\`, will not send event.`, 'log');
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $lxc2k.SentryError)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $lxc2k.SentryError)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).error('Error while sending event:', reason);
        });
        else (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).error('Transport disabled');
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $15001778090acaba$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $2Jaqc.isThenable)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $2Jaqc.isPlainObject)(event) && event !== null) throw new (0, $lxc2k.SentryError)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $lxc2k.SentryError)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $2Jaqc.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw new (0, $lxc2k.SentryError)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $15001778090acaba$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction } = options;
    if ($15001778090acaba$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($15001778090acaba$var$isTransactionEvent(event) && beforeSendTransaction) {
        if (event.spans) {
            // We store the # of spans before processing in SDK metadata,
            // so we can compare it afterwards to determine how many spans were dropped
            const spanCountBefore = event.spans.length;
            event.sdkProcessingMetadata = {
                ...event.sdkProcessingMetadata,
                spanCountBeforeProcessing: spanCountBefore
            };
        }
        return beforeSendTransaction(event, hint);
    }
    return event;
}
function $15001778090acaba$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $15001778090acaba$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */ function $15001778090acaba$export$9aac0b9f77928fbf(callback) {
    const client = (0, $3vr70.getClient)();
    if (!client || !client.addEventProcessor) return;
    client.addEventProcessor(callback);
}

});
parcelRegister("9CzI9", function(module, exports) {
$parcel$export(module.exports, "createEnvelope", () => $70135d2a181505db$export$f93f7f385160c44e);
$parcel$export(module.exports, "addItemToEnvelope", () => $70135d2a181505db$export$d650323442802f6f);
$parcel$export(module.exports, "forEachEnvelopeItem", () => $70135d2a181505db$export$c56c55acf0136fd3);
$parcel$export(module.exports, "serializeEnvelope", () => $70135d2a181505db$export$32f9b428425aac85);
$parcel$export(module.exports, "createAttachmentEnvelopeItem", () => $70135d2a181505db$export$d8fc80952cc31fa4);
$parcel$export(module.exports, "envelopeItemTypeToDataCategory", () => $70135d2a181505db$export$b11169581eeaf237);
$parcel$export(module.exports, "getSdkMetadataForEnvelopeHeader", () => $70135d2a181505db$export$d369f3b2758f6743);
$parcel$export(module.exports, "createEventEnvelopeHeaders", () => $70135d2a181505db$export$92b6093782fe661b);

var $cLBIh = parcelRequire("cLBIh");

var $9ZmTE = parcelRequire("9ZmTE");

var $3dFJR = parcelRequire("3dFJR");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $70135d2a181505db$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $70135d2a181505db$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $70135d2a181505db$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $70135d2a181505db$export$604a45d95a155e2b(envelope, types) {
    return $70135d2a181505db$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $70135d2a181505db$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $70135d2a181505db$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $70135d2a181505db$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === 'string' ? $70135d2a181505db$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $9ZmTE.normalize)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $70135d2a181505db$var$concatBuffers(parts);
}
function $70135d2a181505db$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $70135d2a181505db$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === 'string' ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $70135d2a181505db$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === 'string' ? $70135d2a181505db$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $3dFJR.dropUndefinedKeys)({
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $70135d2a181505db$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    statsd: 'metric_bucket'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $70135d2a181505db$export$b11169581eeaf237(type) {
    return $70135d2a181505db$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $70135d2a181505db$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $70135d2a181505db$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $cLBIh.dsnToString)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $3dFJR.dropUndefinedKeys)({
                ...dynamicSamplingContext
            })
        }
    };
}

});

parcelRegister("lxc2k", function(module, exports) {
$parcel$export(module.exports, "SentryError", () => $fad604414083c48c$export$5949942ba2a7c0e2);
/** An error emitted by Sentry SDKs and related utilities. */ class $fad604414083c48c$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = 'warn'){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}

});

parcelRegister("i0zSS", function(module, exports) {
$parcel$export(module.exports, "createSessionEnvelope", () => $d1c40fee9e218d65$export$124b03c077baa2f3);
$parcel$export(module.exports, "createEventEnvelope", () => $d1c40fee9e218d65$export$c31057337a18010f);

var $9CzI9 = parcelRequire("9CzI9");
var $cLBIh = parcelRequire("cLBIh");
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $d1c40fee9e218d65$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $d1c40fee9e218d65$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $9CzI9.getSdkMetadataForEnvelopeHeader)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $cLBIh.dsnToString)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $9CzI9.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $d1c40fee9e218d65$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $9CzI9.getSdkMetadataForEnvelopeHeader)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $d1c40fee9e218d65$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $9CzI9.createEventEnvelopeHeaders)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $9CzI9.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}

});

parcelRegister("9Ji56", function(module, exports) {
$parcel$export(module.exports, "createMetricEnvelope", () => $71565792f3185651$export$f23eb96e33154901);

var $9CzI9 = parcelRequire("9CzI9");
var $cLBIh = parcelRequire("cLBIh");

var $8bqGQ = parcelRequire("8bqGQ");
/**
 * Create envelope from a metric aggregate.
 */ function $71565792f3185651$export$f23eb96e33154901(metricBucketItems, dsn, metadata, tunnel) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata && metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && dsn) headers.dsn = (0, $cLBIh.dsnToString)(dsn);
    const item = $71565792f3185651$var$createMetricEnvelopeItem(metricBucketItems);
    return (0, $9CzI9.createEnvelope)(headers, [
        item
    ]);
}
function $71565792f3185651$var$createMetricEnvelopeItem(metricBucketItems) {
    const payload = (0, $8bqGQ.serializeMetricBuckets)(metricBucketItems);
    const metricHeaders = {
        type: 'statsd',
        length: payload.length
    };
    return [
        metricHeaders,
        payload
    ];
}

});
parcelRegister("8bqGQ", function(module, exports) {
$parcel$export(module.exports, "serializeMetricBuckets", () => $5f540de4b57d4567$export$66decd709db01dc8);

var $3dFJR = parcelRequire("3dFJR");
/**
 * Generate bucket key from metric properties.
 */ function $5f540de4b57d4567$export$b8bd8c4dffa5aa2d(metricType, name, unit, tags) {
    const stringifiedTags = Object.entries((0, $3dFJR.dropUndefinedKeys)(tags)).sort((a, b)=>a[0].localeCompare(b[0]));
    return `${metricType}${name}${unit}${stringifiedTags}`;
}
/* eslint-disable no-bitwise */ /**
 * Simple hash function for strings.
 */ function $5f540de4b57d4567$export$b211ce59c0ea1cfb(s) {
    let rv = 0;
    for(let i = 0; i < s.length; i++){
        const c = s.charCodeAt(i);
        rv = (rv << 5) - rv + c;
        rv &= rv;
    }
    return rv >>> 0;
}
/* eslint-enable no-bitwise */ /**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */ function $5f540de4b57d4567$export$66decd709db01dc8(metricBucketItems) {
    let out = '';
    for (const item of metricBucketItems){
        const tagEntries = Object.entries(item.tags);
        const maybeTags = tagEntries.length > 0 ? `|#${tagEntries.map(([key, value])=>`${key}:${value}`).join(',')}` : '';
        out += `${item.name}@${item.unit}:${item.metric}|${item.metricType}${maybeTags}|T${item.timestamp}\n`;
    }
    return out;
}
/** Sanitizes units */ function $5f540de4b57d4567$export$2d8c9911396bbf5f(unit) {
    return unit.replace(/[^\w]+/gi, '_');
}
/** Sanitizes metric keys */ function $5f540de4b57d4567$export$d3b3167f2ebbcecc(key) {
    return key.replace(/[^\w\-.]+/gi, '_');
}
function $5f540de4b57d4567$var$sanitizeTagKey(key) {
    return key.replace(/[^\w\-./]+/gi, '');
}
const $5f540de4b57d4567$var$tagValueReplacements = [
    [
        '\n',
        '\\n'
    ],
    [
        '\r',
        '\\r'
    ],
    [
        '\t',
        '\\t'
    ],
    [
        '\\',
        '\\\\'
    ],
    [
        '|',
        '\\u{7c}'
    ],
    [
        ',',
        '\\u{2c}'
    ]
];
function $5f540de4b57d4567$var$getCharOrReplacement(input) {
    for (const [search, replacement] of $5f540de4b57d4567$var$tagValueReplacements){
        if (input === search) return replacement;
    }
    return input;
}
function $5f540de4b57d4567$var$sanitizeTagValue(value) {
    return [
        ...value
    ].reduce((acc, char)=>acc + $5f540de4b57d4567$var$getCharOrReplacement(char), '');
}
/**
 * Sanitizes tags.
 */ function $5f540de4b57d4567$export$ae49af12dbdf2477(unsanitizedTags) {
    const tags = {};
    for(const key in unsanitizedTags)if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
        const sanitizedKey = $5f540de4b57d4567$var$sanitizeTagKey(key);
        tags[sanitizedKey] = $5f540de4b57d4567$var$sanitizeTagValue(String(unsanitizedTags[key]));
    }
    return tags;
}

});



parcelRegister("fF6rH", function(module, exports) {
$parcel$export(module.exports, "createClientReportEnvelope", () => $b66faf559e07f01b$export$f3b9ed77c03eeb00);

var $9CzI9 = parcelRequire("9CzI9");

var $gv1sw = parcelRequire("gv1sw");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $b66faf559e07f01b$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $gv1sw.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $9CzI9.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});

parcelRegister("bUvh9", function(module, exports) {
$parcel$export(module.exports, "getSDKSource", () => $8abd2f5c9e8bf9fd$export$8ad33f488b1ab046);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $8abd2f5c9e8bf9fd$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $8abd2f5c9e8bf9fd$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}

});

parcelRegister("bl0Xy", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", () => $0221543b93b3d1f1$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $0221543b93b3d1f1$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("iRG6Q", function(module, exports) {
$parcel$export(module.exports, "exceptionFromError", () => $dbbdd74e32b77fa2$export$a6c2d27607295951);
$parcel$export(module.exports, "eventFromException", () => $dbbdd74e32b77fa2$export$ea3ec7e569b823fc);
$parcel$export(module.exports, "eventFromUnknownInput", () => $dbbdd74e32b77fa2$export$9dd56ed1ef0c3420);
$parcel$export(module.exports, "eventFromMessage", () => $dbbdd74e32b77fa2$export$5425b53185d13d6c);

var $3vr70 = parcelRequire("3vr70");

var $kgI9H = parcelRequire("kgI9H");
var $3dFJR = parcelRequire("3dFJR");
var $2Jaqc = parcelRequire("2Jaqc");
var $9ZmTE = parcelRequire("9ZmTE");
var $dtmqq = parcelRequire("dtmqq");
/**
 * This function creates an exception from a JavaScript Error
 */ function $dbbdd74e32b77fa2$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $dbbdd74e32b77fa2$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $dbbdd74e32b77fa2$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
/**
 * @hidden
 */ function $dbbdd74e32b77fa2$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $3vr70.getClient)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $2Jaqc.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $dbbdd74e32b77fa2$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $9ZmTE.normalizeToSize)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $dbbdd74e32b77fa2$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $dbbdd74e32b77fa2$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $dbbdd74e32b77fa2$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $dbbdd74e32b77fa2$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const popSize = $dbbdd74e32b77fa2$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $dbbdd74e32b77fa2$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $dbbdd74e32b77fa2$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($dbbdd74e32b77fa2$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $dbbdd74e32b77fa2$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $dbbdd74e32b77fa2$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $dbbdd74e32b77fa2$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $kgI9H.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $dtmqq.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $dbbdd74e32b77fa2$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = 'info', hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $dbbdd74e32b77fa2$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $dtmqq.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $dbbdd74e32b77fa2$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $2Jaqc.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $dbbdd74e32b77fa2$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $2Jaqc.isDOMError)(exception) || (0, $2Jaqc.isDOMException)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $dbbdd74e32b77fa2$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $2Jaqc.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $dbbdd74e32b77fa2$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $kgI9H.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $2Jaqc.isError)(exception)) // we have a real Error object, do nothing
    return $dbbdd74e32b77fa2$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $2Jaqc.isPlainObject)(exception) || (0, $2Jaqc.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $dbbdd74e32b77fa2$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $kgI9H.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $dbbdd74e32b77fa2$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $kgI9H.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $kgI9H.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $dbbdd74e32b77fa2$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $dbbdd74e32b77fa2$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $2Jaqc.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $dbbdd74e32b77fa2$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $3dFJR.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $2Jaqc.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $2Jaqc.isEvent)(exception)) {
        const className = $dbbdd74e32b77fa2$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $dbbdd74e32b77fa2$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}

});

parcelRegister("3FkMI", function(module, exports) {
$parcel$export(module.exports, "WINDOW", () => $2ab552d7bbe7b9d8$export$56d8a8a25bd48b81);
$parcel$export(module.exports, "shouldIgnoreOnError", () => $2ab552d7bbe7b9d8$export$b79738ab10c590b2);
$parcel$export(module.exports, "wrap", () => $2ab552d7bbe7b9d8$export$4997ffc0176396a6);


var $3vr70 = parcelRequire("3vr70");

var $kgI9H = parcelRequire("kgI9H");
var $3dFJR = parcelRequire("3dFJR");
var $aFn2S = parcelRequire("aFn2S");
const $2ab552d7bbe7b9d8$export$56d8a8a25bd48b81 = (0, $aFn2S.GLOBAL_OBJ);
let $2ab552d7bbe7b9d8$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $2ab552d7bbe7b9d8$export$b79738ab10c590b2() {
    return $2ab552d7bbe7b9d8$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $2ab552d7bbe7b9d8$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $2ab552d7bbe7b9d8$var$ignoreOnError++;
    setTimeout(()=>{
        $2ab552d7bbe7b9d8$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $2ab552d7bbe7b9d8$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $3dFJR.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$2ab552d7bbe7b9d8$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $2ab552d7bbe7b9d8$export$1265a142ff5ba165();
            (0, $3vr70.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $kgI9H.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $kgI9H.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $3vr70.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $3dFJR.markFunctionWrapped)(sentryWrapped, fn);
    (0, $3dFJR.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}

});

parcelRegister("6377k", function(module, exports) {
$parcel$export(module.exports, "createUserFeedbackEnvelope", () => $46788b35bdcb3014$export$24a4dfcb686ee5bf);

var $9CzI9 = parcelRequire("9CzI9");
var $cLBIh = parcelRequire("cLBIh");
/**
 * Creates an envelope from a user feedback.
 */ function $46788b35bdcb3014$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $cLBIh.dsnToString)(dsn)
        }
    };
    const item = $46788b35bdcb3014$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $9CzI9.createEnvelope)(headers, [
        item
    ]);
}
function $46788b35bdcb3014$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: 'user_report'
    };
    return [
        feedbackHeaders,
        feedback
    ];
}

});


parcelRegister("fK4F3", function(module, exports) {
$parcel$export(module.exports, "breadcrumbsIntegration", () => $b75ec480d5b3e975$export$c079d904b326663a);
$parcel$export(module.exports, "Breadcrumbs", () => $b75ec480d5b3e975$export$2dc68d50d56fbbd);

var $3vr70 = parcelRequire("3vr70");
var $8WCUT = parcelRequire("8WCUT");

var $aNrXU = parcelRequire("aNrXU");
var $7pl6s = parcelRequire("7pl6s");
var $hpPel = parcelRequire("hpPel");
var $6g60L = parcelRequire("6g60L");
var $1eUoF = parcelRequire("1eUoF");
var $1Pi8W = parcelRequire("1Pi8W");
var $kgI9H = parcelRequire("kgI9H");
var $6lJZW = parcelRequire("6lJZW");
var $29V09 = parcelRequire("29V09");
var $4RzNY = parcelRequire("4RzNY");
var $7VcJa = parcelRequire("7VcJa");

var $bl0Xy = parcelRequire("bl0Xy");

var $3FkMI = parcelRequire("3FkMI");
/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $b75ec480d5b3e975$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $b75ec480d5b3e975$var$INTEGRATION_NAME = 'Breadcrumbs';
const $b75ec480d5b3e975$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $b75ec480d5b3e975$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (_options.console) (0, $7pl6s.addConsoleInstrumentationHandler)($b75ec480d5b3e975$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $aNrXU.addClickKeypressInstrumentationHandler)($b75ec480d5b3e975$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $1eUoF.addXhrInstrumentationHandler)($b75ec480d5b3e975$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $hpPel.addFetchInstrumentationHandler)($b75ec480d5b3e975$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $6g60L.addHistoryInstrumentationHandler)($b75ec480d5b3e975$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry && client.on) client.on('beforeSendEvent', $b75ec480d5b3e975$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $b75ec480d5b3e975$export$c079d904b326663a = (0, $8WCUT.defineIntegration)($b75ec480d5b3e975$var$_breadcrumbsIntegration);
/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $b75ec480d5b3e975$export$2dc68d50d56fbbd = (0, $8WCUT.convertIntegrationFnToClass)($b75ec480d5b3e975$var$INTEGRATION_NAME, $b75ec480d5b3e975$export$c079d904b326663a);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $b75ec480d5b3e975$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $3vr70.getClient)() !== client) return;
        (0, $3vr70.addBreadcrumb)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $kgI9H.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $b75ec480d5b3e975$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $3vr70.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $b75ec480d5b3e975$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $bl0Xy.DEBUG_BUILD) && (0, $6lJZW.logger).warn(`\`dom.maxStringLength\` cannot exceed ${$b75ec480d5b3e975$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$b75ec480d5b3e975$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $b75ec480d5b3e975$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $b75ec480d5b3e975$var$_isEvent(event) ? event.target : event;
            target = (0, $1Pi8W.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $1Pi8W.getComponentName)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $3vr70.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $b75ec480d5b3e975$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $3vr70.getClient)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $7VcJa.severityLevelFromString)(handlerData.level),
            message: (0, $4RzNY.safeJoin)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $4RzNY.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $3vr70.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $b75ec480d5b3e975$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $3vr70.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $1eUoF.SENTRY_XHR_DATA_KEY];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $3vr70.addBreadcrumb)({
            category: 'xhr',
            data: data,
            type: 'http'
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $b75ec480d5b3e975$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $3vr70.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $3vr70.addBreadcrumb)({
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $3vr70.addBreadcrumb)({
                category: 'fetch',
                data: data,
                type: 'http'
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $b75ec480d5b3e975$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $3vr70.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $29V09.parseUrl)((0, $3FkMI.WINDOW).location.href);
        let parsedFrom = from ? (0, $29V09.parseUrl)(from) : undefined;
        const parsedTo = (0, $29V09.parseUrl)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $3vr70.addBreadcrumb)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $b75ec480d5b3e975$var$_isEvent(event) {
    return !!event && !!event.target;
}

});
parcelRegister("aNrXU", function(module, exports) {
$parcel$export(module.exports, "addClickKeypressInstrumentationHandler", () => $7dc42c5339563501$export$5aeffd3db2cf9df7);

var $kgI9H = parcelRequire("kgI9H");

var $3dFJR = parcelRequire("3dFJR");

var $aFn2S = parcelRequire("aFn2S");

var $6i9I9 = parcelRequire("6i9I9");
const $7dc42c5339563501$var$WINDOW = (0, $aFn2S.GLOBAL_OBJ);
const $7dc42c5339563501$var$DEBOUNCE_DURATION = 1000;
let $7dc42c5339563501$var$debounceTimerID;
let $7dc42c5339563501$var$lastCapturedEventType;
let $7dc42c5339563501$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $7dc42c5339563501$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $6i9I9.addHandler)(type, handler);
    (0, $6i9I9.maybeInstrument)(type, $7dc42c5339563501$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $7dc42c5339563501$export$3014bbf0af0e1d4a() {
    if (!$7dc42c5339563501$var$WINDOW.document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $6i9I9.triggerHandlers).bind(null, 'dom');
    const globalDOMEventHandler = $7dc42c5339563501$var$makeDOMEventHandler(triggerDOMHandler, true);
    $7dc42c5339563501$var$WINDOW.document.addEventListener('click', globalDOMEventHandler, false);
    $7dc42c5339563501$var$WINDOW.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $7dc42c5339563501$var$WINDOW[target] && $7dc42c5339563501$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $3dFJR.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $7dc42c5339563501$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $3dFJR.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $7dc42c5339563501$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $7dc42c5339563501$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $7dc42c5339563501$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $7dc42c5339563501$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $7dc42c5339563501$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $7dc42c5339563501$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($7dc42c5339563501$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $3dFJR.addNonEnumerableProperty)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $3dFJR.addNonEnumerableProperty)(target, '_sentryId', (0, $kgI9H.uuid4)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$7dc42c5339563501$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $7dc42c5339563501$var$lastCapturedEventType = event.type;
            $7dc42c5339563501$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($7dc42c5339563501$var$debounceTimerID);
        $7dc42c5339563501$var$debounceTimerID = $7dc42c5339563501$var$WINDOW.setTimeout(()=>{
            $7dc42c5339563501$var$lastCapturedEventTargetId = undefined;
            $7dc42c5339563501$var$lastCapturedEventType = undefined;
        }, $7dc42c5339563501$var$DEBOUNCE_DURATION);
    };
}
function $7dc42c5339563501$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}

});

parcelRegister("7pl6s", function(module, exports) {
$parcel$export(module.exports, "addConsoleInstrumentationHandler", () => $564b3cd814cf7a5a$export$1d6e0d073f9e6723);

var $6lJZW = parcelRequire("6lJZW");

var $3dFJR = parcelRequire("3dFJR");

var $aFn2S = parcelRequire("aFn2S");

var $6i9I9 = parcelRequire("6i9I9");
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $564b3cd814cf7a5a$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $6i9I9.addHandler)(type, handler);
    (0, $6i9I9.maybeInstrument)(type, $564b3cd814cf7a5a$var$instrumentConsole);
}
function $564b3cd814cf7a5a$var$instrumentConsole() {
    if (!('console' in (0, $aFn2S.GLOBAL_OBJ))) return;
    (0, $6lJZW.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, $aFn2S.GLOBAL_OBJ).console)) return;
        (0, $3dFJR.fill)((0, $aFn2S.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $6lJZW.originalConsoleMethods)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $6i9I9.triggerHandlers)('console', handlerData);
                const log = (0, $6lJZW.originalConsoleMethods)[level];
                log && log.apply((0, $aFn2S.GLOBAL_OBJ).console, args);
            };
        });
    });
}

});

parcelRegister("hpPel", function(module, exports) {
$parcel$export(module.exports, "addFetchInstrumentationHandler", () => $cadc82c56874dc17$export$f75d3c772c923df0);

var $3dFJR = parcelRequire("3dFJR");

var $fsPAv = parcelRequire("fsPAv");

var $aFn2S = parcelRequire("aFn2S");

var $6i9I9 = parcelRequire("6i9I9");
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $cadc82c56874dc17$export$f75d3c772c923df0(handler) {
    const type = 'fetch';
    (0, $6i9I9.addHandler)(type, handler);
    (0, $6i9I9.maybeInstrument)(type, $cadc82c56874dc17$var$instrumentFetch);
}
function $cadc82c56874dc17$var$instrumentFetch() {
    if (!(0, $fsPAv.supportsNativeFetch)()) return;
    (0, $3dFJR.fill)((0, $aFn2S.GLOBAL_OBJ), 'fetch', function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $cadc82c56874dc17$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            (0, $6i9I9.triggerHandlers)('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $aFn2S.GLOBAL_OBJ), args).then((response)=>{
                const finishedHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                };
                (0, $6i9I9.triggerHandlers)('fetch', finishedHandlerData);
                return response;
            }, (error)=>{
                const erroredHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                };
                (0, $6i9I9.triggerHandlers)('fetch', erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $cadc82c56874dc17$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $cadc82c56874dc17$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($cadc82c56874dc17$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $cadc82c56874dc17$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $cadc82c56874dc17$var$getUrlFromResource(url),
            method: $cadc82c56874dc17$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $cadc82c56874dc17$var$getUrlFromResource(arg),
        method: $cadc82c56874dc17$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}

});

parcelRegister("1eUoF", function(module, exports) {
$parcel$export(module.exports, "SENTRY_XHR_DATA_KEY", () => $0e72d880fb6ffb53$export$55b6bb1e45c6cf59);
$parcel$export(module.exports, "addXhrInstrumentationHandler", () => $0e72d880fb6ffb53$export$26ace48dd54c9aea);

var $2Jaqc = parcelRequire("2Jaqc");

var $3dFJR = parcelRequire("3dFJR");

var $aFn2S = parcelRequire("aFn2S");

var $6i9I9 = parcelRequire("6i9I9");
const $0e72d880fb6ffb53$var$WINDOW = (0, $aFn2S.GLOBAL_OBJ);
const $0e72d880fb6ffb53$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $0e72d880fb6ffb53$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $6i9I9.addHandler)(type, handler);
    (0, $6i9I9.maybeInstrument)(type, $0e72d880fb6ffb53$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $0e72d880fb6ffb53$export$c67d533bf77cbf54() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!$0e72d880fb6ffb53$var$WINDOW.XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $3dFJR.fill)(xhrproto, 'open', function(originalOpen) {
        return function(...args) {
            const startTimestamp = Date.now();
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $2Jaqc.isString)(args[0]) ? args[0].toUpperCase() : undefined;
            const url = $0e72d880fb6ffb53$var$parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[$0e72d880fb6ffb53$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$0e72d880fb6ffb53$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp: startTimestamp,
                        xhr: this
                    };
                    (0, $6i9I9.triggerHandlers)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in this && typeof this.onreadystatechange === 'function') (0, $3dFJR.fill)(this, 'onreadystatechange', function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $3dFJR.fill)(this, 'setRequestHeader', function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$0e72d880fb6ffb53$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $2Jaqc.isString)(header) && (0, $2Jaqc.isString)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $3dFJR.fill)(xhrproto, 'send', function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$0e72d880fb6ffb53$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            const handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            (0, $6i9I9.triggerHandlers)('xhr', handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function $0e72d880fb6ffb53$var$parseUrl(url) {
    if ((0, $2Jaqc.isString)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}

});

parcelRegister("29V09", function(module, exports) {
$parcel$export(module.exports, "parseUrl", () => $1928a35931a4ddde$export$7a5253c0f62e0150);
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $1928a35931a4ddde$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $1928a35931a4ddde$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $1928a35931a4ddde$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ',').length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $1928a35931a4ddde$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, '[filtered]:[filtered]@')// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}

});

parcelRegister("7VcJa", function(module, exports) {
$parcel$export(module.exports, "severityLevelFromString", () => $5c47bab40404e116$export$d771ef054122c30a);
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $5c47bab40404e116$export$411d0ffdba845b6c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug'
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $5c47bab40404e116$export$e01cef29b4327697(level) {
    return $5c47bab40404e116$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $5c47bab40404e116$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : $5c47bab40404e116$export$411d0ffdba845b6c.includes(level) ? level : 'log';
}

});


parcelRegister("lo7wK", function(module, exports) {
$parcel$export(module.exports, "dedupeIntegration", () => $f921ad9e3802490f$export$6d39aa44cd0c7567);
$parcel$export(module.exports, "Dedupe", () => $f921ad9e3802490f$export$688d98c249d31ad3);

var $8WCUT = parcelRequire("8WCUT");

var $6lJZW = parcelRequire("6lJZW");

var $bl0Xy = parcelRequire("bl0Xy");
const $f921ad9e3802490f$var$INTEGRATION_NAME = 'Dedupe';
const $f921ad9e3802490f$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $f921ad9e3802490f$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($f921ad9e3802490f$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, $bl0Xy.DEBUG_BUILD) && (0, $6lJZW.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const $f921ad9e3802490f$export$6d39aa44cd0c7567 = (0, $8WCUT.defineIntegration)($f921ad9e3802490f$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $f921ad9e3802490f$export$688d98c249d31ad3 = (0, $8WCUT.convertIntegrationFnToClass)($f921ad9e3802490f$var$INTEGRATION_NAME, $f921ad9e3802490f$export$6d39aa44cd0c7567);
function $f921ad9e3802490f$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($f921ad9e3802490f$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($f921ad9e3802490f$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $f921ad9e3802490f$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$f921ad9e3802490f$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$f921ad9e3802490f$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $f921ad9e3802490f$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $f921ad9e3802490f$var$_getExceptionFromEvent(previousEvent);
    const currentException = $f921ad9e3802490f$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$f921ad9e3802490f$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$f921ad9e3802490f$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $f921ad9e3802490f$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $f921ad9e3802490f$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $f921ad9e3802490f$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $f921ad9e3802490f$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $f921ad9e3802490f$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $f921ad9e3802490f$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}

});

parcelRegister("jFqF2", function(module, exports) {
$parcel$export(module.exports, "globalHandlersIntegration", () => $e51686f51cf86652$export$66acc70e8cf2b71a);
$parcel$export(module.exports, "GlobalHandlers", () => $e51686f51cf86652$export$204155decbc90e5a);

var $3vr70 = parcelRequire("3vr70");
var $8WCUT = parcelRequire("8WCUT");

var $1QDmA = parcelRequire("1QDmA");
var $kS6cd = parcelRequire("kS6cd");
var $1Pi8W = parcelRequire("1Pi8W");
var $2Jaqc = parcelRequire("2Jaqc");
var $6lJZW = parcelRequire("6lJZW");

var $bl0Xy = parcelRequire("bl0Xy");

var $iRG6Q = parcelRequire("iRG6Q");

var $3FkMI = parcelRequire("3FkMI");
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ const $e51686f51cf86652$var$INTEGRATION_NAME = 'GlobalHandlers';
const $e51686f51cf86652$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $e51686f51cf86652$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $e51686f51cf86652$var$_installGlobalOnErrorHandler(client);
                $e51686f51cf86652$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $e51686f51cf86652$var$_installGlobalOnUnhandledRejectionHandler(client);
                $e51686f51cf86652$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $e51686f51cf86652$export$66acc70e8cf2b71a = (0, $8WCUT.defineIntegration)($e51686f51cf86652$var$_globalHandlersIntegration);
/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $e51686f51cf86652$export$204155decbc90e5a = (0, $8WCUT.convertIntegrationFnToClass)($e51686f51cf86652$var$INTEGRATION_NAME, $e51686f51cf86652$export$66acc70e8cf2b71a);
function $e51686f51cf86652$var$_installGlobalOnErrorHandler(client) {
    (0, $1QDmA.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $e51686f51cf86652$var$getOptions();
        if ((0, $3vr70.getClient)() !== client || (0, $3FkMI.shouldIgnoreOnError)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = error === undefined && (0, $2Jaqc.isString)(msg) ? $e51686f51cf86652$var$_eventFromIncompleteOnError(msg, url, line, column) : $e51686f51cf86652$var$_enhanceEventWithInitialFrame((0, $iRG6Q.eventFromUnknownInput)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $3vr70.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onerror'
            }
        });
    });
}
function $e51686f51cf86652$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $kS6cd.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $e51686f51cf86652$var$getOptions();
        if ((0, $3vr70.getClient)() !== client || (0, $3FkMI.shouldIgnoreOnError)()) return;
        const error = $e51686f51cf86652$var$_getUnhandledRejectionError(e);
        const event = (0, $2Jaqc.isPrimitive)(error) ? $e51686f51cf86652$var$_eventFromRejectionWithPrimitive(error) : (0, $iRG6Q.eventFromUnknownInput)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $3vr70.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onunhandledrejection'
            }
        });
    });
}
function $e51686f51cf86652$var$_getUnhandledRejectionError(error) {
    if ((0, $2Jaqc.isPrimitive)(error)) return error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in e) return e.reason;
        else if ('detail' in e && 'reason' in e.detail) return e.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $e51686f51cf86652$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e51686f51cf86652$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $2Jaqc.isErrorEvent)(msg) ? msg.message : msg;
    let name = 'Error';
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $e51686f51cf86652$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e51686f51cf86652$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $2Jaqc.isString)(url) && url.length > 0 ? url : (0, $1Pi8W.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: '?',
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $e51686f51cf86652$var$globalHandlerLog(type) {
    (0, $bl0Xy.DEBUG_BUILD) && (0, $6lJZW.logger).log(`Global Handler attached: ${type}`);
}
function $e51686f51cf86652$var$getOptions() {
    const client = (0, $3vr70.getClient)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}

});
parcelRegister("1QDmA", function(module, exports) {
$parcel$export(module.exports, "addGlobalErrorInstrumentationHandler", () => $15892e7c224b8e3a$export$55b5c3ba2194f0c6);

var $aFn2S = parcelRequire("aFn2S");

var $6i9I9 = parcelRequire("6i9I9");
let $15892e7c224b8e3a$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $15892e7c224b8e3a$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $6i9I9.addHandler)(type, handler);
    (0, $6i9I9.maybeInstrument)(type, $15892e7c224b8e3a$var$instrumentError);
}
function $15892e7c224b8e3a$var$instrumentError() {
    $15892e7c224b8e3a$var$_oldOnErrorHandler = (0, $aFn2S.GLOBAL_OBJ).onerror;
    (0, $aFn2S.GLOBAL_OBJ).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $6i9I9.triggerHandlers)('error', handlerData);
        if ($15892e7c224b8e3a$var$_oldOnErrorHandler && !$15892e7c224b8e3a$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $15892e7c224b8e3a$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $aFn2S.GLOBAL_OBJ).onerror.__SENTRY_INSTRUMENTED__ = true;
}

});

parcelRegister("kS6cd", function(module, exports) {
$parcel$export(module.exports, "addGlobalUnhandledRejectionInstrumentationHandler", () => $f31da83365f8d695$export$8bf4fc6858821a4e);

var $aFn2S = parcelRequire("aFn2S");

var $6i9I9 = parcelRequire("6i9I9");
let $f31da83365f8d695$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $f31da83365f8d695$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $6i9I9.addHandler)(type, handler);
    (0, $6i9I9.maybeInstrument)(type, $f31da83365f8d695$var$instrumentUnhandledRejection);
}
function $f31da83365f8d695$var$instrumentUnhandledRejection() {
    $f31da83365f8d695$var$_oldOnUnhandledRejectionHandler = (0, $aFn2S.GLOBAL_OBJ).onunhandledrejection;
    (0, $aFn2S.GLOBAL_OBJ).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $6i9I9.triggerHandlers)('unhandledrejection', handlerData);
        if ($f31da83365f8d695$var$_oldOnUnhandledRejectionHandler && !$f31da83365f8d695$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $f31da83365f8d695$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $aFn2S.GLOBAL_OBJ).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}

});


parcelRegister("11Thk", function(module, exports) {
$parcel$export(module.exports, "httpContextIntegration", () => $0c00c3958b78b76f$export$1378794447170364);
$parcel$export(module.exports, "HttpContext", () => $0c00c3958b78b76f$export$5d2ee9a544b09a94);

var $8WCUT = parcelRequire("8WCUT");

var $3FkMI = parcelRequire("3FkMI");
const $0c00c3958b78b76f$var$INTEGRATION_NAME = 'HttpContext';
const $0c00c3958b78b76f$var$_httpContextIntegration = ()=>{
    return {
        name: $0c00c3958b78b76f$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $3FkMI.WINDOW).navigator && !(0, $3FkMI.WINDOW).location && !(0, $3FkMI.WINDOW).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $3FkMI.WINDOW).location && (0, $3FkMI.WINDOW).location.href;
            const { referrer: referrer } = (0, $3FkMI.WINDOW).document || {};
            const { userAgent: userAgent } = (0, $3FkMI.WINDOW).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    'User-Agent': userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
};
const $0c00c3958b78b76f$export$1378794447170364 = (0, $8WCUT.defineIntegration)($0c00c3958b78b76f$var$_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $0c00c3958b78b76f$export$5d2ee9a544b09a94 = (0, $8WCUT.convertIntegrationFnToClass)($0c00c3958b78b76f$var$INTEGRATION_NAME, $0c00c3958b78b76f$export$1378794447170364);

});

parcelRegister("fTNUR", function(module, exports) {
$parcel$export(module.exports, "linkedErrorsIntegration", () => $b932b65e88c59ae2$export$ebabb00eb7f3a395);
$parcel$export(module.exports, "LinkedErrors", () => $b932b65e88c59ae2$export$8d1e60aaf616fb4f);

var $8WCUT = parcelRequire("8WCUT");

var $1EqWC = parcelRequire("1EqWC");

var $iRG6Q = parcelRequire("iRG6Q");
const $b932b65e88c59ae2$var$DEFAULT_KEY = 'cause';
const $b932b65e88c59ae2$var$DEFAULT_LIMIT = 5;
const $b932b65e88c59ae2$var$INTEGRATION_NAME = 'LinkedErrors';
const $b932b65e88c59ae2$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $b932b65e88c59ae2$var$DEFAULT_LIMIT;
    const key = options.key || $b932b65e88c59ae2$var$DEFAULT_KEY;
    return {
        name: $b932b65e88c59ae2$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $1EqWC.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $iRG6Q.exceptionFromError), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $b932b65e88c59ae2$export$ebabb00eb7f3a395 = (0, $8WCUT.defineIntegration)($b932b65e88c59ae2$var$_linkedErrorsIntegration);
/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $b932b65e88c59ae2$export$8d1e60aaf616fb4f = (0, $8WCUT.convertIntegrationFnToClass)($b932b65e88c59ae2$var$INTEGRATION_NAME, $b932b65e88c59ae2$export$ebabb00eb7f3a395);

});
parcelRegister("1EqWC", function(module, exports) {
$parcel$export(module.exports, "applyAggregateErrorsToEvent", () => $133e6d7ac7a2df5c$export$b91c38ed7d8ae9b2);

var $2Jaqc = parcelRequire("2Jaqc");

var $4RzNY = parcelRequire("4RzNY");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $133e6d7ac7a2df5c$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $2Jaqc.isInstanceOf)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $133e6d7ac7a2df5c$var$truncateAggregateExceptions($133e6d7ac7a2df5c$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $133e6d7ac7a2df5c$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $2Jaqc.isInstanceOf)(error[key], Error)) {
        $133e6d7ac7a2df5c$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $133e6d7ac7a2df5c$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $133e6d7ac7a2df5c$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $2Jaqc.isInstanceOf)(childError, Error)) {
            $133e6d7ac7a2df5c$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $133e6d7ac7a2df5c$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $133e6d7ac7a2df5c$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $133e6d7ac7a2df5c$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === 'AggregateError' && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $133e6d7ac7a2df5c$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $133e6d7ac7a2df5c$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $4RzNY.truncate)(exception.value, maxValueLength);
        return exception;
    });
}

});


parcelRegister("jWbWT", function(module, exports) {
$parcel$export(module.exports, "browserApiErrorsIntegration", () => $e83cb3e6cc54780e$export$59bfe9f1c76150e);
$parcel$export(module.exports, "TryCatch", () => $e83cb3e6cc54780e$export$f1a018517668e6d3);

var $8WCUT = parcelRequire("8WCUT");

var $3dFJR = parcelRequire("3dFJR");
var $amn5g = parcelRequire("amn5g");

var $3FkMI = parcelRequire("3FkMI");
const $e83cb3e6cc54780e$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $e83cb3e6cc54780e$var$INTEGRATION_NAME = 'TryCatch';
const $e83cb3e6cc54780e$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $e83cb3e6cc54780e$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $3dFJR.fill)((0, $3FkMI.WINDOW), 'setTimeout', $e83cb3e6cc54780e$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $3dFJR.fill)((0, $3FkMI.WINDOW), 'setInterval', $e83cb3e6cc54780e$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $3dFJR.fill)((0, $3FkMI.WINDOW), 'requestAnimationFrame', $e83cb3e6cc54780e$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $3FkMI.WINDOW)) (0, $3dFJR.fill)(XMLHttpRequest.prototype, 'send', $e83cb3e6cc54780e$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $e83cb3e6cc54780e$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($e83cb3e6cc54780e$var$_wrapEventTarget);
            }
        }
    };
};
const $e83cb3e6cc54780e$export$59bfe9f1c76150e = (0, $8WCUT.defineIntegration)($e83cb3e6cc54780e$var$_browserApiErrorsIntegration);
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $e83cb3e6cc54780e$export$f1a018517668e6d3 = (0, $8WCUT.convertIntegrationFnToClass)($e83cb3e6cc54780e$var$INTEGRATION_NAME, $e83cb3e6cc54780e$export$59bfe9f1c76150e);
function $e83cb3e6cc54780e$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $3FkMI.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $amn5g.getFunctionName)(original)
                },
                handled: false,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e83cb3e6cc54780e$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $3FkMI.wrap)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $amn5g.getFunctionName)(original)
                    },
                    handled: false,
                    type: 'instrument'
                }
            })
        ]);
    };
}
function $e83cb3e6cc54780e$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $3dFJR.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $amn5g.getFunctionName)(original)
                        },
                        handled: false,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $3dFJR.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $amn5g.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $3FkMI.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $e83cb3e6cc54780e$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $3FkMI.WINDOW);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $3dFJR.fill)(proto, 'addEventListener', function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $3FkMI.wrap)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $amn5g.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $3FkMI.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $amn5g.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $3dFJR.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}

});

parcelRegister("7JgVP", function(module, exports) {
$parcel$export(module.exports, "defaultStackParser", () => $5a09dea27edb4e14$export$2b2b997d81bf3907);

var $amn5g = parcelRequire("amn5g");
// global reference to slice
const $5a09dea27edb4e14$var$UNKNOWN_FUNCTION = '?';
const $5a09dea27edb4e14$var$OPERA10_PRIORITY = 10;
const $5a09dea27edb4e14$var$OPERA11_PRIORITY = 20;
const $5a09dea27edb4e14$var$CHROME_PRIORITY = 30;
const $5a09dea27edb4e14$var$WINJS_PRIORITY = 40;
const $5a09dea27edb4e14$var$GECKO_PRIORITY = 50;
function $5a09dea27edb4e14$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $5a09dea27edb4e14$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $5a09dea27edb4e14$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $5a09dea27edb4e14$var$chromeStackParserFn = (line)=>{
    const parts = $5a09dea27edb4e14$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $5a09dea27edb4e14$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $5a09dea27edb4e14$var$extractSafariExtensionDetails(parts[1] || $5a09dea27edb4e14$var$UNKNOWN_FUNCTION, parts[2]);
        return $5a09dea27edb4e14$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $5a09dea27edb4e14$export$263a749fff749872 = [
    $5a09dea27edb4e14$var$CHROME_PRIORITY,
    $5a09dea27edb4e14$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $5a09dea27edb4e14$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $5a09dea27edb4e14$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $5a09dea27edb4e14$var$gecko = (line)=>{
    const parts = $5a09dea27edb4e14$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $5a09dea27edb4e14$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $5a09dea27edb4e14$var$UNKNOWN_FUNCTION;
        [func, filename] = $5a09dea27edb4e14$var$extractSafariExtensionDetails(func, filename);
        return $5a09dea27edb4e14$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $5a09dea27edb4e14$export$cdba47a5dd2804d = [
    $5a09dea27edb4e14$var$GECKO_PRIORITY,
    $5a09dea27edb4e14$var$gecko
];
const $5a09dea27edb4e14$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $5a09dea27edb4e14$var$winjs = (line)=>{
    const parts = $5a09dea27edb4e14$var$winjsRegex.exec(line);
    return parts ? $5a09dea27edb4e14$var$createFrame(parts[2], parts[1] || $5a09dea27edb4e14$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $5a09dea27edb4e14$export$179460296da408e8 = [
    $5a09dea27edb4e14$var$WINJS_PRIORITY,
    $5a09dea27edb4e14$var$winjs
];
const $5a09dea27edb4e14$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $5a09dea27edb4e14$var$opera10 = (line)=>{
    const parts = $5a09dea27edb4e14$var$opera10Regex.exec(line);
    return parts ? $5a09dea27edb4e14$var$createFrame(parts[2], parts[3] || $5a09dea27edb4e14$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $5a09dea27edb4e14$export$f892b52c880ffc7a = [
    $5a09dea27edb4e14$var$OPERA10_PRIORITY,
    $5a09dea27edb4e14$var$opera10
];
const $5a09dea27edb4e14$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $5a09dea27edb4e14$var$opera11 = (line)=>{
    const parts = $5a09dea27edb4e14$var$opera11Regex.exec(line);
    return parts ? $5a09dea27edb4e14$var$createFrame(parts[5], parts[3] || parts[4] || $5a09dea27edb4e14$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $5a09dea27edb4e14$export$af11af13f09fb0dc = [
    $5a09dea27edb4e14$var$OPERA11_PRIORITY,
    $5a09dea27edb4e14$var$opera11
];
const $5a09dea27edb4e14$export$7197c0fe6554c079 = [
    $5a09dea27edb4e14$export$263a749fff749872,
    $5a09dea27edb4e14$export$cdba47a5dd2804d,
    $5a09dea27edb4e14$export$179460296da408e8
];
const $5a09dea27edb4e14$export$2b2b997d81bf3907 = (0, $amn5g.createStackParser)(...$5a09dea27edb4e14$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $5a09dea27edb4e14$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $5a09dea27edb4e14$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};

});

parcelRegister("3SNJd", function(module, exports) {
$parcel$export(module.exports, "makeFetchTransport", () => $2d3cfd3debb30c89$export$b2311068c46d7cc8);

var $5ks7K = parcelRequire("5ks7K");

var $dtmqq = parcelRequire("dtmqq");

var $9eUfH = parcelRequire("9eUfH");
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $2d3cfd3debb30c89$export$b2311068c46d7cc8(options, nativeFetch = (0, $9eUfH.getNativeFetchImplementation)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $9eUfH.clearCachedFetchImplementation)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $dtmqq.rejectedSyncPromise)(e);
        }
    }
    return (0, $5ks7K.createTransport)(options, makeRequest);
}

});
parcelRegister("5ks7K", function(module, exports) {
$parcel$export(module.exports, "createTransport", () => $3e14a2d32e466f22$export$d09f50d9ab7f7b69);

var $9CzI9 = parcelRequire("9CzI9");
var $egZpt = parcelRequire("egZpt");
var $6lJZW = parcelRequire("6lJZW");
var $bONan = parcelRequire("bONan");
var $dtmqq = parcelRequire("dtmqq");
var $lxc2k = parcelRequire("lxc2k");

var $fZ2r3 = parcelRequire("fZ2r3");
const $3e14a2d32e466f22$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $3e14a2d32e466f22$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $bONan.makePromiseBuffer)(options.bufferSize || $3e14a2d32e466f22$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $9CzI9.forEachEnvelopeItem)(envelope, (item, type)=>{
            const dataCategory = (0, $9CzI9.envelopeItemTypeToDataCategory)(type);
            if ((0, $egZpt.isRateLimited)(rateLimits, dataCategory)) {
                const event = $3e14a2d32e466f22$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent('ratelimit_backoff', dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $dtmqq.resolvedSyncPromise)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $9CzI9.createEnvelope)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $9CzI9.forEachEnvelopeItem)(filteredEnvelope, (item, type)=>{
                const event = $3e14a2d32e466f22$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $9CzI9.envelopeItemTypeToDataCategory)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $9CzI9.serializeEnvelope)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $egZpt.updateRateLimits)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $lxc2k.SentryError)) {
                (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, $dtmqq.resolvedSyncPromise)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $3e14a2d32e466f22$var$getEventForEnvelopeItem(item, type) {
    if (type !== 'event' && type !== 'transaction') return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}

});
parcelRegister("egZpt", function(module, exports) {
$parcel$export(module.exports, "isRateLimited", () => $a642320356270be7$export$6c91fec22056810a);
$parcel$export(module.exports, "updateRateLimits", () => $a642320356270be7$export$699aff705e0d49d4);
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $a642320356270be7$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $a642320356270be7$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $a642320356270be7$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $a642320356270be7$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $a642320356270be7$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $a642320356270be7$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $a642320356270be7$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
    const retryAfterHeader = headers && headers['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $a642320356270be7$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}

});

parcelRegister("bONan", function(module, exports) {
$parcel$export(module.exports, "makePromiseBuffer", () => $89aa80a6d2bece5d$export$85a4f67f852183e6);

var $lxc2k = parcelRequire("lxc2k");

var $dtmqq = parcelRequire("dtmqq");
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $89aa80a6d2bece5d$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $dtmqq.rejectedSyncPromise)(new (0, $lxc2k.SentryError)('Not adding Promise because buffer limit was reached.'));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $dtmqq.SyncPromise)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $dtmqq.resolvedSyncPromise)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});


parcelRegister("9eUfH", function(module, exports) {
$parcel$export(module.exports, "getNativeFetchImplementation", () => $6ba10e5e88e965b4$export$8be2119ce08e3379);
$parcel$export(module.exports, "clearCachedFetchImplementation", () => $6ba10e5e88e965b4$export$d499686d2dd738c6);

var $fsPAv = parcelRequire("fsPAv");
var $6lJZW = parcelRequire("6lJZW");

var $bl0Xy = parcelRequire("bl0Xy");

var $3FkMI = parcelRequire("3FkMI");
let $6ba10e5e88e965b4$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $6ba10e5e88e965b4$export$8be2119ce08e3379() {
    if ($6ba10e5e88e965b4$var$cachedFetchImpl) return $6ba10e5e88e965b4$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $fsPAv.isNativeFetch)((0, $3FkMI.WINDOW).fetch)) return $6ba10e5e88e965b4$var$cachedFetchImpl = (0, $3FkMI.WINDOW).fetch.bind((0, $3FkMI.WINDOW));
    const document = (0, $3FkMI.WINDOW).document;
    let fetchImpl = (0, $3FkMI.WINDOW).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $bl0Xy.DEBUG_BUILD) && (0, $6lJZW.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return $6ba10e5e88e965b4$var$cachedFetchImpl = fetchImpl.bind((0, $3FkMI.WINDOW));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $6ba10e5e88e965b4$export$d499686d2dd738c6() {
    $6ba10e5e88e965b4$var$cachedFetchImpl = undefined;
}

});


parcelRegister("1FjJN", function(module, exports) {
$parcel$export(module.exports, "makeXHRTransport", () => $1368ee45dd559bc3$export$5e1441cee30d5a39);

var $5ks7K = parcelRequire("5ks7K");

var $dtmqq = parcelRequire("dtmqq");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $1368ee45dd559bc3$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $1368ee45dd559bc3$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $dtmqq.SyncPromise)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $1368ee45dd559bc3$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                        'retry-after': xhr.getResponseHeader('Retry-After')
                    }
                });
            };
            xhr.open('POST', options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $5ks7K.createTransport)(options, makeRequest);
}

});


parcelRegister("kvkQX", function(module, exports) {
$parcel$export(module.exports, "Integrations", () => $eed6e0e057d8942d$export$99d02219d259eb94);

var $3vr70 = parcelRequire("3vr70");
var $1feQE = parcelRequire("1feQE");
var $kINbm = parcelRequire("kINbm");
var $gIi6D = parcelRequire("gIi6D");


var $lt7A0 = parcelRequire("lt7A0");

var $3SNJd = parcelRequire("3SNJd");


var $7JgVP = parcelRequire("7JgVP");



var $38t4T = parcelRequire("38t4T");







var $ezgAK = parcelRequire("ezgAK");

var $lOA8N = parcelRequire("lOA8N");


var $lOA8N = parcelRequire("lOA8N");





let $eed6e0e057d8942d$var$windowIntegrations = {};
/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */ const $eed6e0e057d8942d$export$99d02219d259eb94 = {
    ...$eed6e0e057d8942d$var$windowIntegrations,
    // eslint-disable-next-line deprecation/deprecation
    ...(0, $gIi6D.Integrations),
    ...$ezgAK
};

});
parcelRegister("gIi6D", function(module, exports) {
$parcel$export(module.exports, "Integrations", () => $c2aecce334b74f3f$export$99d02219d259eb94);













var $3vr70 = parcelRequire("3vr70");

var $kINbm = parcelRequire("kINbm");




var $1feQE = parcelRequire("1feQE");

var $71uQM = parcelRequire("71uQM");

var $1NMDh = parcelRequire("1NMDh");


var $bQI3R = parcelRequire("bQI3R");

var $5ks7K = parcelRequire("5ks7K");




var $8WCUT = parcelRequire("8WCUT");











var $2XwhW = parcelRequire("2XwhW");




var $hTs4r = parcelRequire("hTs4r");

var $3idHc = parcelRequire("3idHc");


var $6Uzyg = parcelRequire("6Uzyg");

/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */ const $c2aecce334b74f3f$export$99d02219d259eb94 = $6Uzyg;

});
parcelRegister("6Uzyg", function(module, exports) {
$parcel$export(module.exports, "FunctionToString", () => (parcelRequire("3idHc")).FunctionToString);
$parcel$export(module.exports, "InboundFilters", () => (parcelRequire("hTs4r")).InboundFilters);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("3kUOV")).LinkedErrors);

var $3idHc = parcelRequire("3idHc");

var $hTs4r = parcelRequire("hTs4r");

var $3kUOV = parcelRequire("3kUOV");
 /* eslint-disable deprecation/deprecation */ 
});
parcelRegister("3kUOV", function(module, exports) {
$parcel$export(module.exports, "LinkedErrors", () => $26df50b0a5bc8189$export$8d1e60aaf616fb4f);

var $1EqWC = parcelRequire("1EqWC");
var $dFeC8 = parcelRequire("dFeC8");

var $8WCUT = parcelRequire("8WCUT");
const $26df50b0a5bc8189$var$DEFAULT_KEY = 'cause';
const $26df50b0a5bc8189$var$DEFAULT_LIMIT = 5;
const $26df50b0a5bc8189$var$INTEGRATION_NAME = 'LinkedErrors';
const $26df50b0a5bc8189$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $26df50b0a5bc8189$var$DEFAULT_LIMIT;
    const key = options.key || $26df50b0a5bc8189$var$DEFAULT_KEY;
    return {
        name: $26df50b0a5bc8189$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $1EqWC.applyAggregateErrorsToEvent)((0, $dFeC8.exceptionFromError), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $26df50b0a5bc8189$export$ebabb00eb7f3a395 = (0, $8WCUT.defineIntegration)($26df50b0a5bc8189$var$_linkedErrorsIntegration);
/**
 * Adds SDK info to an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $26df50b0a5bc8189$export$8d1e60aaf616fb4f = (0, $8WCUT.convertIntegrationFnToClass)($26df50b0a5bc8189$var$INTEGRATION_NAME, $26df50b0a5bc8189$export$ebabb00eb7f3a395);

});
parcelRegister("dFeC8", function(module, exports) {
$parcel$export(module.exports, "exceptionFromError", () => $9f2a70bcca4952d7$export$a6c2d27607295951);

var $2Jaqc = parcelRequire("2Jaqc");

var $kgI9H = parcelRequire("kgI9H");

var $9ZmTE = parcelRequire("9ZmTE");

var $3dFJR = parcelRequire("3dFJR");
/**
 * Extracts stack frames from the error.stack string
 */ function $9f2a70bcca4952d7$export$d478b2c12fbcfdda(stackParser, error) {
    return stackParser(error.stack || '', 1);
}
/**
 * Extracts stack frames from the error and builds a Sentry Exception
 */ function $9f2a70bcca4952d7$export$a6c2d27607295951(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: error.message
    };
    const frames = $9f2a70bcca4952d7$export$d478b2c12fbcfdda(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
function $9f2a70bcca4952d7$var$getMessageForObject(exception) {
    if ('name' in exception && typeof exception.name === 'string') {
        let message = `'${exception.name}' captured as exception`;
        if ('message' in exception && typeof exception.message === 'string') message += ` with message '${exception.message}'`;
        return message;
    } else if ('message' in exception && typeof exception.message === 'string') return exception.message;
    else // This will allow us to group events based on top-level keys
    // which is much better than creating new group when any key/value change
    return `Object captured as exception with keys: ${(0, $3dFJR.extractExceptionKeysForMessage)(exception)}`;
}
/**
 * Builds and Event from a Exception
 *
 * TODO(v8): Remove getHub fallback
 * @hidden
 */ function $9f2a70bcca4952d7$export$9dd56ed1ef0c3420(// eslint-disable-next-line deprecation/deprecation
getHubOrClient, stackParser, exception, hint) {
    const client = typeof getHubOrClient === 'function' ? getHubOrClient().getClient() : getHubOrClient;
    let ex = exception;
    const providedMechanism = hint && hint.data && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: 'generic'
    };
    let extras;
    if (!(0, $2Jaqc.isError)(exception)) {
        if ((0, $2Jaqc.isPlainObject)(exception)) {
            const normalizeDepth = client && client.getOptions().normalizeDepth;
            extras = {
                ['__serialized__']: (0, $9ZmTE.normalizeToSize)(exception, normalizeDepth)
            };
            const message = $9f2a70bcca4952d7$var$getMessageForObject(exception);
            ex = hint && hint.syntheticException || new Error(message);
            ex.message = message;
        } else {
            // This handles when someone does: `throw "something awesome";`
            // We use synthesized Error here so we can extract a (rough) stack trace.
            ex = hint && hint.syntheticException || new Error(exception);
            ex.message = exception;
        }
        mechanism.synthetic = true;
    }
    const event = {
        exception: {
            values: [
                $9f2a70bcca4952d7$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    (0, $kgI9H.addExceptionTypeValue)(event, undefined, undefined);
    (0, $kgI9H.addExceptionMechanism)(event, mechanism);
    return {
        ...event,
        event_id: hint && hint.event_id
    };
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $9f2a70bcca4952d7$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = 'info', hint, attachStacktrace) {
    const event = {
        event_id: hint && hint.event_id,
        level: level
    };
    if (attachStacktrace && hint && hint.syntheticException) {
        const frames = $9f2a70bcca4952d7$export$d478b2c12fbcfdda(stackParser, hint.syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $2Jaqc.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}

});




parcelRegister("ezgAK", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => (parcelRequire("jFqF2")).GlobalHandlers);
$parcel$export(module.exports, "TryCatch", () => (parcelRequire("jWbWT")).TryCatch);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("fK4F3")).Breadcrumbs);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("fTNUR")).LinkedErrors);
$parcel$export(module.exports, "HttpContext", () => (parcelRequire("11Thk")).HttpContext);
$parcel$export(module.exports, "Dedupe", () => (parcelRequire("lo7wK")).Dedupe);

var $jFqF2 = parcelRequire("jFqF2");

var $jWbWT = parcelRequire("jWbWT");

var $fK4F3 = parcelRequire("fK4F3");

var $fTNUR = parcelRequire("fTNUR");

var $11Thk = parcelRequire("11Thk");

var $lo7wK = parcelRequire("lo7wK");
 /* eslint-disable deprecation/deprecation */ 
});


parcelRegister("5fWuD", function(module, exports) {
$parcel$export(module.exports, "captureConsoleIntegration", () => $3d3bb9f8cd87f17d$export$caa9b6c4a4144db4);
$parcel$export(module.exports, "CaptureConsole", () => $3d3bb9f8cd87f17d$export$25a43cb5b5c58c08);

var $iO9Sf = parcelRequire("iO9Sf");
var $jKfzP = parcelRequire("jKfzP");

var $2b8br = parcelRequire("2b8br");
var $cVW2m = parcelRequire("cVW2m");
var $i1LdH = parcelRequire("i1LdH");
var $2R9Om = parcelRequire("2R9Om");
var $8gX89 = parcelRequire("8gX89");
var $kqK0H = parcelRequire("kqK0H");
const $3d3bb9f8cd87f17d$var$INTEGRATION_NAME = 'CaptureConsole';
const $3d3bb9f8cd87f17d$var$_captureConsoleIntegration = (options = {})=>{
    const levels = options.levels || (0, $i1LdH.CONSOLE_LEVELS);
    return {
        name: $3d3bb9f8cd87f17d$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (!('console' in (0, $2R9Om.GLOBAL_OBJ))) return;
            (0, $2b8br.addConsoleInstrumentationHandler)(({ args: args, level: level })=>{
                if ((0, $iO9Sf.getClient)() !== client || !levels.includes(level)) return;
                $3d3bb9f8cd87f17d$var$consoleHandler(args, level);
            });
        }
    };
};
const $3d3bb9f8cd87f17d$export$caa9b6c4a4144db4 = (0, $jKfzP.defineIntegration)($3d3bb9f8cd87f17d$var$_captureConsoleIntegration);
/**
 * Send Console API calls as Sentry Events.
 * @deprecated Use `captureConsoleIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $3d3bb9f8cd87f17d$export$25a43cb5b5c58c08 = (0, $jKfzP.convertIntegrationFnToClass)($3d3bb9f8cd87f17d$var$INTEGRATION_NAME, $3d3bb9f8cd87f17d$export$caa9b6c4a4144db4);
function $3d3bb9f8cd87f17d$var$consoleHandler(args, level) {
    const captureContext = {
        level: (0, $kqK0H.severityLevelFromString)(level),
        extra: {
            arguments: args
        }
    };
    (0, $iO9Sf.withScope)((scope)=>{
        scope.addEventProcessor((event)=>{
            event.logger = 'console';
            (0, $cVW2m.addExceptionMechanism)(event, {
                handled: false,
                type: 'console'
            });
            return event;
        });
        if (level === 'assert' && args[0] === false) {
            const message = `Assertion failed: ${(0, $8gX89.safeJoin)(args.slice(1), ' ') || 'console.assert'}`;
            scope.setExtra('arguments', args.slice(1));
            (0, $iO9Sf.captureMessage)(message, captureContext);
            return;
        }
        const error = args.find((arg)=>arg instanceof Error);
        if (level === 'error' && error) {
            (0, $iO9Sf.captureException)(error, captureContext);
            return;
        }
        const message = (0, $8gX89.safeJoin)(args, ' ');
        (0, $iO9Sf.captureMessage)(message, captureContext);
    });
}

});

parcelRegister("gwUes", function(module, exports) {
$parcel$export(module.exports, "dedupeIntegration", () => $c08b410787f030fd$export$6d39aa44cd0c7567);
$parcel$export(module.exports, "Dedupe", () => $c08b410787f030fd$export$688d98c249d31ad3);

var $jKfzP = parcelRequire("jKfzP");

var $i1LdH = parcelRequire("i1LdH");

var $2Vacp = parcelRequire("2Vacp");
const $c08b410787f030fd$var$INTEGRATION_NAME = 'Dedupe';
const $c08b410787f030fd$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $c08b410787f030fd$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($c08b410787f030fd$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $2Vacp.DEBUG_BUILD) && (0, $i1LdH.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const $c08b410787f030fd$export$6d39aa44cd0c7567 = (0, $jKfzP.defineIntegration)($c08b410787f030fd$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $c08b410787f030fd$export$688d98c249d31ad3 = (0, $jKfzP.convertIntegrationFnToClass)($c08b410787f030fd$var$INTEGRATION_NAME, $c08b410787f030fd$export$6d39aa44cd0c7567);
/** only exported for tests. */ function $c08b410787f030fd$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($c08b410787f030fd$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($c08b410787f030fd$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $c08b410787f030fd$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$c08b410787f030fd$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$c08b410787f030fd$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $c08b410787f030fd$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $c08b410787f030fd$var$_getExceptionFromEvent(previousEvent);
    const currentException = $c08b410787f030fd$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$c08b410787f030fd$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$c08b410787f030fd$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $c08b410787f030fd$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $c08b410787f030fd$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $c08b410787f030fd$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $c08b410787f030fd$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $c08b410787f030fd$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $c08b410787f030fd$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}

});
parcelRegister("2Vacp", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", () => $2208d0f5fc561583$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $2208d0f5fc561583$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});


parcelRegister("gOI8F", function(module, exports) {
$parcel$export(module.exports, "extraErrorDataIntegration", () => $c3e38dec0f9d83f6$export$6e0872131894301d);
$parcel$export(module.exports, "ExtraErrorData", () => $c3e38dec0f9d83f6$export$56d961ef3a52a072);

var $jKfzP = parcelRequire("jKfzP");

var $aVUg9 = parcelRequire("aVUg9");
var $louD4 = parcelRequire("louD4");
var $i1LdH = parcelRequire("i1LdH");
var $7wF0d = parcelRequire("7wF0d");

var $2Vacp = parcelRequire("2Vacp");
const $c3e38dec0f9d83f6$var$INTEGRATION_NAME = 'ExtraErrorData';
const $c3e38dec0f9d83f6$var$_extraErrorDataIntegration = (options = {})=>{
    const depth = options.depth || 3;
    // TODO(v8): Flip the default for this option to true
    const captureErrorCause = options.captureErrorCause || false;
    return {
        name: $c3e38dec0f9d83f6$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, hint) {
            return $c3e38dec0f9d83f6$var$_enhanceEventWithErrorData(event, hint, depth, captureErrorCause);
        }
    };
};
const $c3e38dec0f9d83f6$export$6e0872131894301d = (0, $jKfzP.defineIntegration)($c3e38dec0f9d83f6$var$_extraErrorDataIntegration);
/**
 * Extract additional data for from original exceptions.
 * @deprecated Use `extraErrorDataIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $c3e38dec0f9d83f6$export$56d961ef3a52a072 = (0, $jKfzP.convertIntegrationFnToClass)($c3e38dec0f9d83f6$var$INTEGRATION_NAME, $c3e38dec0f9d83f6$export$6e0872131894301d);
function $c3e38dec0f9d83f6$var$_enhanceEventWithErrorData(event, hint = {}, depth, captureErrorCause) {
    if (!hint.originalException || !(0, $louD4.isError)(hint.originalException)) return event;
    const exceptionName = hint.originalException.name || hint.originalException.constructor.name;
    const errorData = $c3e38dec0f9d83f6$var$_extractErrorData(hint.originalException, captureErrorCause);
    if (errorData) {
        const contexts = {
            ...event.contexts
        };
        const normalizedErrorData = (0, $7wF0d.normalize)(errorData, depth);
        if ((0, $louD4.isPlainObject)(normalizedErrorData)) {
            // We mark the error data as "already normalized" here, because we don't want other normalization procedures to
            // potentially truncate the data we just already normalized, with a certain depth setting.
            (0, $aVUg9.addNonEnumerableProperty)(normalizedErrorData, '__sentry_skip_normalization__', true);
            contexts[exceptionName] = normalizedErrorData;
        }
        return {
            ...event,
            contexts: contexts
        };
    }
    return event;
}
/**
 * Extract extra information from the Error object
 */ function $c3e38dec0f9d83f6$var$_extractErrorData(error, captureErrorCause) {
    // We are trying to enhance already existing event, so no harm done if it won't succeed
    try {
        const nativeKeys = [
            'name',
            'message',
            'stack',
            'line',
            'column',
            'fileName',
            'lineNumber',
            'columnNumber',
            'toJSON'
        ];
        const extraErrorInfo = {};
        // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
        for (const key of Object.keys(error)){
            if (nativeKeys.indexOf(key) !== -1) continue;
            const value = error[key];
            extraErrorInfo[key] = (0, $louD4.isError)(value) ? value.toString() : value;
        }
        // Error.cause is a standard property that is non enumerable, we therefore need to access it separately.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/cause
        if (captureErrorCause && error.cause !== undefined) extraErrorInfo.cause = (0, $louD4.isError)(error.cause) ? error.cause.toString() : error.cause;
        // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
        if (typeof error.toJSON === 'function') {
            const serializedError = error.toJSON();
            for (const key of Object.keys(serializedError)){
                const value = serializedError[key];
                extraErrorInfo[key] = (0, $louD4.isError)(value) ? value.toString() : value;
            }
        }
        return extraErrorInfo;
    } catch (oO) {
        (0, $2Vacp.DEBUG_BUILD) && (0, $i1LdH.logger).error('Unable to extract extra data from the Error object:', oO);
    }
    return null;
}

});

parcelRegister("jPpPM", function(module, exports) {
$parcel$export(module.exports, "rewriteFramesIntegration", () => $e6f6d1e21d14bbec$export$5ed0db6416cb6ea2);
$parcel$export(module.exports, "RewriteFrames", () => $e6f6d1e21d14bbec$export$af39fa91d1acf248);

var $jKfzP = parcelRequire("jKfzP");

var $btxD6 = parcelRequire("btxD6");
const $e6f6d1e21d14bbec$var$INTEGRATION_NAME = 'RewriteFrames';
const $e6f6d1e21d14bbec$var$_rewriteFramesIntegration = (options = {})=>{
    const root = options.root;
    const prefix = options.prefix || 'app:///';
    const iteratee = options.iteratee || ((frame)=>{
        if (!frame.filename) return frame;
        // Determine if this is a Windows frame by checking for a Windows-style prefix such as `C:\`
        const isWindowsFrame = /^[a-zA-Z]:\\/.test(frame.filename) || // or the presence of a backslash without a forward slash (which are not allowed on Windows)
        frame.filename.includes('\\') && !frame.filename.includes('/');
        // Check if the frame filename begins with `/`
        const startsWithSlash = /^\//.test(frame.filename);
        if (isWindowsFrame || startsWithSlash) {
            const filename = isWindowsFrame ? frame.filename.replace(/^[a-zA-Z]:/, '') // remove Windows-style prefix
            .replace(/\\/g, '/') // replace all `\\` instances with `/`
             : frame.filename;
            const base = root ? (0, $btxD6.relative)(root, filename) : (0, $btxD6.basename)(filename);
            frame.filename = `${prefix}${base}`;
        }
        return frame;
    });
    /** Process an exception event. */ function _processExceptionsEvent(event) {
        try {
            return {
                ...event,
                exception: {
                    ...event.exception,
                    // The check for this is performed inside `process` call itself, safe to skip here
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    values: event.exception.values.map((value)=>({
                            ...value,
                            ...value.stacktrace && {
                                stacktrace: _processStacktrace(value.stacktrace)
                            }
                        }))
                }
            };
        } catch (_oO) {
            return event;
        }
    }
    /** Process a stack trace. */ function _processStacktrace(stacktrace) {
        return {
            ...stacktrace,
            frames: stacktrace && stacktrace.frames && stacktrace.frames.map((f)=>iteratee(f))
        };
    }
    return {
        name: $e6f6d1e21d14bbec$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (originalEvent) {
            let processedEvent = originalEvent;
            if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) processedEvent = _processExceptionsEvent(processedEvent);
            return processedEvent;
        }
    };
};
const $e6f6d1e21d14bbec$export$5ed0db6416cb6ea2 = (0, $jKfzP.defineIntegration)($e6f6d1e21d14bbec$var$_rewriteFramesIntegration);
/**
 * Rewrite event frames paths.
 * @deprecated Use `rewriteFramesIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $e6f6d1e21d14bbec$export$af39fa91d1acf248 = (0, $jKfzP.convertIntegrationFnToClass)($e6f6d1e21d14bbec$var$INTEGRATION_NAME, $e6f6d1e21d14bbec$export$5ed0db6416cb6ea2);

});

parcelRegister("aYncF", function(module, exports) {
$parcel$export(module.exports, "LICENSED_PRODUCTS", () => $f94c92768d16d5bb$export$88049c64f9286584);
$parcel$export(module.exports, "getLicensedProducts", () => $f94c92768d16d5bb$export$8cc688f27940ac);
$parcel$export(module.exports, "getInitialProductList", () => $f94c92768d16d5bb$export$971bd624a4cf068e);
$parcel$export(module.exports, "getFirstActivationDate", () => $f94c92768d16d5bb$export$2fc3e4b3f0460c2f);
$parcel$export(module.exports, "determineProductCrossSellConfig", () => $f94c92768d16d5bb$export$2885d42113231825);
$parcel$export(module.exports, "getEnvironment", () => $f94c92768d16d5bb$export$57570b1603cf6adb);
$parcel$export(module.exports, "getAtlassianAccountId", () => $f94c92768d16d5bb$export$f5baf4f0aaa47428);
$parcel$export(module.exports, "getTenantContext_DEPRECATED_DO_NOT_USE", () => $f94c92768d16d5bb$export$374aeba69d52d74d);

var $LFmXM = parcelRequire("LFmXM");

var $jbr6p = parcelRequire("jbr6p");

var $hWeHP = parcelRequire("hWeHP");

var $kIz4h = parcelRequire("kIz4h");

var $ljej9 = parcelRequire("ljej9");

var $5KtrL = parcelRequire("5KtrL");

var $dCptc = parcelRequire("dCptc");

var $aFPNn = parcelRequire("aFPNn");

var $cDvK0 = parcelRequire("cDvK0");

var $8FAyk = parcelRequire("8FAyk");
const $f94c92768d16d5bb$export$88049c64f9286584 = {
    ATLASSIAN_ANALYTICS: 'atlassian-analytics-free',
    JIRA_SOFTWARE: 'jira-software',
    JIRA_SERVICEDESK: 'jira-servicedesk',
    JIRA_PORTFOLIO: 'com.radiantminds.roadmaps-jira',
    JIRA_CORE: 'jira-core',
    JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery',
    CONFLUENCE: 'confluence',
    OPSGENIE: 'opsgenie',
    BITBUCKET: 'com.atlassian.bitbucket',
    STATUS_PAGE: 'statuspage',
    LOOM: 'loom',
    COMPASS: 'compass',
    TOWNSQUARE: 'townsquare',
    PROJECT: 'project',
    GOAL: 'goal'
};
const $f94c92768d16d5bb$export$b4187945225b3132 = (getMetaCustom)=>{
    const getMetaImpl = getMetaCustom === undefined ? (0, $hWeHP.default) : getMetaCustom;
    const metaValue = getMetaImpl('ajs-is-admin');
    if (metaValue === null) return 'unknown';
    return metaValue === 'true' ? 'admin' : 'non-admin';
};
const $f94c92768d16d5bb$export$8cc688f27940ac = (getMetaCustom)=>{
    const getMetaImpl = getMetaCustom === undefined ? (0, $hWeHP.default) : getMetaCustom;
    try {
        return JSON.parse(getMetaImpl('ajs-licensed-products') || '{}');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(`Invalid list of licensed products: ${error}`);
        return {};
    }
};
const $f94c92768d16d5bb$export$875713824cd90c85 = (getMetaCustom)=>{
    const getMetaImpl = getMetaCustom === undefined ? (0, $hWeHP.default) : getMetaCustom;
    try {
        return JSON.parse(getMetaImpl('ajs-product-entitlement-details') || '{}');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return {};
    }
};
const $f94c92768d16d5bb$export$971bd624a4cf068e = (getMetaCustom)=>{
    const getMetaImpl = getMetaCustom === undefined ? (0, $hWeHP.default) : getMetaCustom;
    const metaValue = getMetaImpl('ajs-initial-product-list');
    if (metaValue === null) return '';
    return metaValue;
};
const $f94c92768d16d5bb$export$2fc3e4b3f0460c2f = (getMetaCustom)=>{
    const getMetaImpl = getMetaCustom === undefined ? (0, $hWeHP.default) : getMetaCustom;
    const metaValue = getMetaImpl('ajs-first-activation-date');
    if (metaValue === null) return null;
    const timestamp = parseInt(metaValue, 10);
    if (Number.isNaN(timestamp)) return null;
    return timestamp;
};
const $f94c92768d16d5bb$export$c3fee804514cdf76 = (getMetaCustom)=>{
    const getMetaImpl = getMetaCustom === undefined ? (0, $hWeHP.default) : getMetaCustom;
    const metaValue = getMetaImpl('ajs-app-updates-available');
    if (metaValue === null) return null;
    const hasAppUpdates = parseInt(metaValue, 10);
    if (Number.isNaN(hasAppUpdates)) return null;
    return hasAppUpdates;
};
const $f94c92768d16d5bb$export$2885d42113231825 = (getMetaCustom)=>{
    const getMetaImpl = getMetaCustom === undefined ? (0, $hWeHP.default) : getMetaCustom;
    const metaValue = getMetaImpl('ajs-xflow-product-suggestions-enabled');
    if (metaValue === null) return 'unknown';
    return metaValue === 'true' ? 'enabled' : 'disabled';
};
const $f94c92768d16d5bb$export$57570b1603cf6adb = ()=>(0, $dCptc.toEnvironment)((0, $hWeHP.default)('ajs-environment'));
const $f94c92768d16d5bb$export$f5baf4f0aaa47428 = ()=>(0, $hWeHP.default)('ajs-atlassian-account-id');
const $f94c92768d16d5bb$export$8ece9c90e8293278 = ()=>{
    return(// Cloud ID is flushed early. Checking only this means critical values are available, but not "all of them".
    typeof (0, $hWeHP.default)('ajs-cloud-id') === 'string' && // Version number is retrieved via slow metadata provider call. its presence should indicate "the rest" are available, too.
    typeof (0, $hWeHP.default)('ajs-version-number') === 'string');
};
/**
 * Use hooks from @atlassian/jira-tenant-context-controller instead of this function. Because reading from 30 <meta> tags in DOM on each call slows page down considerably.
 * More info: https://hello.atlassian.net/wiki/spaces/MAGMA/blog/2022/01/12/1479453433/PSA+getTenantContext+is+now+deprecated
 */ const $f94c92768d16d5bb$var$getTenantContextFromMeta = (getMetaCustom)=>{
    const getMetaImpl = getMetaCustom === undefined ? (0, $hWeHP.default) : getMetaCustom;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const cloudId = getMetaImpl('ajs-cloud-id');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const activationId = getMetaImpl('ajs-activation-id');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const cloudName = getMetaImpl('ajs-cloud-name');
    const xsrfToken = getMetaImpl === (0, $hWeHP.default) ? (0, $kIz4h.default)() || null : getMetaImpl('atlassian-token');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const languageTag = getMetaImpl('ajs-fspage-locale');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const locale = getMetaImpl('ajs-user-locale');
    const userFullname = getMetaImpl('ajs-remote-user-fullname');
    const username = getMetaImpl('ajs-remote-user');
    const isAdmin = getMetaImpl('ajs-is-admin') === 'true';
    const isSiteAdmin = getMetaImpl('ajs-is-site-admin') === 'true';
    const fabricActivityUrl = '/gateway/api/activity';
    const fabricNotificationLogUrl = '/gateway/api/notification-log';
    const fabricPfDirUrl = getMetaImpl('ajs-fabric-pf-dir-url');
    const appPermissions = (0, $dCptc.populateApplicationPermissions)({
        hasSoftwareAccess: getMetaImpl('ajs-has-jira-software') === 'true',
        hasServiceDeskAccess: getMetaImpl('ajs-has-jira-service-desk') === 'true',
        hasCoreAccess: getMetaImpl('ajs-has-jira-core') === 'true',
        hasProductDiscoveryAccess: getMetaImpl('ajs-has-jira-product-discovery') === 'true',
        hasCustomerServiceAccess: getMetaImpl('ajs-has-jira-customer-service') === 'true'
    });
    const accountId = getMetaImpl('ajs-atlassian-account-id');
    const isAnonymous = accountId === '';
    const applicationKey = getMetaImpl('ajs-application-key');
    const environment = (0, $dCptc.toEnvironment)(getMetaImpl('ajs-environment'));
    const areProductSuggestionsEnabled = getMetaImpl('ajs-xflow-product-suggestions-enabled') === 'true';
    const licensedProducts = $f94c92768d16d5bb$export$8cc688f27940ac(getMetaImpl);
    const productEntitlementDetails = $f94c92768d16d5bb$export$875713824cd90c85(getMetaImpl);
    if (accountId === null || locale === null || cloudId === null) throw new Error('Unable to find tenant context');
    if (!(0, $jbr6p.default).includes(locale)) // eslint-disable-next-line no-console
    console.warn(`Non supported locale in tenant context: ${locale}`);
    const siteAdminStatus = $f94c92768d16d5bb$export$b4187945225b3132(getMetaImpl);
    const productCrossSellConfig = $f94c92768d16d5bb$export$2885d42113231825(getMetaImpl);
    const appEditions = (0, $aFPNn.default)(getMetaImpl);
    const productPermissionGated = (0, $8FAyk.default)(getMetaImpl);
    let licenseStates;
    if (getMetaImpl('ajs-product-license-states') !== null) licenseStates = (0, $cDvK0.default)(getMetaImpl);
    else /**
		 * When feature flag is OFF, the value of licenseStates will just depend on ajs-has-* tags.
		 * At the moment, there's no other usages besides <LicenseStateCheck>, so this is safe
		 */ licenseStates = (0, $5KtrL.populateApplicationLicenseStates)({
        core: appPermissions.hasCoreAccess ? (0, $5KtrL.LICENSE_STATE_ACTIVE) : (0, $5KtrL.LICENSE_STATE_UNLICENSED),
        software: appPermissions.hasSoftwareAccess ? (0, $5KtrL.LICENSE_STATE_ACTIVE) : (0, $5KtrL.LICENSE_STATE_UNLICENSED),
        serviceDesk: appPermissions.hasServiceDeskAccess ? (0, $5KtrL.LICENSE_STATE_ACTIVE) : (0, $5KtrL.LICENSE_STATE_UNLICENSED),
        customerService: appPermissions.hasCustomerServiceAccess ? (0, $5KtrL.LICENSE_STATE_ACTIVE) : (0, $5KtrL.LICENSE_STATE_UNLICENSED),
        productDiscovery: appPermissions.hasProductDiscoveryAccess ? (0, $5KtrL.LICENSE_STATE_ACTIVE) : (0, $5KtrL.LICENSE_STATE_UNLICENSED)
    });
    const loggedInUser = username === '' ? null : username;
    const atlassianAccountId = accountId === '' ? null : (0, $ljej9.toAccountId)(accountId);
    const isDevMode = getMetaImpl('ajs-dev-mode') === 'true';
    const firstActivationDateMs = $f94c92768d16d5bb$export$2fc3e4b3f0460c2f(getMetaImpl);
    const isDevopsProjectCreationScenario = getMetaImpl('ajs-devops-project-creation-scenario') === 'true';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const devopsProjectSignupSource = getMetaImpl('ajs-devops-signup-source-scenario');
    const isMarketingOptOut = getMetaImpl('ajs-marketing-opt-out') === 'true';
    const hasDlpEnabled = getMetaImpl('ajs-has-dlp') === 'true';
    const appUpdatesAvailable = $f94c92768d16d5bb$export$c3fee804514cdf76(getMetaImpl);
    const avpWorkspaceId = getMetaImpl('ajs-avp-workspace-id');
    return {
        appEditions: appEditions,
        applicationKey: applicationKey,
        appPermissions: appPermissions,
        appUpdatesAvailable: appUpdatesAvailable,
        areProductSuggestionsEnabled: areProductSuggestionsEnabled,
        atlassianAccountId: atlassianAccountId,
        cloudId: cloudId,
        orgId: getMetaImpl('ajs-org-id') ?? undefined,
        activationId: activationId,
        cloudName: cloudName,
        devopsProjectSignupSource: devopsProjectSignupSource,
        environment: environment,
        fabricActivityUrl: fabricActivityUrl,
        fabricNotificationLogUrl: fabricNotificationLogUrl,
        fabricPfDirUrl: fabricPfDirUrl,
        firstActivationDateMs: firstActivationDateMs,
        isAdmin: isAdmin,
        isAnonymous: isAnonymous,
        isDevMode: isDevMode,
        isDevopsProjectCreationScenario: isDevopsProjectCreationScenario,
        isMarketingOptOut: isMarketingOptOut,
        isSiteAdmin: isSiteAdmin,
        languageTag: languageTag,
        licensedProducts: licensedProducts,
        licenseStates: licenseStates,
        locale: locale,
        loggedInUser: loggedInUser,
        productCrossSellConfig: productCrossSellConfig,
        productEntitlementDetails: productEntitlementDetails,
        productPermissionGated: productPermissionGated,
        siteAdminStatus: siteAdminStatus,
        userFullname: userFullname,
        xsrfToken: xsrfToken,
        hasDlpEnabled: hasDlpEnabled,
        avpWorkspaceId: avpWorkspaceId
    };
};
const $f94c92768d16d5bb$export$374aeba69d52d74d = (0, $LFmXM.default)($f94c92768d16d5bb$var$getTenantContextFromMeta);

});
parcelRegister("jbr6p", function(module, exports) {
$parcel$export(module.exports, "defaultLocale", () => $b5efbc768eb416ed$export$d7f512c98c859244);
$parcel$export(module.exports, "default", () => $b5efbc768eb416ed$export$2e2bcd8739ae039);
$parcel$export(module.exports, "standardizeLocale", () => $b5efbc768eb416ed$export$ca06804549ae25fb);

var $l9VJB = parcelRequire("l9VJB");
const $b5efbc768eb416ed$export$d7f512c98c859244 = 'en_US';
const $b5efbc768eb416ed$export$a95850d20423e414 = 'fr_FR';
const $b5efbc768eb416ed$var$locales = Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($l9VJB)))).map((locale)=>locale.replace('-', '_'));
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$b5efbc768eb416ed$export$2e2bcd8739ae039 = $b5efbc768eb416ed$var$locales;
const $b5efbc768eb416ed$export$ca06804549ae25fb = (locale)=>locale.replace('_', '-');

});
parcelRegister("l9VJB", function(module, exports) {
module.exports = JSON.parse("{\"cs-CZ\":{},\"da-DK\":{},\"de-DE\":{},\"en-GB\":{},\"en-UK\":{},\"en-US\":{},\"en-ZZ\":{},\"es-ES\":{},\"et-EE\":{},\"fi-FI\":{},\"fr-FR\":{},\"hu-HU\":{},\"is-IS\":{},\"it-IT\":{},\"ja-JP\":{},\"ko-KR\":{},\"nb-NO\":{},\"nl-NL\":{},\"pl-PL\":{},\"pt-BR\":{},\"pt-PT\":{},\"ro-RO\":{},\"ru-RU\":{},\"sk-SK\":{},\"sv-SE\":{},\"tr-TR\":{},\"zh-CN\":{},\"zh-TW\":{}}");

});


parcelRegister("kIz4h", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c418e7a8ed99ac0$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/cookie

var $5H4WP = parcelRequire("5H4WP");
/**
 * Returns 'atlassian-token' aka xsrf required to secure some operation.
 *
 *
 * Security note: it is important to read from cookies - the same source backend will use to validate the operation
 * The attempt to read it from meta-data ('atlassian-token') resulted in Sev2 HOT-108450
 *
 * The cookie is a part of XSRF technology itself and is exempt from "safe cookies"/FedRAMP requirements.
 * The technology is based on one's ability to read the cookie and this is one it shall be preserved.
 *
 * There is ongoing work to migrate from legacy experiences that rely on this sort of protection
 * Until the work is not done, it shall stay untouched
 * See:
 *  - https://jplat.jira.atlassian.cloud/browse/ISSUEHELP-1198
 */ const $1c418e7a8ed99ac0$var$getXSRFToken = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($5H4WP))).get('atlassian.xsrf.token');
var $1c418e7a8ed99ac0$export$2e2bcd8739ae039 = $1c418e7a8ed99ac0$var$getXSRFToken;

});

parcelRegister("ljej9", function(module, exports) {
$parcel$export(module.exports, "toHref", () => $12bdcc55f096eaac$export$a54d91f6923c5464);
$parcel$export(module.exports, "toProjectId", () => $12bdcc55f096eaac$export$859c6c19231e0cae);
$parcel$export(module.exports, "toProjectIdArray", () => $12bdcc55f096eaac$export$4286301eed9f9657);
$parcel$export(module.exports, "toProjectUuid", () => $12bdcc55f096eaac$export$612bb41d73fb11e5);
$parcel$export(module.exports, "toIssueTypeUuid", () => $12bdcc55f096eaac$export$794befc4075c2835);
$parcel$export(module.exports, "toProjectKey", () => $12bdcc55f096eaac$export$cb2a92f44ebd7cbe);
$parcel$export(module.exports, "toIssueId", () => $12bdcc55f096eaac$export$a2c922a630ec0e8b);
$parcel$export(module.exports, "toIssueIdArray", () => $12bdcc55f096eaac$export$53d0e029b96060e8);
$parcel$export(module.exports, "toIssueKey", () => $12bdcc55f096eaac$export$aecb26efae237d79);
$parcel$export(module.exports, "toIssueStatusId", () => $12bdcc55f096eaac$export$f76742ae029c1fc8);
$parcel$export(module.exports, "toIssueStatusCategoryId", () => $12bdcc55f096eaac$export$b60f3955104deb9c);
$parcel$export(module.exports, "toIssueTypeId", () => $12bdcc55f096eaac$export$82d0d80d4e8f7071);
$parcel$export(module.exports, "toIssueTypeIdArray", () => $12bdcc55f096eaac$export$1e4024404d7db479);
$parcel$export(module.exports, "toVersionIdArray", () => $12bdcc55f096eaac$export$44dab0418964345a);
$parcel$export(module.exports, "toComponentIdArray", () => $12bdcc55f096eaac$export$52ef34d341740a97);
$parcel$export(module.exports, "toConfluencePageId", () => $12bdcc55f096eaac$export$c990339ab4d5fb8c);
$parcel$export(module.exports, "toRemoteLinkGlobalId", () => $12bdcc55f096eaac$export$ed362afc0734723b);
$parcel$export(module.exports, "toFailedRemoteLinkId", () => $12bdcc55f096eaac$export$fc6fd899c0ba114c);
$parcel$export(module.exports, "toWebLinkId", () => $12bdcc55f096eaac$export$f7c5e56dbe1fb);
$parcel$export(module.exports, "toUrlOrigin", () => $12bdcc55f096eaac$export$28cf3b03487f001b);
$parcel$export(module.exports, "toCloudId", () => $12bdcc55f096eaac$export$23d820b01683ce88);
$parcel$export(module.exports, "toDevopsProjectSignupSource", () => $12bdcc55f096eaac$export$da62a850b3644c3e);
$parcel$export(module.exports, "toActivationId", () => $12bdcc55f096eaac$export$31f624ce6ffbfb24);
$parcel$export(module.exports, "toCloudName", () => $12bdcc55f096eaac$export$fdaeb5e3e448929);
$parcel$export(module.exports, "toDisplayName", () => $12bdcc55f096eaac$export$1c60d924084a17b4);
$parcel$export(module.exports, "toAccountId", () => $12bdcc55f096eaac$export$ef1795c9a6f7e7ac);
$parcel$export(module.exports, "toAccountIdArray", () => $12bdcc55f096eaac$export$4c931bf2f36c0686);
$parcel$export(module.exports, "toTimeZone", () => $12bdcc55f096eaac$export$538b00033cc11c75);
$parcel$export(module.exports, "toFieldUuid", () => $12bdcc55f096eaac$export$57dcf8a3df2057f2);
$parcel$export(module.exports, "toOptionUuid", () => $12bdcc55f096eaac$export$ebcb2e81f79f291e);
$parcel$export(module.exports, "toStringArray", () => $12bdcc55f096eaac$export$1de82121cbe727f3);
$parcel$export(module.exports, "values", () => $12bdcc55f096eaac$export$68c286be0e7e55b7);
const $12bdcc55f096eaac$export$a54d91f6923c5464 = (value)=>value;
const $12bdcc55f096eaac$export$859c6c19231e0cae = (value)=>value;
const $12bdcc55f096eaac$export$4286301eed9f9657 = (ids)=>ids;
const $12bdcc55f096eaac$export$612bb41d73fb11e5 = (value)=>value;
const $12bdcc55f096eaac$export$794befc4075c2835 = (value)=>value;
const $12bdcc55f096eaac$export$cb2a92f44ebd7cbe = (value)=>value;
const $12bdcc55f096eaac$export$a2c922a630ec0e8b = (value)=>value;
const $12bdcc55f096eaac$export$53d0e029b96060e8 = (ids)=>ids;
const $12bdcc55f096eaac$export$aecb26efae237d79 = (value)=>value;
const $12bdcc55f096eaac$export$f76742ae029c1fc8 = (value)=>value;
const $12bdcc55f096eaac$export$b60f3955104deb9c = (value)=>value;
const $12bdcc55f096eaac$export$41c62847026740ac = (ids)=>ids;
const $12bdcc55f096eaac$export$82d0d80d4e8f7071 = (value)=>value;
const $12bdcc55f096eaac$export$1e4024404d7db479 = (ids)=>ids;
const $12bdcc55f096eaac$export$4a012c414e08ecc4 = (value)=>value;
const $12bdcc55f096eaac$export$44dab0418964345a = (ids)=>ids;
const $12bdcc55f096eaac$export$b68c3eacfb4600f5 = (value)=>value;
const $12bdcc55f096eaac$export$52ef34d341740a97 = (ids)=>ids;
const $12bdcc55f096eaac$export$c990339ab4d5fb8c = (value)=>value;
const $12bdcc55f096eaac$export$a6948b4337f07910 = (value)=>value;
const $12bdcc55f096eaac$export$ed362afc0734723b = (value)=>value;
const $12bdcc55f096eaac$export$fc6fd899c0ba114c = (value)=>value;
const $12bdcc55f096eaac$export$f7c5e56dbe1fb = (value)=>value;
const $12bdcc55f096eaac$export$28cf3b03487f001b = (value)=>value;
const $12bdcc55f096eaac$export$23d820b01683ce88 = (value)=>value;
const $12bdcc55f096eaac$export$da62a850b3644c3e = (value)=>value != null && value.length > 0 ? value : null;
const $12bdcc55f096eaac$export$31f624ce6ffbfb24 = (value)=>value;
const $12bdcc55f096eaac$export$fdaeb5e3e448929 = (value)=>value;
const $12bdcc55f096eaac$export$7b7196cdd6b82c61 = (value)=>value != null && value.length > 0 ? value : null;
const $12bdcc55f096eaac$export$1c60d924084a17b4 = (value)=>value;
const $12bdcc55f096eaac$export$ef1795c9a6f7e7ac = (value)=>value;
const $12bdcc55f096eaac$export$4c931bf2f36c0686 = (ids)=>ids;
const $12bdcc55f096eaac$export$538b00033cc11c75 = (value)=>value;
const $12bdcc55f096eaac$export$57dcf8a3df2057f2 = (value)=>value;
const $12bdcc55f096eaac$export$b6239e8adcb3a902 = (value)=>value;
const $12bdcc55f096eaac$export$ebcb2e81f79f291e = (value)=>value;
const $12bdcc55f096eaac$export$10e31d74b47a44fa = (value)=>value;
const $12bdcc55f096eaac$export$f84e8e69fd4488a5 = (value)=>value;
const $12bdcc55f096eaac$export$1de82121cbe727f3 = (arrayValues)=>arrayValues;
function $12bdcc55f096eaac$export$68c286be0e7e55b7(object) {
    // @ts-expect-error - TS2769 - No overload matches this call.
    return Object.values(object);
}

});

parcelRegister("5KtrL", function(module, exports) {
$parcel$export(module.exports, "LICENSE_STATE_ACTIVE", () => $8f57b5dc727d58b4$export$b1825e21241fc91);
$parcel$export(module.exports, "LICENSE_STATE_SUSPENDED", () => $8f57b5dc727d58b4$export$da47d37a794d21de);
$parcel$export(module.exports, "LICENSE_STATE_EXPIRED", () => $8f57b5dc727d58b4$export$7b174e57c0bd6a9c);
$parcel$export(module.exports, "LICENSE_STATE_UNLICENSED", () => $8f57b5dc727d58b4$export$2547e580661cf303);
$parcel$export(module.exports, "populateApplicationLicenseStates", () => $8f57b5dc727d58b4$export$d72e24da946cb239);
const $8f57b5dc727d58b4$export$b1825e21241fc91 = 'ACTIVE';
const $8f57b5dc727d58b4$export$da47d37a794d21de = 'SUSPENDED';
const $8f57b5dc727d58b4$export$7b174e57c0bd6a9c = 'EXPIRED';
const $8f57b5dc727d58b4$export$2547e580661cf303 = 'UNLICENSED';
const $8f57b5dc727d58b4$export$d72e24da946cb239 = (overrides = {}, defaultLicenseState = $8f57b5dc727d58b4$export$2547e580661cf303)=>({
        core: defaultLicenseState,
        software: defaultLicenseState,
        serviceDesk: defaultLicenseState,
        customerService: defaultLicenseState,
        productDiscovery: defaultLicenseState,
        ...overrides
    });

});

parcelRegister("dCptc", function(module, exports) {
$parcel$export(module.exports, "populateApplicationPermissions", () => $6387528062fc6074$export$4d9dffdb588381aa);
$parcel$export(module.exports, "toEnvironment", () => $6387528062fc6074$export$a69dcd7c1d779173);
const $6387528062fc6074$export$4d9dffdb588381aa = (overrides = {}, defaultPermission = false)=>({
        hasCoreAccess: defaultPermission,
        hasSoftwareAccess: defaultPermission,
        hasServiceDeskAccess: defaultPermission,
        hasCustomerServiceAccess: defaultPermission,
        hasProductDiscoveryAccess: defaultPermission,
        ...overrides
    });
const $6387528062fc6074$export$a69dcd7c1d779173 = (value)=>{
    switch(value){
        case 'dev':
            return 'dev';
        case 'staging':
            return 'staging';
        case 'prod':
            return 'prod';
        case 'local':
            return 'local';
        default:
            return null;
    }
};

});

parcelRegister("aFPNn", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ec3e537150500ab$export$2e2bcd8739ae039);

var $cblKs = parcelRequire("cblKs");
const $6ec3e537150500ab$var$parseTenantContextEdition = (tenantContextValue)=>{
    switch(tenantContextValue){
        case 'f':
            return 0, $cblKs.FREE_EDITION;
        case 's':
            return 0, $cblKs.STANDARD_EDITION;
        case 'p':
            return 0, $cblKs.PREMIUM_EDITION;
        default:
            return 0, $cblKs.UNLICENSED;
    }
};
const $6ec3e537150500ab$var$parseTenantContextEditions = (tenantContextEditions)=>(0, $cblKs.populateApplicationEditions)({
        core: $6ec3e537150500ab$var$parseTenantContextEdition(tenantContextEditions['jira-core']),
        software: $6ec3e537150500ab$var$parseTenantContextEdition(tenantContextEditions['jira-software']),
        serviceDesk: $6ec3e537150500ab$var$parseTenantContextEdition(tenantContextEditions['jira-servicedesk']),
        customerService: $6ec3e537150500ab$var$parseTenantContextEdition(tenantContextEditions['jira-customer-service']),
        productDiscovery: $6ec3e537150500ab$var$parseTenantContextEdition(tenantContextEditions['jira-product-discovery'])
    });
const $6ec3e537150500ab$var$determineApplicationEditions = (getMetaImpl)=>{
    try {
        const tenantContextEditions = JSON.parse(getMetaImpl('ajs-product-editions') || '{}');
        return $6ec3e537150500ab$var$parseTenantContextEditions(tenantContextEditions);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(`Error parsing application editions from tenant context: ${error}`);
        return (0, $cblKs.populateApplicationEditions)();
    }
};
var $6ec3e537150500ab$export$2e2bcd8739ae039 = $6ec3e537150500ab$var$determineApplicationEditions;

});
parcelRegister("cblKs", function(module, exports) {
$parcel$export(module.exports, "FREE_EDITION", () => $fb003bac48af88b4$export$e69af2c4378638a2);
$parcel$export(module.exports, "STANDARD_EDITION", () => $fb003bac48af88b4$export$7bc7dd5faba7ad6b);
$parcel$export(module.exports, "PREMIUM_EDITION", () => $fb003bac48af88b4$export$3fd0bbb8c68dc4c7);
$parcel$export(module.exports, "UNLICENSED", () => $fb003bac48af88b4$export$5747d23113da6aa6);
$parcel$export(module.exports, "STANDARD_EDITION_KEY", () => $fb003bac48af88b4$export$6ad005c3d13398a0);
$parcel$export(module.exports, "PREMIUM_EDITION_KEY", () => $fb003bac48af88b4$export$ee574a74f490a9e8);
$parcel$export(module.exports, "editionKeyToEdition", () => $fb003bac48af88b4$export$21d25cf944084a5e);
$parcel$export(module.exports, "editionToEditionKey", () => $fb003bac48af88b4$export$564d24f5605eb83d);
$parcel$export(module.exports, "populateApplicationEditions", () => $fb003bac48af88b4$export$6bdd11dc05a96fbd);
$parcel$export(module.exports, "getEdition", () => $fb003bac48af88b4$export$acf25cbc735b9b90);
$parcel$export(module.exports, "getEditionForProject", () => $fb003bac48af88b4$export$7f5fd5f8e6705012);
$parcel$export(module.exports, "toEdition", () => $fb003bac48af88b4$export$59f6e933a5e0096b);

var $lBYgs = parcelRequire("lBYgs");
const $fb003bac48af88b4$export$e69af2c4378638a2 = 'FREE_EDITION';
const $fb003bac48af88b4$export$7bc7dd5faba7ad6b = 'STANDARD_EDITION';
const $fb003bac48af88b4$export$3fd0bbb8c68dc4c7 = 'PREMIUM_EDITION';
const $fb003bac48af88b4$export$5747d23113da6aa6 = 'UNLICENSED';
const $fb003bac48af88b4$export$c8c756d9ef774404 = 'free';
const $fb003bac48af88b4$export$6ad005c3d13398a0 = 'standard';
const $fb003bac48af88b4$export$ee574a74f490a9e8 = 'premium';
const $fb003bac48af88b4$export$21d25cf944084a5e = (editionShort)=>{
    if (editionShort === $fb003bac48af88b4$export$c8c756d9ef774404) return $fb003bac48af88b4$export$e69af2c4378638a2;
    if (editionShort === $fb003bac48af88b4$export$6ad005c3d13398a0) return $fb003bac48af88b4$export$7bc7dd5faba7ad6b;
    if (editionShort === $fb003bac48af88b4$export$ee574a74f490a9e8) return $fb003bac48af88b4$export$3fd0bbb8c68dc4c7;
    return $fb003bac48af88b4$export$5747d23113da6aa6;
};
const $fb003bac48af88b4$export$564d24f5605eb83d = (edition)=>{
    switch(edition){
        case $fb003bac48af88b4$export$e69af2c4378638a2:
            return $fb003bac48af88b4$export$c8c756d9ef774404;
        case $fb003bac48af88b4$export$7bc7dd5faba7ad6b:
            return $fb003bac48af88b4$export$6ad005c3d13398a0;
        case $fb003bac48af88b4$export$3fd0bbb8c68dc4c7:
            return $fb003bac48af88b4$export$ee574a74f490a9e8;
        default:
            return undefined;
    }
};
const $fb003bac48af88b4$export$6bdd11dc05a96fbd = (overrides = {}, defaultEdition = $fb003bac48af88b4$export$5747d23113da6aa6)=>({
        core: defaultEdition,
        software: defaultEdition,
        serviceDesk: defaultEdition,
        customerService: defaultEdition,
        productDiscovery: defaultEdition,
        ...overrides
    });
const $fb003bac48af88b4$export$acf25cbc735b9b90 = (application, applicationEditions)=>{
    switch(application){
        case 0, $lBYgs.JIRA_CORE:
            return applicationEditions.core;
        case 0, $lBYgs.JIRA_SOFTWARE:
            return applicationEditions.software;
        case 0, $lBYgs.JIRA_PRODUCT_DISCOVERY:
            return applicationEditions.productDiscovery;
        case 0, $lBYgs.JIRA_SERVICE_DESK:
            return applicationEditions.serviceDesk;
        case 0, $lBYgs.JIRA_CUSTOMER_SERVICE:
            return applicationEditions.customerService;
        default:
            throw new Error(`Unrecognised application: ${application}`);
    }
};
const $fb003bac48af88b4$export$7f5fd5f8e6705012 = (projectType, applicationEditions)=>{
    const application = (0, $lBYgs.getApplicationForProject)(projectType);
    return $fb003bac48af88b4$export$acf25cbc735b9b90(application, applicationEditions);
};
const $fb003bac48af88b4$export$59f6e933a5e0096b = (edition)=>{
    switch(edition){
        case $fb003bac48af88b4$export$e69af2c4378638a2:
            return $fb003bac48af88b4$export$e69af2c4378638a2;
        case $fb003bac48af88b4$export$7bc7dd5faba7ad6b:
            return $fb003bac48af88b4$export$7bc7dd5faba7ad6b;
        case $fb003bac48af88b4$export$3fd0bbb8c68dc4c7:
            return $fb003bac48af88b4$export$3fd0bbb8c68dc4c7;
        case $fb003bac48af88b4$export$5747d23113da6aa6:
        default:
            return $fb003bac48af88b4$export$5747d23113da6aa6;
    }
};

});
parcelRegister("lBYgs", function(module, exports) {
$parcel$export(module.exports, "JIRA_PORTFOLIO", () => $ed4bb02d92cf03d1$export$29c4c091cb388ff0);
$parcel$export(module.exports, "JIRA_SERVICE_DESK", () => $ed4bb02d92cf03d1$export$3afc372bb8c4538c);
$parcel$export(module.exports, "JIRA_CUSTOMER_SERVICE", () => $ed4bb02d92cf03d1$export$19eb54cb466391c5);
$parcel$export(module.exports, "JIRA_SOFTWARE", () => $ed4bb02d92cf03d1$export$ad9850d60736acbb);
$parcel$export(module.exports, "JIRA_CORE", () => $ed4bb02d92cf03d1$export$66e37ea59188c0b8);
$parcel$export(module.exports, "JIRA_PRODUCT_DISCOVERY", () => $ed4bb02d92cf03d1$export$b6c5b3e2284b683b);
$parcel$export(module.exports, "getApplicationForProject", () => $ed4bb02d92cf03d1$export$3804df50ba7ca359);
const $ed4bb02d92cf03d1$export$29c4c091cb388ff0 = 'JIRA_PORTFOLIO';
const $ed4bb02d92cf03d1$export$3afc372bb8c4538c = 'JIRA_SERVICE_DESK';
const $ed4bb02d92cf03d1$export$19eb54cb466391c5 = 'JIRA_CUSTOMER_SERVICE';
const $ed4bb02d92cf03d1$export$ad9850d60736acbb = 'JIRA_SOFTWARE';
const $ed4bb02d92cf03d1$export$66e37ea59188c0b8 = 'JIRA_CORE';
const $ed4bb02d92cf03d1$export$b6c5b3e2284b683b = 'JIRA_PRODUCT_DISCOVERY';
const $ed4bb02d92cf03d1$export$3804df50ba7ca359 = (projectType)=>{
    switch(projectType){
        case 'business':
            return $ed4bb02d92cf03d1$export$66e37ea59188c0b8;
        case 'product_discovery':
            return $ed4bb02d92cf03d1$export$b6c5b3e2284b683b;
        case 'software':
            return $ed4bb02d92cf03d1$export$ad9850d60736acbb;
        case 'service_desk':
            return $ed4bb02d92cf03d1$export$3afc372bb8c4538c;
        case 'customer_service':
            return $ed4bb02d92cf03d1$export$19eb54cb466391c5;
        default:
            throw new Error(`Unrecognised project type: ${projectType}`);
    }
};
const $ed4bb02d92cf03d1$export$70d16cc42a798666 = (projectType)=>{
    switch(projectType){
        case 'business':
            return $ed4bb02d92cf03d1$export$66e37ea59188c0b8;
        case 'product_discovery':
            return $ed4bb02d92cf03d1$export$b6c5b3e2284b683b;
        case 'software':
            return $ed4bb02d92cf03d1$export$ad9850d60736acbb;
        case 'service_desk':
            return $ed4bb02d92cf03d1$export$3afc372bb8c4538c;
        case 'customer_service':
            return $ed4bb02d92cf03d1$export$19eb54cb466391c5;
        default:
            throw new Error(`Unrecognised project type: ${projectType}`);
    }
};

});



parcelRegister("cDvK0", function(module, exports) {
$parcel$export(module.exports, "default", () => $2af962fe8c6c42ce$export$2e2bcd8739ae039);

var $5KtrL = parcelRequire("5KtrL");
const $2af962fe8c6c42ce$var$parseTenantContextLicenseState = (tenantContextValue)=>{
    switch(tenantContextValue){
        case 'ACTIVE':
            return 0, $5KtrL.LICENSE_STATE_ACTIVE;
        case 'SUSPENDED':
            return 0, $5KtrL.LICENSE_STATE_SUSPENDED;
        case 'EXPIRED':
            return 0, $5KtrL.LICENSE_STATE_EXPIRED;
        default:
            return 0, $5KtrL.LICENSE_STATE_UNLICENSED;
    }
};
const $2af962fe8c6c42ce$var$parseTenantContextLicenseStates = (tenantContextLicenseStates)=>(0, $5KtrL.populateApplicationLicenseStates)({
        core: $2af962fe8c6c42ce$var$parseTenantContextLicenseState(tenantContextLicenseStates['jira-core']),
        software: $2af962fe8c6c42ce$var$parseTenantContextLicenseState(tenantContextLicenseStates['jira-software']),
        serviceDesk: $2af962fe8c6c42ce$var$parseTenantContextLicenseState(tenantContextLicenseStates['jira-servicedesk']),
        customerService: $2af962fe8c6c42ce$var$parseTenantContextLicenseState(tenantContextLicenseStates['jira-customer-service']),
        productDiscovery: $2af962fe8c6c42ce$var$parseTenantContextLicenseState(tenantContextLicenseStates['jira-product-discovery'])
    });
const $2af962fe8c6c42ce$var$determineApplicationLicenseStates = (getMetaImpl)=>{
    try {
        const tenantContextLicenseStates = JSON.parse(getMetaImpl('ajs-product-license-states') || '{}');
        return $2af962fe8c6c42ce$var$parseTenantContextLicenseStates(tenantContextLicenseStates);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(`Error parsing application license states from tenant context: ${error}`);
        return (0, $5KtrL.populateApplicationLicenseStates)();
    }
};
var $2af962fe8c6c42ce$export$2e2bcd8739ae039 = $2af962fe8c6c42ce$var$determineApplicationLicenseStates;

});

parcelRegister("8FAyk", function(module, exports) {
$parcel$export(module.exports, "default", () => $b3ee847faaab2d15$export$2e2bcd8739ae039);

// Fallback to true(not allowed) if product does not exist. This makes sense, because the tenant has no product.
// If user tries to somehow access the feature they are not supposed to access, it should be blocked.
const $b3ee847faaab2d15$var$parseProductPermissionGates = (productPermissionGatesRaw)=>({
        core: typeof productPermissionGatesRaw[0, $315aedf92e50a945$export$db515c8cec1e6f79] === 'boolean' ? productPermissionGatesRaw[0, $315aedf92e50a945$export$db515c8cec1e6f79] : true,
        software: typeof productPermissionGatesRaw[0, $315aedf92e50a945$export$1346c9aa3cbb477d] === 'boolean' ? productPermissionGatesRaw[0, $315aedf92e50a945$export$1346c9aa3cbb477d] : true,
        serviceDesk: typeof productPermissionGatesRaw[0, $315aedf92e50a945$export$c8c1c8c3f8ddba61] === 'boolean' ? productPermissionGatesRaw[0, $315aedf92e50a945$export$c8c1c8c3f8ddba61] : true,
        productDiscovery: typeof productPermissionGatesRaw[0, $315aedf92e50a945$export$202f50ee62667e32] === 'boolean' ? productPermissionGatesRaw[0, $315aedf92e50a945$export$202f50ee62667e32] : true,
        customerService: typeof productPermissionGatesRaw[0, $315aedf92e50a945$export$e9c56aa3b027d98f] === 'boolean' ? productPermissionGatesRaw[0, $315aedf92e50a945$export$e9c56aa3b027d98f] : true
    });
const $b3ee847faaab2d15$var$defaultProductPermissionGates = {
    core: true,
    software: true,
    serviceDesk: true,
    productDiscovery: true,
    customerService: true
};
const $b3ee847faaab2d15$var$getProductPermissionGates = (getMetaImpl)=>{
    try {
        const productPermissionGatesRaw = JSON.parse(getMetaImpl('ajs-product-permission-gates') || '{}');
        return $b3ee847faaab2d15$var$parseProductPermissionGates(productPermissionGatesRaw);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(`Error parsing product permission gates from tenant context: ${error}`);
        return $b3ee847faaab2d15$var$defaultProductPermissionGates;
    }
};
var $b3ee847faaab2d15$export$2e2bcd8739ae039 = $b3ee847faaab2d15$var$getProductPermissionGates;

});
const $315aedf92e50a945$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $315aedf92e50a945$export$e9c56aa3b027d98f = 'jira-customer-service';
const $315aedf92e50a945$export$1346c9aa3cbb477d = 'jira-software';
const $315aedf92e50a945$export$202f50ee62667e32 = 'jira-product-discovery';
const $315aedf92e50a945$export$db515c8cec1e6f79 = 'jira-core';
const $315aedf92e50a945$export$c811f21c9ad05dc2 = 'confluence';
const $315aedf92e50a945$export$961148c98d198270 = 'opsgenie';



parcelRegister("j0R8U", function(module, exports) {
$parcel$export(module.exports, "SERIALIZABLE_ATTRIBUTES", () => $3af37ab0f378bb05$export$b5bdb04ea16a02e3);
$parcel$export(module.exports, "normaliseSentryBreadcrumbs", () => $3af37ab0f378bb05$export$6f14342128c6eaa4);
const $3af37ab0f378bb05$export$b5bdb04ea16a02e3 = [
    'data-test-id',
    'data-testid'
];
const $3af37ab0f378bb05$var$WHITELISTED_ATTRIBNUTES = [
    'type',
    'name',
    ...$3af37ab0f378bb05$export$b5bdb04ea16a02e3
];
const $3af37ab0f378bb05$var$REG_MATCH_NOTALLOWED_ATTRIBUTES = new RegExp(`\\[(?!${$3af37ab0f378bb05$var$WHITELISTED_ATTRIBNUTES.join('|')}).*?\\]`, 'gm');
// attributes may contain UGC that we need to strip out
// only allow type and name attributes
const $3af37ab0f378bb05$var$sanitiseUiBreadcrumbMessage = (message)=>message.replace($3af37ab0f378bb05$var$REG_MATCH_NOTALLOWED_ATTRIBUTES, '');
const $3af37ab0f378bb05$export$6f14342128c6eaa4 = (breadcrumb)=>{
    const { category: category } = breadcrumb || {};
    // allow "ui*"" category breadcrumbs, that include clicks and inputs on DOM elements
    // they may contain UGC that needs to be stripped out
    if (category?.startsWith('ui')) {
        // sentry can include the element attributes in the data
        // which may contain UGC that we need to strip out
        const sanitisedBreadCrumb = breadcrumb;
        const { message: message } = sanitisedBreadCrumb;
        if (message !== null && message !== undefined) sanitisedBreadCrumb.message = $3af37ab0f378bb05$var$sanitiseUiBreadcrumbMessage(message);
        return breadcrumb;
    }
    return breadcrumb;
};

});

parcelRegister("1G7kx", function(module, exports) {
$parcel$export(module.exports, "normaliseSentryEvent", () => $d9f1d5f87a3a526b$export$c1a1d522906bf17c);

var $lpMrC = parcelRequire("lpMrC");

var $7jTnu = parcelRequire("7jTnu");

var $8KUFq = parcelRequire("8KUFq");

var $kQnVX = parcelRequire("kQnVX");

var $kkHo2 = parcelRequire("kkHo2");

var $2HRPu = parcelRequire("2HRPu");

var $evUkq = parcelRequire("evUkq");

var $4CmEX = parcelRequire("4CmEX");
const $d9f1d5f87a3a526b$var$REPORTED_ERRORS = new WeakSet();
const $d9f1d5f87a3a526b$var$REPORTED_STRING_ERRORS = new WeakSet();
const $d9f1d5f87a3a526b$var$getFragmentNames = (stackTrace)=>{
    const re = /(?:src\/entry|src|assets)\/([^,./]+)/g;
    const fragmentNames = new Set();
    let fragmentName = re.exec(stackTrace);
    while(fragmentName){
        fragmentNames.add(fragmentName[1]);
        fragmentName = re.exec(stackTrace);
    }
    return Array.from(fragmentNames);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d9f1d5f87a3a526b$var$getBackendStatus = (exception)=>exception.statusCode || exception.cause?.statusCode || exception.cause?.extensions?.statusCode || (0, $8KUFq.isBackendAPIError)(exception) && 'true' || 'false';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d9f1d5f87a3a526b$var$getTraceId = (exception)=>exception.traceId || exception.cause?.traceId || exception.cause?.extensions?.traceId || undefined;
// Add custom tags based on stack trace
const $d9f1d5f87a3a526b$var$getTaggedData = (data, hint, samplingResult)=>{
    if (!hint) return data;
    const exception = hint.originalException || hint.syntheticException;
    if (!exception) return data;
    if (typeof exception === 'string') return data;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const stackTrace = exception.stack;
    if (!stackTrace) return data;
    const taggedData = data;
    taggedData.tags = {
        backend: $d9f1d5f87a3a526b$var$getBackendStatus(exception),
        hash: (0, $2HRPu.getErrorHash)(exception),
        userLocation: (0, $kQnVX.getUserLocation)(),
        traceId: $d9f1d5f87a3a526b$var$getTraceId(exception),
        ...taggedData.tags
    };
    const fragmentNames = $d9f1d5f87a3a526b$var$getFragmentNames(stackTrace);
    if (!fragmentNames.length) taggedData.tags = {
        ...taggedData.tags,
        fragment: 'unknown'
    };
    else {
        taggedData.tags = {
            ...taggedData.tags,
            fragment: fragmentNames[0]
        };
        if (fragmentNames.length > 1) taggedData.extra = {
            ...taggedData.extra,
            allRelevantFragments: fragmentNames
        };
    }
    if (samplingResult && samplingResult.samplingRate !== null) // this tag indicates the true volume of the exception being sampled
    taggedData.tags.sampled = `1/${samplingResult.samplingRate}`;
    return taggedData;
};
/**
 * It's possible to receive an event with a string exception instead of an Error object.
 * This is typically the case when we catch a console.error.
 *
 * This function performs the same normalisation as `normaliseSentryEvent`, but only includes the steps that are relevant for strings
 */ const $d9f1d5f87a3a526b$var$normaliseStringException = (event, hint)=>{
    const exception = hint?.originalException;
    if (typeof exception !== 'string') return null;
    // If we are reporting an error with a logger tag and we already reported it, ignore
    if ($d9f1d5f87a3a526b$var$REPORTED_STRING_ERRORS.has(exception)) return null;
    if (event.tags?.logger) $d9f1d5f87a3a526b$var$REPORTED_STRING_ERRORS.add(exception);
    // Yes, we're mutating the argument, but at this point in the error handling lifecycle
    // immutability is not important and it simplifies the logic
    // Event type is documented here: https://github.com/getsentry/sentry-javascript/blob/master/packages/types/src/event.ts
    let updatedData = event;
    if (updatedData.request?.url) updatedData.request.url = (0, $kkHo2.default)(updatedData.request.url);
    updatedData = (0, $4CmEX.stackFrameAssetRewrite)(updatedData);
    const samplingResult = (0, $evUkq.default)(exception, updatedData.request?.url);
    // sample data sent to sentry if it matches the sampling config
    if (samplingResult.limitCaptureException) return null;
    updatedData.tags = {
        userLocation: (0, $kQnVX.getUserLocation)(),
        ...updatedData.tags
    };
    return updatedData;
};
const $d9f1d5f87a3a526b$export$c1a1d522906bf17c = (event, hint)=>{
    // We want to report only real exceptions, so we filter out everything that is non-error
    const exception = hint?.originalException;
    if (!event || event.environment === 'development') return null;
    if (typeof exception === 'string' && (0, $7jTnu.fg)('jira-capture-console-errors-in-sentry')) return $d9f1d5f87a3a526b$var$normaliseStringException(event, hint);
    if (!(exception instanceof Error)) return null;
    // Ignore errors coming from unsupported browsers (or faking it)
    const isSupportedUA = (0, $lpMrC.isChrome)(84) || (0, $lpMrC.isFirefox)(76) || (0, $lpMrC.isSafari)(15) || (0, $lpMrC.isEdge)(84);
    if (!('allSettled' in Promise) || !isSupportedUA) return null;
    // Ignore errors that explicitly want to skip Sentry
    if ('skipSentry' in exception && (exception.skipSentry === true || typeof exception.skipSentry === 'function' && exception.skipSentry())) return null;
    // Ignore network-like errors
    if ((0, $8KUFq.isClientFetchError)(exception)) return null;
    // If we are reporting an error with a logger tag and we already reported it, ignore
    if ($d9f1d5f87a3a526b$var$REPORTED_ERRORS.has(exception)) return null;
    if (event.tags?.logger) $d9f1d5f87a3a526b$var$REPORTED_ERRORS.add(exception);
    // Yes, we're mutating the argument, but at this point in the error handling lifecycle
    // immutability is not important and it simplifies the logic
    // Event type is documented here: https://github.com/getsentry/sentry-javascript/blob/master/packages/types/src/event.ts
    let updatedData = event;
    if (updatedData.request?.url) updatedData.request.url = (0, $kkHo2.default)(updatedData.request.url);
    updatedData = (0, $4CmEX.stackFrameAssetRewrite)(updatedData);
    let samplingResult = (0, $evUkq.default)(exception?.message, updatedData.request?.url);
    // sample data sent to sentry if it matches the sampling config
    if (samplingResult.limitCaptureException) return null;
    if ((0, $8KUFq.isBackendAPIError)(exception)) {
        // capture only 1/X of backend API errors
        const samplingRate = 20;
        samplingResult = {
            limitCaptureException: Math.random() <= 1 / samplingRate,
            samplingRate: samplingRate
        };
        if (samplingResult.limitCaptureException) return null;
    }
    updatedData = $d9f1d5f87a3a526b$var$getTaggedData(updatedData, hint, samplingResult);
    return updatedData;
};

});
parcelRegister("kkHo2", function(module, exports) {
$parcel$export(module.exports, "default", () => $408a97f936a5acec$export$2e2bcd8739ae039);

var $3Q6BV = parcelRequire("3Q6BV");

var $dVuvn = parcelRequire("dVuvn");
const $408a97f936a5acec$var$applyMatchers = (url, mappings)=>{
    for(let i = 0; i < mappings.length; i += 1){
        const mapping = mappings[i];
        if (!mapping.matcher) return mapping.transformer;
        const match = url.match(mapping.matcher);
        if (match) {
            if (typeof mapping.transformer === 'string') {
                if (match.length > 1) throw new Error('Grouped matcher requires a match => string transformer');
                return mapping.transformer;
            }
            if (match.length === 1) throw new Error('Basic matcher only supports a string transformer');
            return mapping.transformer(match);
        }
    }
    throw new Error('No URL mappers matched! Expected a default matcher.');
};
const $408a97f936a5acec$var$normaliseUrl = (url, mappings = (0, $dVuvn.default))=>{
    let parsedUrl;
    try {
        // This is a little bit of a hack, it's really hard to actually get `url-parse` to throw an
        // error, so instead we set the default base URL to be the fallback - if parsing fails the
        // fallback URL will be the parsed URL
        parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($3Q6BV)))(url, (0, $dVuvn.PARSE_ERROR_FALLBACK_URL));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (ex) {
        // we can't log the original URL or message because we could end up with UGC, so we return a
        // safe fallback URL so we don't lose the error
        return 0, $dVuvn.PARSE_ERROR_FALLBACK_URL;
    }
    const partialUrl = `${parsedUrl.pathname}${parsedUrl.query}`;
    const result = $408a97f936a5acec$var$applyMatchers(partialUrl, mappings);
    // For the purposes of normalisation, we assume we're only returning a path im the normalised URL
    return `${parsedUrl.protocol}//${parsedUrl.host}${result}`;
};
var $408a97f936a5acec$export$2e2bcd8739ae039 = $408a97f936a5acec$var$normaliseUrl;

});
parcelRegister("dVuvn", function(module, exports) {
$parcel$export(module.exports, "PARSE_ERROR_FALLBACK_URL", () => $8dffdd74c5c905e8$export$92f2182a552c2178);
$parcel$export(module.exports, "default", () => $8dffdd74c5c905e8$export$2e2bcd8739ae039);
const $8dffdd74c5c905e8$var$PARSE_ERROR_FALLBACK_PATH = '/could-not-parse/';
const $8dffdd74c5c905e8$export$92f2182a552c2178 = `https://unknown.example.com${$8dffdd74c5c905e8$var$PARSE_ERROR_FALLBACK_PATH}`;
const $8dffdd74c5c905e8$var$defaultMappings = [
    {
        matcher: /^\/browse\/.*/i,
        transformer: '/browse/:issueKey'
    },
    {
        matcher: /^\/project\/[A-Z][A-Z0-9]+\/issues/i,
        transformer: '/project/:projectKey/issues'
    },
    {
        matcher: /^\/jira\/software\/projects\/[A-Z][A-Z0-9]+\/issues/i,
        transformer: '/jira/software/projects/:projectKey/issues'
    },
    {
        matcher: /^\/jira\/software\/c\/projects\/[A-Z][A-Z0-9]+\/issues/i,
        transformer: '/jira/software/c/projects/:projectKey/issues'
    },
    {
        matcher: /^\/jira\/servicedesk\/projects\/[A-Z][A-Z0-9]+\/issues/i,
        transformer: '/jira/servicedesk/projects/:projectKey/issues'
    },
    {
        matcher: /^\/jira\/core\/projects\/[A-Z][A-Z0-9]+\/issues/i,
        transformer: '/jira/core/projects/:projectKey/issues'
    },
    {
        matcher: /^\/issues/i,
        transformer: '/issues'
    },
    {
        matcher: /^\/jira\/issues/i,
        transformer: '/jira/issues'
    },
    {
        matcher: /^\/jira\/software\/projects\/[A-Z][A-Z0-9]+\/boards\/\d+(\/backlog|\/roadmap|\/timeline)?/i,
        transformer: (match)=>`/jira/software/projects/:projectKey/boards/:boardId${match[1] ? match[1] : ''}`
    },
    {
        matcher: /^\/jira\/software\/c\/projects\/[A-Z][A-Z0-9]+\/boards\/\d+(\/roadmap|\/timeline)?/i,
        transformer: (match)=>`/jira/software/c/projects/:projectKey/boards/:boardId${match[1] ? match[1] : ''}`
    },
    {
        matcher: /^\/rest\/agile\/(.*?)\/board\/\d+\/configuration/i,
        transformer: (match)=>`/rest/agile/${match[1]}/board/:boardId/configuration`
    },
    {
        matcher: /^\/gateway\/api\/insights\/agile\/board\/\d+\/backlog\/sprint-commitment/i,
        transformer: '/gateway/api/insights/agile/board/:boardId/backlog/sprint-commitment'
    },
    {
        matcher: /^\/rest\/internal\/board\/\d+\/sprint\/\d+\/workload/i,
        transformer: '/rest/internal/board/:boardId/sprint/:sprintId/workload'
    },
    {
        matcher: /^\/rest\/internal\/board\/\d+\/sprint\/\d+\/sprint-progress/i,
        transformer: '/rest/internal/board/:boardId/sprint/:sprintId/sprint-progress'
    },
    {
        matcher: /^\/rest\/internal\/board\/\d+\/sprint\/\d+\/blocked-issues/i,
        transformer: '/rest/internal/board/:boardId/sprint/:sprintId/blocked-issues'
    },
    {
        matcher: /^\/rest\/internal\/board\/\d+\/sprint\/\d+\/epic-progress/i,
        transformer: '/rest/internal/board/:boardId/sprint/:sprintId/epic-progress'
    },
    {
        matcher: /^\/gateway\/api\/aris\/jira\/[a-f0-9-]+\/board\/\d+\/config/i,
        transformer: '/gateway/api/aris/jira/:cloudId/board/:boardId/config'
    },
    {
        matcher: /^\/gateway\/api\/jira-insights\/settings\/board\/\d+\/permissions\/board-admin/i,
        transformer: '/gateway/api/jira-insights/settings/board/:boardId/permissions/board-admin'
    },
    {
        matcher: /\/gateway\/api\/jira-insights\/settings\/board\/\d+/i,
        transformer: '/gateway/api/jira-insights/settings/board/:boardId'
    },
    {
        matcher: /^\/gateway\/api\/insights\/agile\/board\/\d+\/sprint\/\d+\/burndown/i,
        transformer: '/gateway/api/insights/agile/board/:boardId/sprint/:sprintId/burndown'
    },
    {
        matcher: /^\/jira\/servicedesk\/projects\/[A-Z][A-Z0-9]+\/queues\/custom\/\d+/i,
        transformer: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/:issueKey'
    },
    {
        matcher: /^\/jira\/servicedesk\/projects\/[A-Z][A-Z0-9]+\/section\/[A-Z]+\/custom\/\d+/i,
        transformer: '/jira/servicedesk/projects/:projectKey/section/:category/custom/:queueId/:issueKey'
    },
    {
        matcher: /^\/projects\/[A-Z][A-Z0-9]+\/settings(\/[a-z]+)?/i,
        transformer: (match)=>`/projects/settings${match[1] ? match[1] : ''}`
    },
    {
        matcher: /^\/projects\/[A-Z][A-Z0-9]+.*?selectedItem=com\.atlassian\.jira\.jira-projects-plugin:(\w+)/i,
        transformer: (match)=>`/projects/:projectKey?selectedItem=com.atlassian.jira.jira-projects-plugin:${match[1]}`
    },
    {
        matcher: /^\/secure\/ConfigureReport!default.jspa.*?reportKey=com.atlassian.jira.plugin.system.reports:(\w+)/i,
        transformer: (match)=>`/secure/ConfigureReport!default.jspa?reportKey=com.atlassian.jira.plugin.system.reports:${match[1]}`
    },
    {
        matcher: /^\/secure\/((.*?\/)?\w+.jspa)/i,
        transformer: (match)=>`/secure/${match[1]}`
    },
    {
        matcher: /^\/plugins\/servlet\/(\w+)/i,
        transformer: (match)=>`/plugins/servlet/${match[1]}`
    },
    {
        matcher: /^\/jira\/your-work/i,
        transformer: '/jira/your-work'
    },
    // Part of the hack around detecting invalid URLs, if we've parsed to the fallback URL, then
    // we return the fallback path instead of the generic "unknown" path
    {
        matcher: new RegExp($8dffdd74c5c905e8$var$PARSE_ERROR_FALLBACK_PATH),
        transformer: '/could-not-parse/'
    },
    {
        matcher: null,
        transformer: '/unknown'
    }
];
var $8dffdd74c5c905e8$export$2e2bcd8739ae039 = $8dffdd74c5c905e8$var$defaultMappings;

});


parcelRegister("2HRPu", function(module, exports) {
$parcel$export(module.exports, "getErrorHash", () => $b0ad33aceb23ae1d$export$211977f0fb53738b);
/* eslint-disable no-bitwise, no-fallthrough, default-case */ /**
 * JS Implementation of MurmurHash2
 * http://github.com/garycourt/murmurhash-js
 * http://sites.google.com/site/murmurhash/
 */ const $b0ad33aceb23ae1d$var$murmurHash2 = (str, seed = 1)=>{
    let l = str.length;
    let h = seed ^ l;
    let i = 0;
    let k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        // @ts-expect-error - TS7029 - Fallthrough case in switch.
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        // @ts-expect-error - TS7029 - Fallthrough case in switch.
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return h >>> 0;
};
const $b0ad33aceb23ae1d$export$156fa11ef8a619c3 = (stack)=>{
    const assetPaths = stack.match(/\/([\w.~\-_]+)\.[jt]sx?/g);
    const lineCols = stack.match(/:\d+:\d+/g);
    // uncomment this to get more specific paths
    // const uniquePaths = (assetPaths || [])
    //     .slice(0, 10)
    //     .reduce((acc, v) => {
    //         const [asset] = v.split(':');
    //         if (!acc.includes(asset)) acc.push(asset);
    //         return acc;
    //     }, [])
    //     .slice(1, 5);
    return (assetPaths?.[0] ?? '') + (lineCols?.[0] ?? '');
};
const $b0ad33aceb23ae1d$var$cache = new WeakMap();
const $b0ad33aceb23ae1d$export$211977f0fb53738b = (error)=>{
    if ($b0ad33aceb23ae1d$var$cache.has(error)) return $b0ad33aceb23ae1d$var$cache.get(error);
    let stackStr = '';
    if (error.stack !== undefined) try {
        stackStr = $b0ad33aceb23ae1d$export$156fa11ef8a619c3(error.stack);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    /* ignore */ }
    let errorString = `${error.name} ${stackStr || error.message}`;
    const hash = $b0ad33aceb23ae1d$var$murmurHash2(errorString).toString(36).toUpperCase();
    try {
        $b0ad33aceb23ae1d$var$cache.set(error, hash);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    /* ignore */ }
    return hash;
};

});

parcelRegister("evUkq", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e3115a51fb218b0$export$2e2bcd8739ae039);

var $jPROM = parcelRequire("jPROM");

var $iproh = parcelRequire("iproh");
const $6e3115a51fb218b0$var$checkForRuleMatch = (config, message, url)=>{
    const { matcher: matcher, route: route } = config;
    // Rule #1: no regex match on message
    if (!matcher.test(message || '')) return false;
    // Rule #2: If the config has a route specific condition
    if (route !== undefined) {
        // the sampling config requires the error originates from a certain route to be limited
        const matchesRoute = Boolean(url !== undefined && url.endsWith(route));
        if (!matchesRoute) return false;
    }
    return true;
};
// The Math.random produces a 0-1 number then multiplied by samplingRate
const $6e3115a51fb218b0$var$shouldLimit = (samplingRate)=>Math.floor(Math.random() * samplingRate) !== 0;
const $6e3115a51fb218b0$export$bb9cc46c6e38bd57 = (ruleSet, shouldLimitFn)=>(message, url)=>{
        // Find the matching config and store the rate, otherwise null
        const rule = ruleSet.find((config)=>$6e3115a51fb218b0$var$checkForRuleMatch(config, message, url));
        const samplingRate = !(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(rule) ? rule.samplingRate : null;
        return {
            limitCaptureException: !(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(samplingRate) ? shouldLimitFn(samplingRate) : false,
            samplingRate: samplingRate
        };
    };
var $6e3115a51fb218b0$export$2e2bcd8739ae039 = $6e3115a51fb218b0$export$bb9cc46c6e38bd57((0, $iproh.default), $6e3115a51fb218b0$var$shouldLimit);

});
parcelRegister("iproh", function(module, exports) {
$parcel$export(module.exports, "default", () => $37ffb0f424d16851$export$2e2bcd8739ae039);
/**
 * BEFORE adding a new sampling configuration:
 * - Ensure no recent change in volume for the error type
 * - Talk to the owners of the error. Confirm there is no other easy fix
 * - Create an issue to improve signal to noise for the error type
 */ const $37ffb0f424d16851$var$SENTRY_SAMPLING_CONFIG = [
    {
        // Ignore postrobot errors triggered by forge as team won't fix
        // https://atlassian.slack.com/archives/C03MMQ1B39V/p1671517439783989
        matcher: /postrobot_method/,
        samplingRate: 0
    },
    {
        // Ignore e.source.postMessage from monolith Connect JS as caused by callback on a closed window
        // https://atlassian.slack.com/archives/CFGTZ99TL/p1677032642940009
        matcher: /postMessage'\)/,
        samplingRate: 0
    },
    {
        // JFP-1542
        matcher: /^\[Frontend PubSub\] Failed to retrieve subscription configuration \[object Object\]$/,
        samplingRate: 10
    }
];
var $37ffb0f424d16851$export$2e2bcd8739ae039 = $37ffb0f424d16851$var$SENTRY_SAMPLING_CONFIG;

});


parcelRegister("4CmEX", function(module, exports) {
$parcel$export(module.exports, "stackFrameAssetRewrite", () => $101287bf08bd4da6$export$94684a7ef5037b24);
const $101287bf08bd4da6$export$94684a7ef5037b24 = (data)=>{
    // There isn't a strong type definition for the `data` object with
    // raven-js (it's literally `any`), so we have to do some shape validation to find the deep
    // part we're interested in (if it exists). We're also extra defensive by wrapping the whole
    // thing in a try/catch - if an error occurs we'll just return the data as-is.
    try {
        const rewriteStacktrace = (value)=>{
            if (!(value && value.stacktrace && value.stacktrace.frames && value.stacktrace.frames.length)) return;
            value.stacktrace.frames.forEach((frame)=>{
                if (!frame.filename) return;
                // Yes, we're manipulating the input, this is an implicit choice for this part
                // of the codebase
                // eslint-disable-next-line no-param-reassign
                frame.filename = frame.filename.replace('/assets-brotli/', '/assets/');
            });
        };
        // for non-error errors there can be a top-level `data.stacktrace`
        rewriteStacktrace(data);
        // for normal errors there can be exception.values, these might contain stacktraces
        if (!(data.exception && data.exception.values && data.exception.values.length)) return data;
        data.exception.values.forEach(rewriteStacktrace);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (ex) {
        // eslint-disable-next-line no-console
        console.warn('Unable to rewrite stacktrace filenames', ex);
    }
    return data;
};

});




parcelRegister("cWTNU", function(module, exports) {
$parcel$export(module.exports, "platformErrorHandler", () => $2f22b91c8c0fada5$export$51242f403a159805);

var $h47gY = parcelRequire("h47gY");
function $2f22b91c8c0fada5$export$51242f403a159805(payload) {
    (0, $h47gY.reportError)(payload.error, payload.errorInfo, {
        id: payload.interactionId
    });
}

});
parcelRegister("h47gY", function(module, exports) {
$parcel$export(module.exports, "reportError", () => $79fad3539deb3f94$export$b33b857ad1d9900e);
$parcel$export(module.exports, "default", () => $79fad3539deb3f94$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");

var $hya93 = parcelRequire("hya93");

var $eSnSE = parcelRequire("eSnSE");

var $2HRPu = parcelRequire("2HRPu");

var $es5G8 = parcelRequire("es5G8");

var $1uIew = parcelRequire("1uIew");

var $7jTnu = parcelRequire("7jTnu");

var $aK3Xl = parcelRequire("aK3Xl");
const $79fad3539deb3f94$var$EGRESS_LIMIT = 5;
const $79fad3539deb3f94$var$getLocation = ({ id: id, packageName: packageName, prefixOverride: prefixOverride })=>{
    const prefix = prefixOverride != null ? prefixOverride : 'common';
    if (id != null) return packageName != null ? `${prefix}.error-boundary.${packageName}.${id}` : `${prefix}.error-boundary.${id}`;
    return `${prefix}.error-boundary`;
};
const $79fad3539deb3f94$var$ErrorBoundary = (props)=>{
    const interactionId = (0, $eJOHy.useContext)((0, $kVpZx.default));
    const interactionContext = (0, $eJOHy.useContext)((0, $7aoMz.default));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($79fad3539deb3f94$export$4b4ea7be124cdbd8, {
        ...props,
        ufoInteractionId: interactionId.current,
        ufoLabelStack: interactionContext?.labelStack
    });
};
function $79fad3539deb3f94$export$b33b857ad1d9900e(error, info, { id: id, packageName: packageName, teamName: teamName, prefixOverride: prefixOverride, onError: onError, extraEventData: extraEventData = {} }, interactionId, labelStack) {
    // Somehow, the ErrorBoundary component catch an undefined error.
    // So this check helps to reduce the noise in our Sentry.
    const errorToReport = error ?? new (0, $aK3Xl.UnknownError)();
    const isFetchOrValidationError = errorToReport instanceof (0, $1uIew.default) || errorToReport instanceof (0, $1uIew.ValidationError);
    const errorStatusCode = isFetchOrValidationError && (0, $7jTnu.fg)('send_status_code_to_ufo') ? errorToReport.statusCode : undefined;
    const hash = (0, $2HRPu.getErrorHash)(errorToReport);
    const event = {
        teamName: teamName ?? null,
        ...extraEventData,
        message: errorToReport.message ?? null,
        stack: errorToReport.stack ?? null,
        // FIXME type "ErrorInfo" used to be mistyped but the type fix propagates in a non-trivial way,
        // cf. PR https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/137436/
        // Progress over perfection: I'm casting to keep the above PR type-only.
        // Next dev actively changing this code, please remove the type cast and use selective inclusion instead.
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        componentStack: info.componentStack,
        hash: hash ?? null
    };
    const location = $79fad3539deb3f94$var$getLocation({
        id: id,
        packageName: packageName,
        prefixOverride: prefixOverride
    });
    $79fad3539deb3f94$export$4b4ea7be124cdbd8.logErrorToSplunk(hash, location, event);
    (0, $es5G8.captureException)(location, errorToReport, // @ts-expect-error TS2345: Index signature for type string is missing in type ErrorInfo
    info);
    if (interactionId) (0, $7jTnu.fg)('obsrve-2504-add-errorhash-to-ufo-message') ? (0, $2QO3b.addError)(interactionId, `JSErrorBoundary:${id}`, labelStack || null, errorToReport.name, errorToReport.message, errorToReport.stack, undefined, hash, errorStatusCode && errorStatusCode) : (0, $2QO3b.addError)(interactionId, `JSErrorBoundary:${id}`, labelStack || null, errorToReport.name, errorToReport.message, errorToReport.stack, undefined, undefined, errorStatusCode && errorStatusCode);
    else (0, $7jTnu.fg)('obsrve-2504-add-errorhash-to-ufo-message') ? (0, $2QO3b.addErrorToAll)(`JSErrorBoundary:${id}`, labelStack || null, errorToReport.name, errorToReport.message, errorToReport.stack, hash, errorStatusCode && errorStatusCode) : (0, $2QO3b.addErrorToAll)(`JSErrorBoundary:${id}`, labelStack || null, errorToReport.name, errorToReport.message, errorToReport.stack, undefined, errorStatusCode && errorStatusCode);
    if (onError) onError(location, errorToReport, event);
}
class $79fad3539deb3f94$export$4b4ea7be124cdbd8 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            children: null,
            extraEventData: {},
            render: ()=>null,
            withExperienceTracker: false,
            onError: ()=>undefined,
            ufoInteractionId: null,
            ufoLabelStack: null
        };
    }
    static{
        // go/jfe-eslint
        // eslint-disable-next-line react/sort-comp
        this.errorFrequencyMap = new Map();
    }
    // go/jfe-eslint
    // eslint-disable-next-line react/sort-comp
    static logErrorToSplunk(hash, location, event) {
        let occurrences;
        if (hash !== undefined) {
            // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
            occurrences = (this.errorFrequencyMap.get(hash) ?? 0) + 1;
            // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
            this.errorFrequencyMap.set(hash, occurrences);
        } else // If there's no hash, treat it as the first time
        occurrences = 1;
        // Only send the error log if we are below the egress limit
        if (occurrences <= $79fad3539deb3f94$var$EGRESS_LIMIT) (0, $eSnSE.default).safeErrorWithoutCustomerData(location, 'Unhandled error caught by error boundary', event);
    }
    static getDerivedStateFromProps(props, state) {
        if (!!props.resetCaughtError && state.caughtError?.error === props.resetCaughtError) return {
            ...state,
            caughtError: null
        };
        return state;
    }
    componentDidCatch(error, info) {
        const { id: id, packageName: packageName, teamName: teamName, prefixOverride: prefixOverride, onError: onError, extraEventData: extraEventData } = this.props;
        this.setState({
            caughtError: {
                error: error,
                info: info
            }
        });
        // passing this.props will cause "'onError' PropType is defined but prop is never used" eslint error
        $79fad3539deb3f94$export$b33b857ad1d9900e(error, info, {
            id: id,
            packageName: packageName,
            teamName: teamName,
            prefixOverride: prefixOverride,
            onError: onError,
            extraEventData: extraEventData
        }, this.props.ufoInteractionId, this.props.ufoLabelStack);
    }
    render() {
        const { caughtError: caughtError } = this.state;
        const { children: children, render: renderFallback, withExperienceTracker: withExperienceTracker, extraEventData: extraEventData } = this.props;
        if (!caughtError) return children;
        const location = $79fad3539deb3f94$var$getLocation(this.props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, renderFallback({
            error: caughtError.error
        }), withExperienceTracker && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hya93.ExperienceFailureTracker), {
            location: location,
            failureEventAttributes: extraEventData
        }));
    }
    constructor(...args){
        super(...args), this.state = {
            caughtError: null
        };
    }
}
var $79fad3539deb3f94$export$2e2bcd8739ae039 = $79fad3539deb3f94$var$ErrorBoundary;

});
parcelRegister("hya93", function(module, exports) {
$parcel$export(module.exports, "ExperienceSuccessTracker", () => $3f86e7031e82fc54$export$b721eda798584098);
$parcel$export(module.exports, "ExperienceFailureTracker", () => $3f86e7031e82fc54$export$7877e129ff70728d);
$parcel$export(module.exports, "ExperienceAbortTracker", () => $3f86e7031e82fc54$export$69d4d8a5c14b1454);
$parcel$export(module.exports, "ExperienceResultFromPropsTracker", () => $3f86e7031e82fc54$export$be2c49f6982d0964);

var $eJOHy = parcelRequire("eJOHy");

var $1cD2y = parcelRequire("1cD2y");
class $3f86e7031e82fc54$export$3908b77264c263e4 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            hasSucceeded: false,
            hasFailed: false,
            hasAborted: false,
            children: null
        };
    }
    componentDidMount() {
        this.postRenderChecks();
    }
    componentDidUpdate() {
        this.postRenderChecks();
    }
    postRenderChecks() {
        const { onExperienceSuccess: onExperienceSuccess, onExperienceFailure: onExperienceFailure, onExperienceAbort: onExperienceAbort, hasSucceeded: hasSucceeded, hasFailed: hasFailed, hasAborted: hasAborted } = this.props;
        if (hasFailed) onExperienceFailure();
        else if (hasAborted) onExperienceAbort();
        else if (hasSucceeded) onExperienceSuccess();
    }
    render() {
        return this.props.children;
    }
}
const $3f86e7031e82fc54$export$5ffc4962dc653e10 = ({ onExperienceSuccess: onExperienceSuccess, onExperienceFailure: onExperienceFailure, onExperienceAbort: onExperienceAbort, hasSucceeded: hasSucceeded = false, hasFailed: hasFailed = false, hasAborted: hasAborted = false, children: children = null })=>{
    (0, $eJOHy.useEffect)(()=>{
        if (hasFailed) onExperienceFailure();
        else if (hasAborted) onExperienceAbort();
        else if (hasSucceeded) onExperienceSuccess();
    }, [
        hasSucceeded,
        hasFailed,
        hasAborted,
        onExperienceSuccess,
        onExperienceFailure,
        onExperienceAbort
    ]);
    return children;
};
const $3f86e7031e82fc54$export$2a8244c81400d030 = $3f86e7031e82fc54$export$5ffc4962dc653e10;
const $3f86e7031e82fc54$export$b721eda798584098 = ({ children: children, ...props })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1cD2y.ExperienceTracker), props, ({ onExperienceSuccess: onExperienceSuccess, onExperienceFailure: onExperienceFailure, onExperienceAbort: onExperienceAbort })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3f86e7031e82fc54$export$2a8244c81400d030, {
            hasSucceeded: true,
            onExperienceSuccess: onExperienceSuccess,
            onExperienceFailure: onExperienceFailure,
            onExperienceAbort: onExperienceAbort
        }, children));
$3f86e7031e82fc54$export$b721eda798584098.defaultProps = (0, $1cD2y.defaultProps);
const $3f86e7031e82fc54$export$7877e129ff70728d = ({ children: children, ...props })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1cD2y.ExperienceTracker), props, ({ onExperienceSuccess: onExperienceSuccess, onExperienceFailure: onExperienceFailure, onExperienceAbort: onExperienceAbort })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3f86e7031e82fc54$export$2a8244c81400d030, {
            hasFailed: true,
            onExperienceSuccess: onExperienceSuccess,
            onExperienceFailure: onExperienceFailure,
            onExperienceAbort: onExperienceAbort
        }, children));
$3f86e7031e82fc54$export$7877e129ff70728d.defaultProps = (0, $1cD2y.defaultProps);
const $3f86e7031e82fc54$export$69d4d8a5c14b1454 = ({ children: children, ...props })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1cD2y.ExperienceTracker), props, ({ onExperienceSuccess: onExperienceSuccess, onExperienceFailure: onExperienceFailure, onExperienceAbort: onExperienceAbort })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3f86e7031e82fc54$export$2a8244c81400d030, {
            hasAborted: true,
            onExperienceSuccess: onExperienceSuccess,
            onExperienceFailure: onExperienceFailure,
            onExperienceAbort: onExperienceAbort
        }, children));
$3f86e7031e82fc54$export$69d4d8a5c14b1454.defaultProps = (0, $1cD2y.defaultProps);
const $3f86e7031e82fc54$export$be2c49f6982d0964 = ({ hasSucceeded: hasSucceeded, hasFailed: hasFailed, hasAborted: hasAborted, children: children, ...trackerProps })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1cD2y.ExperienceTracker), trackerProps, ({ onExperienceSuccess: onExperienceSuccess, onExperienceFailure: onExperienceFailure, onExperienceAbort: onExperienceAbort })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3f86e7031e82fc54$export$2a8244c81400d030, {
            hasSucceeded: hasSucceeded,
            hasFailed: hasFailed,
            hasAborted: hasAborted,
            onExperienceSuccess: onExperienceSuccess,
            onExperienceFailure: onExperienceFailure,
            onExperienceAbort: onExperienceAbort
        }, children));
$3f86e7031e82fc54$export$be2c49f6982d0964.defaultProps = {
    hasSucceeded: false,
    hasFailed: false,
    hasAborted: false,
    ...(0, $1cD2y.defaultProps)
};

});
parcelRegister("1cD2y", function(module, exports) {
$parcel$export(module.exports, "defaultProps", () => $389c50de354f6b6f$export$9c21a3269931e1e6);
$parcel$export(module.exports, "ExperienceTracker", () => $389c50de354f6b6f$export$12b6b072930fd68f);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $eSnSE = parcelRequire("eSnSE");

var $6DllT = parcelRequire("6DllT");

var $e5QGj = parcelRequire("e5QGj");
const $389c50de354f6b6f$export$9c21a3269931e1e6 = {
    failureEventAttributes: null,
    parentProviders: null,
    children: null
};
const $389c50de354f6b6f$export$12b6b072930fd68f = ({ children: children, ...props })=>{
    const context = (0, $eJOHy.useContext)((0, $6DllT.default));
    (0, $eJOHy.useEffect)(()=>{
        if (context === null) (0, $eSnSE.default).safeErrorWithoutCustomerData('experience-tracker.missing-provider', 'Experience tracker rendered without a provider');
    }, [
        context
    ]);
    if (context == null || false) return typeof children === 'function' ? children({
        onExperienceSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        onExperienceFailure: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        onExperienceAbort: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e5QGj.default), {
        location: props.location,
        experienceContext: context,
        failureEventAttributes: props.failureEventAttributes,
        parentProvidersWhitelist: props.parentProviders
    }, children);
};
$389c50de354f6b6f$export$12b6b072930fd68f.defaultProps = $389c50de354f6b6f$export$9c21a3269931e1e6;

});
parcelRegister("6DllT", function(module, exports) {
$parcel$export(module.exports, "default", () => $a75a38c680cd51ff$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
var $a75a38c680cd51ff$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.createContext)(null);

});

parcelRegister("e5QGj", function(module, exports) {
$parcel$export(module.exports, "default", () => $63591557644dfb5c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8KUFq = parcelRequire("8KUFq");
class $63591557644dfb5c$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    constructor(props){
        super(props), this.onSuccess = ()=>{
            // This guards against the possibility of the child calling `onExperienceSuccess` repeatedly.
            if (!this.hasSignalledSuccess && this.isReportingToCurrentProvider()) {
                this.hasSignalledSuccess = true;
                this.props.experienceContext.consumerCallbacks.onSuccess();
            }
        }, this.onFailure = (locationSuffix, extraFailureEventAttributes)=>{
            const { experienceContext: { consumerCallbacks: { onFailure: onFailure } }, location: location, failureEventAttributes: failureEventAttributes } = this.props;
            if (!this.hasSignalledFailure && this.isReportingToCurrentProvider()) {
                this.hasSignalledFailure = true;
                const concatenatedLocation = locationSuffix == null ? location : `${location}.${locationSuffix}`;
                const mergedFailureAttributes = {
                    ...extraFailureEventAttributes,
                    ...failureEventAttributes
                };
                onFailure(concatenatedLocation, mergedFailureAttributes);
            }
        }, this.onAbort = (locationSuffix, extraFailureEventAttributes)=>{
            const { experienceContext: { consumerCallbacks: { onAbort: onAbort } }, location: location, failureEventAttributes: failureEventAttributes } = this.props;
            if (!this.hasSignalledFailure && this.isReportingToCurrentProvider()) {
                this.hasSignalledFailure = true;
                const concatenatedLocation = locationSuffix == null ? location : `${location}.${locationSuffix}`;
                const mergedFailureAttributes = {
                    ...extraFailureEventAttributes,
                    ...failureEventAttributes
                };
                onAbort(concatenatedLocation, mergedFailureAttributes);
            }
        };
        this.resetTracker();
    }
    componentDidCatch(error) {
        if (!(0, $8KUFq.isClientFetchError)(error)) this.onFailure(undefined, {
            errorMessage: error.message
        });
        // We're deliberately rethrowing the error here because we don't want to interfere with
        // any error handling the container app may have in place. This app exists only to track
        // error/success metrics; we don't want to interfere with the app that's actually rendering UI.
        throw error;
    }
    isReportingToCurrentProvider() {
        const { experience: experience } = this.props.experienceContext;
        return(// parentProviders is an OPTIONAL whitelist. If not specified, then we are definitely reporting to the current experience
        this.parentProvidersWhitelistSet == null || // otherwise make sure we are currently in one of the listed experiences
        this.parentProvidersWhitelistSet.has(experience));
    }
    // Resetting must not call setState since this can be executed in the render phase
    resetTracker() {
        this.hasSignalledFailure = false;
        this.hasSignalledSuccess = false;
        this.lastExperienceId = this.props.experienceContext.experienceId;
        // Must only respect updates to `parentProvidersWhitelist` when the experience resets, otherwise weird bugs can arise.
        // Eg: a component could call onSuccess when it never called onPending, this would result in premature experience successes.
        this.parentProvidersWhitelistSet = this.props.parentProvidersWhitelist ? new Set(this.props.parentProvidersWhitelist) : null;
        this.isReportingToCurrentProvider() && this.props.experienceContext.consumerCallbacks.onPending();
    }
    // Check every render to reset the experience state instance variables
    checkExperienceIdForExperienceReset() {
        if (this.lastExperienceId !== this.props.experienceContext.experienceId) this.resetTracker();
    }
    render() {
        this.checkExperienceIdForExperienceReset();
        const { children: children } = this.props;
        return typeof children === 'function' ? children({
            onExperienceSuccess: this.onSuccess,
            onExperienceFailure: this.onFailure,
            onExperienceAbort: this.onAbort
        }) : children;
    }
}

});



parcelRegister("aK3Xl", function(module, exports) {
$parcel$export(module.exports, "UnknownError", () => $63e5072b60ba1eed$export$ff4405149dbd0c5c);
class $63e5072b60ba1eed$export$ff4405149dbd0c5c extends Error {
    constructor(){
        super();
        this.name = 'UnknownError';
        this.message = 'There is something wrong and ErrorBoundary component catch an undefined error.';
    }
}

});




parcelRegister("2I68T", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "AnalyticsProviders", () => $d9f06bf69bc5bb00$export$fe99df39f319f93e);
$parcel$export(module.exports, "default", () => $d9f06bf69bc5bb00$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $l7Alo = parcelRequire("l7Alo");

var $eSnSE = parcelRequire("eSnSE");

var $4xbv3 = parcelRequire("4xbv3");

var $g9Vr6 = parcelRequire("g9Vr6");

var $lvKO5 = parcelRequire("lvKO5");

var $hWeHP = parcelRequire("hWeHP");

var $exfGR = parcelRequire("exfGR");

var $HpPtH = parcelRequire("HpPtH");
const $d9f06bf69bc5bb00$export$fe99df39f319f93e = ({ children: children })=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    (0, $eJOHy.useEffect)(()=>{
        if (false) return;
        try {
            const success = (0, $exfGR.default)({
                ...tenantContext,
                orgId: orgId
            });
            if (success === undefined) throw new Error('observability.analytics-providers-error: @atlassiansox/analytics-web-client AnalyticsClient in src/common/analytics-web-react/web-client/index.js failed to initialise successfully');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData('observability.analytics-providers.analytics', e);
        }
    }, [
        orgId,
        tenantContext
    ]);
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
    // Temporary analytics for our experiment
    const mobileAnalytics = {
        isMobileUserAgent: (0, $l7Alo.isSupportedUserAgent)(),
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        userAgent: navigator?.userAgent
    };
    /**
	 * As per Jira: Incident Detection and Reliability Uplift we need to add shard and region to the analytics context
	 * This will add shard and region to all analytics events fired throughout the application
	 * we check for false above to ensure SSR does not break with getMeta()
	 */ const shardAndRegionAnalytics = {
        shard: (0, $hWeHP.default)('ajs-shard') || '',
        region: (0, $hWeHP.default)('ajs-region') || ''
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $HpPtH.JiraStructuredAnalyticsListener), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        attributes: {
            isSPA: __SPA__,
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            variant: window.BUILD_VARIANT,
            ...mobileAnalytics,
            ...shardAndRegionAnalytics
        }
    }, children));
};
var $d9f06bf69bc5bb00$export$2e2bcd8739ae039 = $d9f06bf69bc5bb00$export$fe99df39f319f93e;

});
parcelRegister("l7Alo", function(module, exports) {
$parcel$export(module.exports, "isSupportedUserAgent", () => $e711cf9145d67cc9$export$2b0f0a801c573b06);
$parcel$export(module.exports, "isAndroidUserAgent", () => $e711cf9145d67cc9$export$6053d3a1e6477e0f);
$parcel$export(module.exports, "isTabletUserAgent", () => $e711cf9145d67cc9$export$a33e336659bb3eb6);
$parcel$export(module.exports, "shouldShowReturnToMobileBanner", () => $e711cf9145d67cc9$export$604401c0b63e5273);
$parcel$export(module.exports, "shouldShowReturnToMobileBannerMobileMvp", () => $e711cf9145d67cc9$export$511710677ef866);
$parcel$export(module.exports, "shouldShowDismissButton", () => $e711cf9145d67cc9$export$5ad7f0440f4fd036);
$parcel$export(module.exports, "determineOperatingSystemAttribute", () => $e711cf9145d67cc9$export$d9f2497f8d710783);
$parcel$export(module.exports, "default", () => $e711cf9145d67cc9$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/cookie -- This reduced TS complexity by 3,114,190 across Jira

var $5H4WP = parcelRequire("5H4WP");
/*
This logic was ported from MobileUtils class from jira monolith to
provide the same conditions for checking whether the user agent is mobile or not.
*/ const $e711cf9145d67cc9$var$DESKTOP_SWITCH_COOKIE_KEY = 'jira.mobile.desktop.switch';
const $e711cf9145d67cc9$var$MOBILE_USER_AGENT = new RegExp('(iPhone;|iPhone Simulator;|iPad;|iPod;|iPod touch|Android)');
const $e711cf9145d67cc9$var$MOBILE_STRING_IN_USER_AGENT = new RegExp('Mobile');
const $e711cf9145d67cc9$var$IPAD_USER_AGENT = new RegExp('iPad;');
const $e711cf9145d67cc9$var$IOS_USER_AGENT = new RegExp('(iPhone;|iPad;|iPod;)');
const $e711cf9145d67cc9$var$ANDROID_USER_AGENT = new RegExp('Android');
// This regex matches the following iOS rendering engines:
// 1. Chrome for iOS
// 2. Firefox for iOS
// 3. Edge for iOS
const $e711cf9145d67cc9$var$NON_SAFARI_IOS_RENDERING_ENGINE_USER_AGENT = new RegExp('CriOS|FxiOS|EdgiOS');
const $e711cf9145d67cc9$export$2b0f0a801c573b06 = ()=>{
    if (false) return false;
    if (!globalThis.navigator?.userAgent.length) return false;
    const isMobile = $e711cf9145d67cc9$var$MOBILE_USER_AGENT.test(globalThis.navigator?.userAgent);
    return isMobile;
};
const $e711cf9145d67cc9$export$6053d3a1e6477e0f = ()=>{
    return $e711cf9145d67cc9$var$ANDROID_USER_AGENT.test(globalThis.navigator?.userAgent);
};
const $e711cf9145d67cc9$export$b4161aa2f4036482 = ()=>$e711cf9145d67cc9$var$IOS_USER_AGENT.test(globalThis.navigator?.userAgent);
const $e711cf9145d67cc9$export$a33e336659bb3eb6 = ()=>{
    if (!globalThis.navigator?.userAgent.length) return false;
    return $e711cf9145d67cc9$var$IPAD_USER_AGENT.test(globalThis.navigator?.userAgent) || $e711cf9145d67cc9$export$6053d3a1e6477e0f() && !$e711cf9145d67cc9$var$MOBILE_STRING_IN_USER_AGENT.test(globalThis.navigator?.userAgent);
};
const $e711cf9145d67cc9$var$isDesktopSwitchEnabled = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($5H4WP))).get($e711cf9145d67cc9$var$DESKTOP_SWITCH_COOKIE_KEY) === 'true';
const $e711cf9145d67cc9$var$isMobileUserAgent = ()=>$e711cf9145d67cc9$export$2b0f0a801c573b06() && !$e711cf9145d67cc9$var$isDesktopSwitchEnabled();
const $e711cf9145d67cc9$export$1cb1de725ba5b3e3 = ()=>{
    if (typeof navigator === 'undefined') return false;
    return $e711cf9145d67cc9$export$b4161aa2f4036482() && !$e711cf9145d67cc9$var$NON_SAFARI_IOS_RENDERING_ENGINE_USER_AGENT.test(globalThis.navigator?.userAgent);
};
const $e711cf9145d67cc9$export$604401c0b63e5273 = ()=>$e711cf9145d67cc9$export$2b0f0a801c573b06();
const $e711cf9145d67cc9$export$511710677ef866 = ()=>{
    return $e711cf9145d67cc9$export$2b0f0a801c573b06() && !$e711cf9145d67cc9$export$1cb1de725ba5b3e3();
};
const $e711cf9145d67cc9$export$5ad7f0440f4fd036 = ()=>$e711cf9145d67cc9$export$604401c0b63e5273() && $e711cf9145d67cc9$export$a33e336659bb3eb6();
const $e711cf9145d67cc9$export$d9f2497f8d710783 = ()=>{
    if ($e711cf9145d67cc9$export$b4161aa2f4036482()) return 'ios';
    if ($e711cf9145d67cc9$export$6053d3a1e6477e0f()) return 'android';
    return 'other';
};
var $e711cf9145d67cc9$export$2e2bcd8739ae039 = $e711cf9145d67cc9$var$isMobileUserAgent;

});

parcelRegister("4xbv3", function(module, exports) {
$parcel$export(module.exports, "extractContextualData", () => $f0336f200c3c464c$export$dc30f43798194b03);
$parcel$export(module.exports, "ContextualAnalyticsData", () => $f0336f200c3c464c$export$198470770171c65);
/**
 * This library is the only place where you'd use raw AnalyticsContext
 * It provides a typed wrapper around it for better user experience
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $6dPbw = parcelRequire("6dPbw");

var $4lYQk = parcelRequire("4lYQk");

var $e2B2h = parcelRequire("e2B2h");
const $f0336f200c3c464c$export$dc30f43798194b03 = (props)=>{
    const { children: children, sourceName: sourceName, sourceType: sourceType, ...rest } = props;
    const source = sourceName && sourceType ? `${sourceName}${sourceType}` : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($4lYQk)))({
        source: source,
        ...rest
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6dPbw))));
};
const $f0336f200c3c464c$export$198470770171c65 = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>{
    const data = $f0336f200c3c464c$export$dc30f43798194b03(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e2B2h.default), {
        data: data
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.children));
});

});

parcelRegister("g9Vr6", function(module, exports) {
$parcel$export(module.exports, "useOrgId", () => $015f4ca0131950ab$export$52a03a3207af3687);
// eslint-disable-next-line jira/import-whitelist

var $hWeHP = parcelRequire("hWeHP");
const $015f4ca0131950ab$export$52a03a3207af3687 = ()=>{
    const orgId = (0, $hWeHP.default)('ajs-org-id');
    return {
        data: orgId || undefined
    };
};

});

parcelRegister("lvKO5", function(module, exports) {
$parcel$export(module.exports, "TenantContextContainer", () => $a7c6e40d3f54987c$export$8b5d54c1fa2f746f);
$parcel$export(module.exports, "TenantContextSubscriber", () => $a7c6e40d3f54987c$export$9d1e1d1d0f8eeb35);
$parcel$export(module.exports, "useTenantContext", () => $a7c6e40d3f54987c$export$28e7c557f4d454d9);

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $ht3nQ = parcelRequire("ht3nQ");

var $ehEmN = parcelRequire("ehEmN");

var $7NgPv = parcelRequire("7NgPv");
const $a7c6e40d3f54987c$export$8b5d54c1fa2f746f = (0, $6E16M.createContainer)((0, $7NgPv.default), {
    onInit: ()=>({ dispatch: dispatch })=>dispatch($ehEmN.bootstrap())
});
const $a7c6e40d3f54987c$export$9d1e1d1d0f8eeb35 = (0, $ht3nQ.createSubscriber)((0, $7NgPv.default), {
    displayName: 'TenantContextSubscriber'
});
const $a7c6e40d3f54987c$export$b24a99788063c041 = (0, $iJq0l.createHook)((0, $7NgPv.default));
const $a7c6e40d3f54987c$export$28e7c557f4d454d9 = ()=>{
    const [{ tenantContext: tenantContext }] = $a7c6e40d3f54987c$export$b24a99788063c041();
    return tenantContext;
};

});
parcelRegister("ehEmN", function(module, exports) {
$parcel$export(module.exports, "bootstrap", () => $af9cd2aa62c3010f$export$36aff1fbb4f5dfc6);

var $aYncF = parcelRequire("aYncF");
const $af9cd2aa62c3010f$export$36aff1fbb4f5dfc6 = ()=>({ setState: setState, getState: getState }, { getMeta: getMeta })=>{
        if (getState().tenantContext) return;
        const tenantContext = (0, $aYncF.getTenantContext_DEPRECATED_DO_NOT_USE)(getMeta);
        setState({
            tenantContext: tenantContext
        });
    };

});

parcelRegister("7NgPv", function(module, exports) {
$parcel$export(module.exports, "default", () => $7cba2d3dc2fa84fa$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $GtRbT = parcelRequire("GtRbT");

var $ehEmN = parcelRequire("ehEmN");
// @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'TenantContext'.
const $7cba2d3dc2fa84fa$var$initialState = {
    tenantContext: null
};
var $7cba2d3dc2fa84fa$export$2e2bcd8739ae039 = (0, $GtRbT.createStore)({
    name: 'tenantContext',
    initialState: $7cba2d3dc2fa84fa$var$initialState,
    actions: $ehEmN
});

});


parcelRegister("exfGR", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d38cd8f7368fef3$export$2e2bcd8739ae039);

var $5G60L = parcelRequire("5G60L");

var $jI4f2 = parcelRequire("jI4f2");

var $64sVH = parcelRequire("64sVH");

var $dsexO = parcelRequire("dsexO");

var $eXiXf = parcelRequire("eXiXf");
/**
 * Initializes the analytics web client with configuration tailored to the user and product environment.
 * It dynamically adjusts settings based on user and organizational details to enhance product analytics.
 */ const $5d38cd8f7368fef3$var$initAnalytics = ({ cloudId: cloudId, cloudName: cloudName, atlassianAccountId: atlassianAccountId, environment: environment, locale: locale, orgId: orgId, activationId: workspaceId })=>(0, $5G60L.initAnalyticsWebClient)({
        tenantId: cloudId,
        ...atlassianAccountId ? {
            userId: atlassianAccountId
        } : undefined,
        ...orgId && {
            orgId: orgId
        },
        ...workspaceId && {
            workspaceId: workspaceId
        },
        product: 'jira',
        environment: environment === 'prod' ? 'prod' : (0, $dsexO.default)({
            cloudId: cloudId,
            cloudName: cloudName,
            environment: environment
        }),
        callback: (0, $eXiXf.logEmau),
        subProduct: (0, $64sVH.default),
        solutions: (0, $jI4f2.default)(),
        locale: locale
    });
var $5d38cd8f7368fef3$export$2e2bcd8739ae039 = $5d38cd8f7368fef3$var$initAnalytics;

});
parcelRegister("jI4f2", function(module, exports) {
$parcel$export(module.exports, "default", () => $8722081fb7c8f225$export$2e2bcd8739ae039);


var $64sVH = parcelRequire("64sVH");
const $8722081fb7c8f225$var$getApplicationSolutions = ()=>(0, $64sVH.default)() === 'serviceDesk' ? [
        (0, $99993c16fc53d6ec$export$c8b406ad8ee0dab9)
    ] : undefined;
var $8722081fb7c8f225$export$2e2bcd8739ae039 = $8722081fb7c8f225$var$getApplicationSolutions;

});
const $99993c16fc53d6ec$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';

parcelRegister("64sVH", function(module, exports) {
$parcel$export(module.exports, "default", () => $bbe8b34c7e980538$export$2e2bcd8739ae039);

var $hWeHP = parcelRequire("hWeHP");

var $jfEiR = parcelRequire("jfEiR");
const $bbe8b34c7e980538$var$getApplicationSubProduct = ()=>(0, $jfEiR.default)((0, $hWeHP.default)('ajs-application-key'));
var $bbe8b34c7e980538$export$2e2bcd8739ae039 = $bbe8b34c7e980538$var$getApplicationSubProduct;

});
parcelRegister("jfEiR", function(module, exports) {
$parcel$export(module.exports, "default", () => $8df0db037eae1be8$export$2e2bcd8739ae039);
/**
 * Transforms sub-product identifiers into a simplified or generic form, providing
 * a default when unspecified. This aids in standardizing the representation of
 * sub-product names across different contexts.
 */ const $8df0db037eae1be8$var$transformSubProducts = (subProduct)=>{
    if (!subProduct) return 'unknown';
    if (subProduct === 'family') return 'platform';
    if (subProduct === 'jira-servicedesk') return 'serviceDesk';
    if (subProduct.startsWith('jira-')) return subProduct.replace('jira-', '');
    return subProduct;
};
var $8df0db037eae1be8$export$2e2bcd8739ae039 = $8df0db037eae1be8$var$transformSubProducts;

});



parcelRegister("dsexO", function(module, exports) {
$parcel$export(module.exports, "default", () => $294900c9ed7c0df9$export$2e2bcd8739ae039);
// MR - stands for the atlassian monorepo prefix
const $294900c9ed7c0df9$var$isOverridingFragments = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    !!(window?.BUILD_KEY && !/^(?:MR)?JF-PROD-\d+$/.test(window.BUILD_KEY));
const $294900c9ed7c0df9$var$isOverridingSsr = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    !!(window?.SSR_BUILD_KEY && !/^(?:MR)?JF-PROD-\d+$/i.test(window.SSR_BUILD_KEY));
const $294900c9ed7c0df9$var$isVoltExplore = ({ cloudId: cloudId, cloudName: cloudName })=>/^(TEST--)/.test(cloudId) && /^(atl-vertigo--jira-jira-branch)/.test(cloudName);
/**
 * Selects the 'staging' environment under specific conditions, defaulting to 'dev' otherwise.
 * This decision is based on the current environment setting and the absence of specific overrides.
 */ const $294900c9ed7c0df9$var$getStagingEnvironment = ({ environment: environment, cloudId: cloudId, cloudName: cloudName })=>{
    if (environment === 'staging' && !$294900c9ed7c0df9$var$isOverridingFragments() && !$294900c9ed7c0df9$var$isOverridingSsr() && !$294900c9ed7c0df9$var$isVoltExplore({
        cloudId: cloudId,
        cloudName: cloudName
    })) return environment;
    return 'dev';
};
var $294900c9ed7c0df9$export$2e2bcd8739ae039 = $294900c9ed7c0df9$var$getStagingEnvironment;

});

parcelRegister("eXiXf", function(module, exports) {
$parcel$export(module.exports, "logEmau", () => $9a679ca747ff7a82$export$f6d9e07ca353aa2e);

var $1oMOM = parcelRequire("1oMOM");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9a679ca747ff7a82$var$logEmauForJira = (subproduct, url, urlParams)=>{
    const body = JSON.stringify({
        eventData: {
            url: url,
            subproduct: subproduct,
            urlParams: urlParams
        }
    });
    const endpointUrl = '/rest/internal/2/log/unsafe/emau';
    const fetchOptions = {
        ...(0, $1oMOM.getDefaultOptions)(endpointUrl),
        method: 'POST',
        body: body
    };
    return fetch(endpointUrl, fetchOptions);
};
const $9a679ca747ff7a82$export$f6d9e07ca353aa2e = ({ product: product, subproduct: subproduct })=>{
    if (product === 'jira') // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    $9a679ca747ff7a82$var$logEmauForJira(subproduct, window.location.pathname, window.location.search);
};

});


parcelRegister("HpPtH", function(module, exports) {
$parcel$export(module.exports, "JiraStructuredAnalyticsListener", () => $6dfca3c6269e3850$export$ba6a124597fff04a);

var $eJOHy = parcelRequire("eJOHy");

var $3VCQy = parcelRequire("3VCQy");

var $8QoO2 = parcelRequire("8QoO2");

var $drtLg = parcelRequire("drtLg");

var $eSnSE = parcelRequire("eSnSE");

var $1WOGD = parcelRequire("1WOGD");

var $2Mqjh = parcelRequire("2Mqjh");

var $8kKDR = parcelRequire("8kKDR");
const $6dfca3c6269e3850$var$EXCLUDED_CHANNELS = [
    (0, $3VCQy.FabricChannel).atlaskit
];
const $6dfca3c6269e3850$var$addSearchPayload = (event, isProductAnalyticsV3 = false)=>{
    try {
        const searchPayload = (0, $8kKDR.addSearchSessionAttributes)();
        if (Object.keys(searchPayload).length > 0) {
            if (isProductAnalyticsV3) // eslint-disable-next-line no-param-reassign
            event.payload.attributes = {
                ...event.payload.attributes,
                ...searchPayload
            };
            else // eslint-disable-next-line no-param-reassign
            event.payload = {
                ...event.payload,
                ...searchPayload
            };
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('observability.analytics-providers.addSearchPayload', 'Failed to dynamically add search payload', e);
    }
    return event;
};
const $6dfca3c6269e3850$var$getAnalyticsWebClientInstance = ()=>(0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>client.getInstance());
const $6dfca3c6269e3850$var$sendAnalyticsEvent = (event)=>{
    // Preemptively create an error so we can find who sends invalid events in Sentry
    const callError = new Error(`This ${event.type} event is not valid`);
    (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
        try {
            client.sendEvent(event);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            err.cause = callError;
            throw err;
        }
    });
};
const $6dfca3c6269e3850$var$onStructuredAnalyticsEvent = (event)=>{
    const enrichedEvent = $6dfca3c6269e3850$var$addSearchPayload(event);
    $6dfca3c6269e3850$var$sendAnalyticsEvent((0, $drtLg.default)(enrichedEvent));
};
const $6dfca3c6269e3850$var$onProductAnalyticsV3 = (event)=>{
    const enrichedEvent = $6dfca3c6269e3850$var$addSearchPayload(event, true);
    $6dfca3c6269e3850$var$sendAnalyticsEvent((0, $1WOGD.getEvent)(enrichedEvent));
};
const $6dfca3c6269e3850$var$JiraAnalyticsListener = ({ onEvent: onEvent, onEventV3: onEventV3, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8QoO2.default), {
        onEvent: onEvent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8QoO2.default), {
        onEvent: onEventV3,
        channel: "productAnalytics"
    }, children));
const $6dfca3c6269e3850$export$ba6a124597fff04a = ({ children: children })=>{
    if (false) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3VCQy.default), {
        // @ts-expect-error - Type 'GasPurePayload' is not assignable to type 'UITrackAndOperationalEventPayload'.
        client: $6dfca3c6269e3850$var$getAnalyticsWebClientInstance(),
        excludedChannels: $6dfca3c6269e3850$var$EXCLUDED_CHANNELS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6dfca3c6269e3850$var$JiraAnalyticsListener, {
        onEvent: $6dfca3c6269e3850$var$onStructuredAnalyticsEvent,
        onEventV3: $6dfca3c6269e3850$var$onProductAnalyticsV3
    }, children));
};

});
parcelRegister("drtLg", function(module, exports) {
$parcel$export(module.exports, "default", () => $fba9204b02b4f431$export$2e2bcd8739ae039);

var $6dPbw = parcelRequire("6dPbw");

var $1ilzu = parcelRequire("1ilzu");

var $4lYQk = parcelRequire("4lYQk");

var $iM63C = parcelRequire("iM63C");

var $dhflm = parcelRequire("dhflm");
const $fba9204b02b4f431$var$formatActionSubjectId = (name, actionSubject)=>actionSubject ? `${name}${actionSubject[0].toUpperCase()}${actionSubject.substring(1)}` : name;
const $fba9204b02b4f431$var$getActionSubjectForEventType = (event, analyticsType)=>{
    if (analyticsType === (0, $iM63C.TRACK_EVENT_TYPE)) return (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $dhflm.getActionSubjects)(event));
    return (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $dhflm.getComponents)(event));
};
const $fba9204b02b4f431$var$getActionSubjectIdForEventType = (event, analyticsType, actionSubject)=>{
    const name = (0, $dhflm.getName)(event);
    // for UI and operational events, the actionSubjectId is generated
    // but for operational events name is optional, since it doesnt always make sense.
    // Consider a high level component BespokeComponent. If this fires an internal event
    // The unique instance of the component is likely to be BespokeComponent (ie there is 1)
    // so if name wasn't optional we would end up with actionSubjectId=bespokeComponentBespokeComponent
    if (analyticsType === (0, $iM63C.OPERATIONAL_EVENT_TYPE)) return name ? $fba9204b02b4f431$var$formatActionSubjectId(name, actionSubject) : actionSubject;
    if (analyticsType === (0, $iM63C.UI_EVENT_TYPE)) return $fba9204b02b4f431$var$formatActionSubjectId(name, actionSubject);
    return (0, $dhflm.getActionSubjectId)(event);
};
/**
 * This util exists to bridge the two different formats between atlaskit and the data services events. Two formats are required because
 * atlaskit needs to be able to collect aribtrary events from the tree while the data service event doesn't (and shouldn't) care about the react tree.
 *
 * Atlaskit event format:
 *
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Data Services event format:
 *  event {
 *      type: <"TRACK"|"SCREEN"|"UI"|"OPERATIONAL">
 *      payload {
 *          ...mandatoryFieldsBasedOnEventType
 *          ...optionalFieldsBasedOnEventType
 *          attributes: {
 *              ...arbirtaryAttributes
 *          }
 *      }
 *  }
 */ const $fba9204b02b4f431$var$getEvent = (event)=>{
    const sources = (0, $dhflm.getSources)(event);
    const analyticsType = (0, $dhflm.getAnalyticsType)(event);
    const actionSubject = $fba9204b02b4f431$var$getActionSubjectForEventType(event, analyticsType);
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(sources);
    const action = (0, $dhflm.getAction)(event);
    const attributes = {
        ...(0, $dhflm.getAttributes)(event),
        namespaces: sources.join('.')
    };
    const containers = (0, $dhflm.getContainers)(event);
    if (action === (0, $iM63C.PAGE_EVENT_ACTION)) return {
        type: (0, $iM63C.SCREEN_EVENT_TYPE),
        payload: {
            name: source,
            attributes: attributes,
            containers: containers
        }
    };
    switch(analyticsType){
        case 0, $iM63C.UI_EVENT_TYPE:
        case 0, $iM63C.TRACK_EVENT_TYPE:
        case 0, $iM63C.OPERATIONAL_EVENT_TYPE:
            {
                const actionSubjectId = $fba9204b02b4f431$var$getActionSubjectIdForEventType(event, analyticsType, actionSubject);
                const containerId = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $dhflm.getContainerIds)(event));
                const containerType = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $dhflm.getContainerTypes)(event));
                const objectId = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $dhflm.getObjectIds)(event));
                const objectType = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $dhflm.getObjectTypes)(event));
                const tags = (0, $dhflm.getTags)(event);
                return {
                    type: analyticsType,
                    payload: (0, (/*@__PURE__*/$parcel$interopDefault($4lYQk)))({
                        action: action,
                        actionSubject: actionSubject,
                        actionSubjectId: actionSubjectId,
                        source: source,
                        tags: tags,
                        containerId: containerId,
                        containers: containers,
                        containerType: containerType,
                        objectType: objectType,
                        objectId: objectId,
                        attributes: attributes
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($6dPbw))))
                };
            }
        default:
            return {
                payload: {
                    source: source,
                    actionSubject: actionSubject,
                    attributes: attributes,
                    containers: containers
                },
                type: undefined
            };
    }
};
var $fba9204b02b4f431$export$2e2bcd8739ae039 = $fba9204b02b4f431$var$getEvent;

});
parcelRegister("iM63C", function(module, exports) {
$parcel$export(module.exports, "UI_EVENT_TYPE", () => $cf7a2b19b8acff07$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $cf7a2b19b8acff07$export$947dac6c72b26f81);
$parcel$export(module.exports, "SCREEN_EVENT_TYPE", () => $cf7a2b19b8acff07$export$f1d537d508d2945a);
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => $cf7a2b19b8acff07$export$12346a674644c156);
$parcel$export(module.exports, "PAGE_EVENT_ACTION", () => $cf7a2b19b8acff07$export$a953886d20994732);
$parcel$export(module.exports, "ScreenTypes", () => $cf7a2b19b8acff07$export$9dd85b191ff3384f);
/**
 * ANALYTICS WEB CLIENT EVENTS
 */ // those events are going to the analytics web client
const $cf7a2b19b8acff07$export$a1562d08625f5d7e = 'UI';
const $cf7a2b19b8acff07$export$947dac6c72b26f81 = 'TRACK';
const $cf7a2b19b8acff07$export$f1d537d508d2945a = 'SCREEN';
const $cf7a2b19b8acff07$export$12346a674644c156 = 'OPERATIONAL';
const $cf7a2b19b8acff07$export$a953886d20994732 = 'page-view';
const $cf7a2b19b8acff07$var$SCREEN = 'Screen';
const $cf7a2b19b8acff07$var$DRAWER = 'Drawer';
const $cf7a2b19b8acff07$var$MODAL = 'Modal';
const $cf7a2b19b8acff07$var$INLINE_DIALOG = 'InlineDialog';
const $cf7a2b19b8acff07$var$DROPDOWN = 'Dropdown';
const $cf7a2b19b8acff07$export$9dd85b191ff3384f = {
    SCREEN: $cf7a2b19b8acff07$var$SCREEN,
    MODAL: $cf7a2b19b8acff07$var$MODAL,
    DRAWER: $cf7a2b19b8acff07$var$DRAWER,
    INLINE_DIALOG: $cf7a2b19b8acff07$var$INLINE_DIALOG,
    DROPDOWN: $cf7a2b19b8acff07$var$DROPDOWN
};

});

parcelRegister("dhflm", function(module, exports) {
$parcel$export(module.exports, "getComponents", () => $ef58a878f811eca7$export$4e811121b221213b);
$parcel$export(module.exports, "getActionSubjects", () => $ef58a878f811eca7$export$d9a2a7d6b7a9497b);
$parcel$export(module.exports, "getSources", () => $ef58a878f811eca7$export$5f9bc633b116660f);
$parcel$export(module.exports, "getAttributes", () => $ef58a878f811eca7$export$fe94072fee8a6976);
$parcel$export(module.exports, "getTags", () => $ef58a878f811eca7$export$af63d7414243dad3);
$parcel$export(module.exports, "getContainerTypes", () => $ef58a878f811eca7$export$94b487dda8940141);
$parcel$export(module.exports, "getContainerIds", () => $ef58a878f811eca7$export$9a462447889d734e);
$parcel$export(module.exports, "getObjectTypes", () => $ef58a878f811eca7$export$9ed2cbb83cd51da0);
$parcel$export(module.exports, "getObjectIds", () => $ef58a878f811eca7$export$2e78a279ad2bf08);
$parcel$export(module.exports, "getActionSubjectId", () => $ef58a878f811eca7$export$b6f8db3ad0711b02);
$parcel$export(module.exports, "getAnalyticsType", () => $ef58a878f811eca7$export$a3569ac53b82a914);
$parcel$export(module.exports, "getName", () => $ef58a878f811eca7$export$7d9f7e9c1c02b41e);
$parcel$export(module.exports, "getAction", () => $ef58a878f811eca7$export$6ca3170acb89054);
$parcel$export(module.exports, "getContainers", () => $ef58a878f811eca7$export$ae861c5c02c4c14c);

var $6dPbw = parcelRequire("6dPbw");

var $1O6Yz = parcelRequire("1O6Yz");

var $4lYQk = parcelRequire("4lYQk");

var $jvwCK = parcelRequire("jvwCK");
const $ef58a878f811eca7$var$extractFromEventContext = (propertyNames, event)=>event.context // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((acc, contextItem)=>{
        propertyNames.forEach((propertyName)=>{
            acc.push(contextItem[propertyName]);
        });
        return acc;
    }, []).filter(Boolean);
const $ef58a878f811eca7$var$extractFromEventPayload = (propertyName, event)=>event.payload[propertyName];
const $ef58a878f811eca7$var$extractFromPayloadOrContext = (propertyName, event)=>{
    const payloadProp = $ef58a878f811eca7$var$extractFromEventPayload(propertyName, event);
    const contextProps = $ef58a878f811eca7$var$extractFromEventContext([
        propertyName
    ], event);
    return payloadProp ? contextProps.concat(payloadProp) : contextProps;
};
const $ef58a878f811eca7$var$extractPayloadAttributes = (event)=>{
    const { tags: tags, actionSubjectId: actionSubjectId, containerType: containerType, containerId: containerId, objectType: objectType, objectId: objectId, analyticsType: analyticsType, name: name, action: action, ...attributes } = event.payload;
    return attributes;
};
const $ef58a878f811eca7$export$4e811121b221213b = (event)=>$ef58a878f811eca7$var$extractFromEventContext([
        'component',
        'componentName'
    ], event);
const $ef58a878f811eca7$export$d9a2a7d6b7a9497b = (event)=>$ef58a878f811eca7$var$extractFromEventContext([
        'actionSubject'
    ], event);
const $ef58a878f811eca7$export$5f9bc633b116660f = (event)=>$ef58a878f811eca7$var$extractFromEventContext([
        'source'
    ], event);
const $ef58a878f811eca7$export$fe94072fee8a6976 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    $ef58a878f811eca7$var$extractFromEventContext([
        'attributes'
    ], event).reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(result, extraAttributes), {}), $ef58a878f811eca7$var$extractPayloadAttributes(event));
const $ef58a878f811eca7$export$af63d7414243dad3 = (event)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const tags = (0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))($ef58a878f811eca7$var$extractFromEventContext([
        'tags'
    ], event) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((result, extraTags)=>result.concat(extraTags), []).concat($ef58a878f811eca7$var$extractFromEventPayload('tags', event)).filter(Boolean));
    return tags.length > 0 ? tags : undefined;
};
const $ef58a878f811eca7$export$94b487dda8940141 = (event)=>$ef58a878f811eca7$var$extractFromPayloadOrContext('containerType', event);
const $ef58a878f811eca7$export$9a462447889d734e = (event)=>$ef58a878f811eca7$var$extractFromPayloadOrContext('containerId', event);
const $ef58a878f811eca7$export$9ed2cbb83cd51da0 = (event)=>$ef58a878f811eca7$var$extractFromPayloadOrContext('objectType', event);
const $ef58a878f811eca7$export$2e78a279ad2bf08 = (event)=>$ef58a878f811eca7$var$extractFromPayloadOrContext('objectId', event);
const $ef58a878f811eca7$export$b6f8db3ad0711b02 = (event)=>$ef58a878f811eca7$var$extractFromEventPayload('actionSubjectId', event);
const $ef58a878f811eca7$export$a3569ac53b82a914 = (event)=>$ef58a878f811eca7$var$extractFromEventPayload('analyticsType', event);
const $ef58a878f811eca7$export$7d9f7e9c1c02b41e = (event)=>$ef58a878f811eca7$var$extractFromEventPayload('name', event);
const $ef58a878f811eca7$export$6ca3170acb89054 = (event)=>$ef58a878f811eca7$var$extractFromEventPayload('action', event);
const $ef58a878f811eca7$export$ae861c5c02c4c14c = (event)=>{
    const contextContainers = $ef58a878f811eca7$var$extractFromEventContext([
        'containers'
    ], event);
    const payloadContainers = event.payload.containers;
    const allContainers = (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    contextContainers.reduce((result, extraContainers)=>(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(result, extraContainers), {}), payloadContainers);
    const finalContainers = (0, (/*@__PURE__*/$parcel$interopDefault($4lYQk)))(allContainers, (0, (/*@__PURE__*/$parcel$interopDefault($6dPbw))));
    return Object.keys(finalContainers).length > 0 ? finalContainers : undefined;
};

});


parcelRegister("8kKDR", function(module, exports) {
$parcel$export(module.exports, "addSearchSessionAttributes", () => $12c7d3348615f122$export$ee9fabaf3a23e7bf);

var $d7YnM = parcelRequire("d7YnM");

var $9pL9Y = parcelRequire("9pL9Y");

var $hWeHP = parcelRequire("hWeHP");
const $12c7d3348615f122$export$ee9fabaf3a23e7bf = (payload)=>{
    const safePayload = payload || {};
    const sessionAttributes = {
        searchSessionId: 'searchSessionId' in safePayload && safePayload.searchSessionId ? safePayload.searchSessionId : (0, $hWeHP.default)('ajs-search-session-id'),
        searchObjectId: 'searchObjectId' in safePayload && safePayload.searchObjectId ? safePayload.searchObjectId : (0, $hWeHP.default)('ajs-search-object-id'),
        searchContainerId: 'searchContainerId' in safePayload && safePayload.searchContainerId ? safePayload.searchContainerId : (0, $hWeHP.default)('ajs-search-container-id'),
        searchContentType: 'searchContentType' in safePayload && safePayload.searchContentType ? safePayload.searchContentType : (0, $hWeHP.default)('ajs-search-content-type')
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        ...payload,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($9pL9Y)))(sessionAttributes, (0, (/*@__PURE__*/$parcel$interopDefault($d7YnM))))
    };
};

});



parcelRegister("7lk3V", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $8cfb5337f1b9e58b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $78ewy = parcelRequire("78ewy");

var $fvNZm = parcelRequire("fvNZm");

var $7Q9YQ = parcelRequire("7Q9YQ");

var $hWeHP = parcelRequire("hWeHP");

var $2Mqjh = parcelRequire("2Mqjh");

var $dCptc = parcelRequire("dCptc");
/**
 * Conditionally renders its children or enriches them with specific configurations for engagement and analytics. This component acts differently based on the execution environment (server vs client) and the availability of user metadata, aiming to seamlessly integrate analytics functionality where applicable.
 */ const $8cfb5337f1b9e58b$var$EngagementProvider = (props)=>{
    if (false) return props.children;
    const environment = (0, $dCptc.toEnvironment)((0, $hWeHP.default)('ajs-environment'));
    const getEnvironmentType = (env)=>{
        if (env === 'prod') return (0, $78ewy.envType).PROD;
        if (env === 'staging') return (0, $78ewy.envType).STAGING;
        return (0, $78ewy.envType).DEV;
    };
    const aaid = (0, $hWeHP.default)('ajs-atlassian-account-id');
    if (aaid === null) return props.children;
    const config = {
        aaid: aaid,
        cloudId: (0, $hWeHP.default)('ajs-cloud-id') || '',
        locale: (0, $hWeHP.default)('ajs-user-locale') || '',
        product: 'jira',
        stargateUrl: '/gateway/api',
        orgId: props.orgId
    };
    const coordinationOptions = {
        envType: getEnvironmentType(environment),
        enableChoreographer: true,
        additionalData: {
            sourceProductId: (0, $7Q9YQ.ProductIds).JIRA
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fvNZm.default), {
        ...props,
        config: config,
        analyticsClientInstance: Promise.resolve((0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>client.getInstance())),
        coordinationOptions: coordinationOptions
    });
};
var $8cfb5337f1b9e58b$export$2e2bcd8739ae039 = $8cfb5337f1b9e58b$var$EngagementProvider;

});

parcelRegister("lDIQ7", function(module, exports) {
$parcel$export(module.exports, "localePropType", () => $0276c7ad8efa4e6a$export$ade363a7f01ce39d);
$parcel$export(module.exports, "defaultLocale", () => (parcelRequire("6uJpm")).defaultLocale);
$parcel$export(module.exports, "supportedLanguagesMap", () => (parcelRequire("6uJpm")).supportedLanguagesMap);
$parcel$export(module.exports, "getLocale", () => (parcelRequire("dO9h7")).getLocale);
$parcel$export(module.exports, "formatTimezonedWithLocale", () => (parcelRequire("dO9h7")).formatTimezonedWithLocale);
$parcel$export(module.exports, "floatDifferenceOfDates", () => (parcelRequire("dO9h7")).floatDifferenceOfDates);
$parcel$export(module.exports, "formatWithLocale", () => (parcelRequire("dO9h7")).formatWithLocale);
$parcel$export(module.exports, "formatDistanceWithLocale", () => (parcelRequire("dO9h7")).formatDistanceWithLocale);
$parcel$export(module.exports, "formatRelativeWithLocale", () => (parcelRequire("dO9h7")).formatRelativeWithLocale);
$parcel$export(module.exports, "formatDistanceStrictWithLocale", () => (parcelRequire("dO9h7")).formatDistanceStrictWithLocale);
$parcel$export(module.exports, "weekStartDayWithLocale", () => (parcelRequire("dO9h7")).weekStartDayWithLocale);
$parcel$export(module.exports, "formatZonedDateTimeWithZone", () => (parcelRequire("dO9h7")).formatZonedDateTimeWithZone);
$parcel$export(module.exports, "parseZoneDateTime", () => (parcelRequire("dO9h7")).parseZoneDateTime);
$parcel$export(module.exports, "setTimezoneOffset", () => (parcelRequire("dO9h7")).setTimezoneOffset);
$parcel$export(module.exports, "setNumberOffsetToISODate", () => (parcelRequire("dO9h7")).setNumberOffsetToISODate);
$parcel$export(module.exports, "formatDateStringToISO", () => (parcelRequire("dO9h7")).formatDateStringToISO);
$parcel$export(module.exports, "isValidTimeZone", () => (parcelRequire("dO9h7")).isValidTimeZone);
// eslint-disable-next-line jira/restricted/prop-types

var $cT3Ey = parcelRequire("cT3Ey");

var $4uPfU = parcelRequire("4uPfU");

var $6uJpm = parcelRequire("6uJpm");

var $dO9h7 = parcelRequire("dO9h7");
const $0276c7ad8efa4e6a$export$ade363a7f01ce39d = (0, (/*@__PURE__*/$parcel$interopDefault($cT3Ey))).oneOf(Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($4uPfU)))));

});
parcelRegister("4uPfU", function(module, exports) {
module.exports = JSON.parse("{\"cs_CZ\":\"cs-CZ\",\"cs\":\"cs-CZ\",\"da_DK\":\"da-DK\",\"da\":\"da-DK\",\"de_DE\":\"de-DE\",\"de\":\"de-DE\",\"en_GB\":\"en-GB\",\"en-GB\":\"en-GB\",\"en_UK\":\"en-US\",\"en-UK\":\"en-US\",\"enUS\":\"enUS\",\"en_US\":\"en-US\",\"en-US\":\"en-US\",\"es-ES\":\"es-ES\",\"es\":\"es-ES\",\"et_EE\":\"et-EE\",\"et\":\"et-EE\",\"fi_FI\":\"fi-FI\",\"fi\":\"fi-FI\",\"fr_FR\":\"fr-FR\",\"fr\":\"fr-FR\",\"hu_HU\":\"hu-HU\",\"hu\":\"hu-HU\",\"is_IS\":\"is-IS\",\"is\":\"is-IS\",\"it_IT\":\"it-IT\",\"it\":\"it-IT\",\"ja_JP\":\"ja-JP\",\"ja\":\"ja-JP\",\"ko_KR\":\"ko-KR\",\"ko\":\"ko-KR\",\"nb_NO\":\"nb-NO\",\"nb\":\"nb-NO\",\"nl_NL\":\"nl-NL\",\"nl\":\"nl-NL\",\"pl_PL\":\"pl-PL\",\"pl\":\"pl-PL\",\"pt_BR\":\"pt-BR\",\"pt-BR\":\"pt-BR\",\"pt_PT\":\"pt-PT\",\"pt\":\"pt-PT\",\"ro_RO\":\"ro-RO\",\"ro\":\"ro-RO\",\"ru_RU\":\"ru-RU\",\"ru\":\"ru-RU\",\"sk_SK\":\"sk-SK\",\"sk\":\"sk-SK\",\"sv_SE\":\"sv-SE\",\"sv\":\"sv-SE\",\"tr\":\"tr-TR\",\"tr_TR\":\"tr-TR\",\"tr-TR\":\"tr-TR\",\"zh_CN\":\"zh-CN\",\"zh-CN\":\"zh-CN\",\"zh_TW\":\"zh-TW\",\"zh-TW\":\"zh-TW\"}");

});

parcelRegister("6uJpm", function(module, exports) {
$parcel$export(module.exports, "defaultLocale", () => $d09059f56c5a579b$export$d7f512c98c859244);
$parcel$export(module.exports, "supportedLanguagesMap", () => $d09059f56c5a579b$export$ff4f0d1b20f0caad);
const $d09059f56c5a579b$export$d7f512c98c859244 = 'enUS';
const $d09059f56c5a579b$var$arabicLocale = 'arDZ';
const $d09059f56c5a579b$export$ff4f0d1b20f0caad = {
    ar: $d09059f56c5a579b$var$arabicLocale,
    ar_DZ: $d09059f56c5a579b$var$arabicLocale,
    ar_MA: $d09059f56c5a579b$var$arabicLocale,
    ar_SA: $d09059f56c5a579b$var$arabicLocale,
    cs_CZ: 'cs',
    cs: 'cs',
    da_DK: 'da',
    da: 'da',
    de_DE: 'de',
    de: 'de',
    en_GB: 'enGB',
    'en-GB': 'enGB',
    en_UK: $d09059f56c5a579b$export$d7f512c98c859244,
    'en-UK': $d09059f56c5a579b$export$d7f512c98c859244,
    en_US: $d09059f56c5a579b$export$d7f512c98c859244,
    'en-US': $d09059f56c5a579b$export$d7f512c98c859244,
    en_AU: 'enAU',
    es_ES: 'es',
    es: 'es',
    et_EE: 'et',
    et: 'et',
    fi_FI: 'fi',
    fi: 'fi',
    fr_FR: 'fr',
    fr: 'fr',
    hu_HU: 'hu',
    hu: 'hu',
    is_IS: 'is',
    is: 'is',
    it_IT: 'it',
    it: 'it',
    ja_JP: 'ja',
    ja: 'ja',
    ko_KR: 'ko',
    ko: 'ko',
    nb_NO: 'nb',
    nb: 'nb',
    nl_NL: 'nl',
    nl: 'nl',
    pl_PL: 'pl',
    pl: 'pl',
    pt_BR: 'ptBR',
    'pt-BR': 'ptBR',
    pt_PT: 'pt',
    pt: 'pt',
    ro_RO: 'ro',
    ro: 'ro',
    ru_RU: 'ru',
    ru: 'ru',
    sk_SK: 'sk',
    sk: 'sk',
    sv_SE: 'sv',
    sv: 'sv',
    tr: 'tr',
    tr_TR: 'tr',
    zh_CN: 'zhCN',
    'zh-CN': 'zhCN',
    zh_TW: 'zhTW',
    'zh-TW': 'zhTW'
};

});

parcelRegister("dO9h7", function(module, exports) {
$parcel$export(module.exports, "getLocale", () => $b2e9153dd128b1bb$export$180605366c04f0cd);
$parcel$export(module.exports, "parseISODate", () => $b2e9153dd128b1bb$export$ee8e61141c87635a);
$parcel$export(module.exports, "isValidTimeZone", () => $b2e9153dd128b1bb$export$c793e14020d7c7b);
$parcel$export(module.exports, "formatWithLocale", () => $b2e9153dd128b1bb$export$fb3485f471c77284);
$parcel$export(module.exports, "formatTimezonedWithLocale", () => $b2e9153dd128b1bb$export$4383dd42a084ef32);
$parcel$export(module.exports, "formatDistanceWithLocale", () => $b2e9153dd128b1bb$export$c2180807b950d3da);
$parcel$export(module.exports, "formatRelativeWithLocale", () => $b2e9153dd128b1bb$export$12b50b1737ea07fc);
$parcel$export(module.exports, "formatDistanceStrictWithLocale", () => $b2e9153dd128b1bb$export$7a7656c130da0e93);
$parcel$export(module.exports, "weekStartDayWithLocale", () => $b2e9153dd128b1bb$export$d2c1381944cd40d9);
$parcel$export(module.exports, "parseZoneDateTime", () => $b2e9153dd128b1bb$export$736ce978ed45f974);
$parcel$export(module.exports, "setTimezoneOffset", () => $b2e9153dd128b1bb$export$11ef0295ba6f3d21);
$parcel$export(module.exports, "setNumberOffsetToISODate", () => $b2e9153dd128b1bb$export$fe2193e77e11d739);
$parcel$export(module.exports, "formatZonedDateTimeWithZone", () => $b2e9153dd128b1bb$export$dd52464bfc436f72);
$parcel$export(module.exports, "formatDateStringToISO", () => $b2e9153dd128b1bb$export$108dbdcbc1363368);
$parcel$export(module.exports, "floatDifferenceOfDates", () => $b2e9153dd128b1bb$export$8b999908ff0a4991);

var $2ruWJ = parcelRequire("2ruWJ");
var $hmO6M = parcelRequire("hmO6M");
var $e8XBu = parcelRequire("e8XBu");
var $57raR = parcelRequire("57raR");
var $2QHI9 = parcelRequire("2QHI9");
var $5fuQp = parcelRequire("5fuQp");
var $9rAv2 = parcelRequire("9rAv2");
var $aCFqL = parcelRequire("aCFqL");
var $kNfXW = parcelRequire("kNfXW");
var $hu795 = parcelRequire("hu795");
var $dBLX0 = parcelRequire("dBLX0");
var $cT05m = parcelRequire("cT05m");
var $kQ82p = parcelRequire("kQ82p");
var $5IPrF = parcelRequire("5IPrF");

var $hT96M = parcelRequire("hT96M");
var $6pRIG = parcelRequire("6pRIG");

var $109Mp = parcelRequire("109Mp");
var $7acw5 = parcelRequire("7acw5");
var $8jd9J = parcelRequire("8jd9J");
var $lFy5x = parcelRequire("lFy5x");
var $8cBti = parcelRequire("8cBti");
var $8JLm6 = parcelRequire("8JLm6");
var $agyKL = parcelRequire("agyKL");
var $gqB2k = parcelRequire("gqB2k");
var $01taM = parcelRequire("01taM");
var $7eJKK = parcelRequire("7eJKK");
var $2Fw99 = parcelRequire("2Fw99");
var $eeShq = parcelRequire("eeShq");
var $6e6Ha = parcelRequire("6e6Ha");
var $6609g = parcelRequire("6609g");
var $akAFq = parcelRequire("akAFq");
var $gFFcU = parcelRequire("gFFcU");
var $9VIdj = parcelRequire("9VIdj");
var $bmEYw = parcelRequire("bmEYw");
var $9yEMq = parcelRequire("9yEMq");
var $2juPt = parcelRequire("2juPt");
var $gYYzt = parcelRequire("gYYzt");
var $fA5Lp = parcelRequire("fA5Lp");
var $bZFHe = parcelRequire("bZFHe");
var $cmLAh = parcelRequire("cmLAh");
var $gjhJ4 = parcelRequire("gjhJ4");
var $1Sotl = parcelRequire("1Sotl");
var $iL2gc = parcelRequire("iL2gc");
var $8ZUjr = parcelRequire("8ZUjr");

var $6uJpm = parcelRequire("6uJpm");
const $b2e9153dd128b1bb$var$locales = {
    arDZ: $109Mp.default,
    cs: $7acw5.default,
    cs_CZ: (0, $7acw5.default),
    da: $8jd9J.default,
    da_DK: (0, $8jd9J.default),
    de: $lFy5x.default,
    de_DE: (0, $lFy5x.default),
    enUS: $agyKL.default,
    en_US: (0, $agyKL.default),
    'en-US': (0, $agyKL.default),
    enGB: $8JLm6.default,
    en_UK: (0, $8JLm6.default),
    'en-UK': (0, $8JLm6.default),
    'en-GB': (0, $8JLm6.default),
    en_GB: (0, $8JLm6.default),
    enAU: $8cBti.default,
    es: $gqB2k.default,
    es_ES: (0, $gqB2k.default),
    et: $01taM.default,
    et_EE: (0, $01taM.default),
    fi: $7eJKK.default,
    fi_FI: (0, $7eJKK.default),
    fr: $2Fw99.default,
    fr_FR: (0, $2Fw99.default),
    hu: $eeShq.default,
    hu_HU: (0, $eeShq.default),
    is: $6e6Ha.default,
    is_IS: (0, $6e6Ha.default),
    it: $6609g.default,
    it_IT: (0, $6609g.default),
    ja: $akAFq.default,
    ja_JP: (0, $akAFq.default),
    ko: $gFFcU.default,
    ko_KR: (0, $gFFcU.default),
    nb: $9VIdj.default,
    nb_NO: (0, $9VIdj.default),
    nl: $bmEYw.default,
    nl_NL: (0, $bmEYw.default),
    pl: $9yEMq.default,
    pl_PL: (0, $9yEMq.default),
    pt: $2juPt.default,
    'pt-PT': (0, $2juPt.default),
    pt_PT: (0, $2juPt.default),
    ptBR: $gYYzt.default,
    'pt-BR': (0, $gYYzt.default),
    pt_BR: (0, $gYYzt.default),
    ro: $fA5Lp.default,
    ro_RO: (0, $fA5Lp.default),
    ru: $bZFHe.default,
    ru_RU: (0, $bZFHe.default),
    sk: $cmLAh.default,
    sk_SK: (0, $cmLAh.default),
    sv: $gjhJ4.default,
    sv_SE: (0, $gjhJ4.default),
    tr: $1Sotl.default,
    'tr-TR': (0, $1Sotl.default),
    tr_TR: (0, $1Sotl.default),
    zhCN: $iL2gc.default,
    'zh-CN': (0, $iL2gc.default),
    zh_CN: (0, $iL2gc.default),
    zhTW: $8ZUjr.default,
    'zh-TW': (0, $8ZUjr.default),
    zh_TW: (0, $8ZUjr.default)
};
const $b2e9153dd128b1bb$var$nonUTCFullZoneRegExp = new RegExp(/:\d\d(\.\d+)?[-,+]\d\d:\d\d$/);
const $b2e9153dd128b1bb$var$negativeZoneRegExp = new RegExp(/:\d\d(\.\d+)?-/);
const $b2e9153dd128b1bb$var$milliseconds\u0421oefficients = {
    seconds: 1000,
    minutes: 60000,
    // 1000 * 60
    hours: 3600000,
    // 1000 * 60 * 60
    days: 86400000,
    // 1000 * 60 * 60 * 24
    weeks: 604800000
};
const $b2e9153dd128b1bb$export$180605366c04f0cd = (locale)=>{
    const dateFnsLocale = (0, $6uJpm.supportedLanguagesMap)[locale] || (0, $6uJpm.defaultLocale);
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly arDZ: Locale; readonly cs: Locale; readonly cs_CZ: Locale; readonly da: Locale; readonly da_DK: Locale; readonly de: Locale; ... 56 more ...; readonly zh_TW: Locale; }'.
    return $b2e9153dd128b1bb$var$locales[dateFnsLocale];
};
const $b2e9153dd128b1bb$export$ee8e61141c87635a = (dateString)=>{
    const parsedDate = (0, $kQ82p.default)(dateString);
    return (0, $dBLX0.default)(parsedDate) ? new Date(dateString) : undefined;
};
const $b2e9153dd128b1bb$export$c793e14020d7c7b = (tz)=>{
    try {
        Intl.DateTimeFormat(undefined, {
            timeZone: tz
        });
        return true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (ex) {
        return false;
    }
};
const $b2e9153dd128b1bb$export$fb3485f471c77284 = (date, formatStyle, locale)=>(0, $57raR.default)(date, formatStyle, {
        locale: $b2e9153dd128b1bb$export$180605366c04f0cd(locale)
    });
const $b2e9153dd128b1bb$export$4383dd42a084ef32 = (date, formatStyle, locale, timeZone)=>$b2e9153dd128b1bb$export$c793e14020d7c7b(timeZone) ? (0, $hT96M.default)((0, $6pRIG.default)(date, timeZone), formatStyle, {
        locale: $b2e9153dd128b1bb$export$180605366c04f0cd(locale),
        timeZone: timeZone
    }) : (0, $hT96M.default)((0, $6pRIG.default)(date, 'utc'), formatStyle, {
        locale: $b2e9153dd128b1bb$export$180605366c04f0cd(locale),
        timeZone: 'utc'
    });
const $b2e9153dd128b1bb$export$c2180807b950d3da = (date, baseDate, locale, addSuffix = false)=>(0, $2QHI9.default)(date, baseDate, {
        locale: $b2e9153dd128b1bb$export$180605366c04f0cd(locale),
        addSuffix: addSuffix
    });
const $b2e9153dd128b1bb$export$12b50b1737ea07fc = (date, baseDate, locale)=>(0, $9rAv2.default)(date, baseDate, {
        locale: $b2e9153dd128b1bb$export$180605366c04f0cd(locale)
    });
const $b2e9153dd128b1bb$export$7a7656c130da0e93 = (date, baseDate, locale, addSuffix = false)=>(0, $5fuQp.default)(date, baseDate, {
        locale: $b2e9153dd128b1bb$export$180605366c04f0cd(locale),
        addSuffix: addSuffix
    });
const $b2e9153dd128b1bb$export$d2c1381944cd40d9 = (date, locale)=>(0, $5IPrF.default)(date, {
        locale: $b2e9153dd128b1bb$export$180605366c04f0cd(locale)
    });
const $b2e9153dd128b1bb$export$736ce978ed45f974 = (parsingDate)=>{
    const date = typeof parsingDate === 'string' ? parsingDate : new Date().toISOString();
    const indxs = {
        positiveZoneStartIndex: date.indexOf('+'),
        negativeZoneStartIndex: $b2e9153dd128b1bb$var$negativeZoneRegExp.test(date) ? date.lastIndexOf('-') : -1,
        utcZoneStartIndex: date.indexOf('Z')
    };
    const zoneStartIndex = Object.values(indxs).find((el)=>typeof el === 'number' && el > -1);
    const parsedDate = typeof zoneStartIndex === 'number' ? date.substring(0, zoneStartIndex) : date;
    let zone = '';
    if (typeof zoneStartIndex === 'number') zone = $b2e9153dd128b1bb$var$nonUTCFullZoneRegExp.test(date) ? date.substring(zoneStartIndex, zoneStartIndex + 6) : `${date.substring(zoneStartIndex, zoneStartIndex + 3)}:00`;
    return {
        date: (0, $kQ82p.default)(parsedDate),
        zone: indxs.utcZoneStartIndex > -1 ? '+00:00' : zone
    };
};
const $b2e9153dd128b1bb$var$calcOffset = (zone)=>Number.parseInt(zone, 10) * 60 + Number.parseInt(`${zone.substring(0, 1)}${zone.substring(4)}`, 10);
const $b2e9153dd128b1bb$export$11ef0295ba6f3d21 = (date, offsetSource)=>{
    const dateOffset = date.getTimezoneOffset();
    const offset = $b2e9153dd128b1bb$var$calcOffset($b2e9153dd128b1bb$export$736ce978ed45f974(offsetSource).zone);
    return (0, $2ruWJ.default)(date, offset + dateOffset); // plus because getTimezoneOffset returns difference in minutes (e.g. +3:00 => -180)
};
const $b2e9153dd128b1bb$export$fe2193e77e11d739 = (date, offsetHoursNumber)=>{
    const parsedDate = $b2e9153dd128b1bb$export$736ce978ed45f974(date);
    const originalOffset = $b2e9153dd128b1bb$var$calcOffset(parsedDate.zone);
    const calculatedDateTime = (0, $2ruWJ.default)(parsedDate.date, offsetHoursNumber * 60 - originalOffset);
    return calculatedDateTime;
};
const $b2e9153dd128b1bb$export$dd52464bfc436f72 = (date, formatString, zone)=>{
    let res = '';
    const formatedString = (0, $57raR.default)(date, formatString);
    const indxs = {
        positiveZoneStartIndex: formatedString.indexOf('+'),
        negativeZoneStartIndex: $b2e9153dd128b1bb$var$negativeZoneRegExp.test(formatedString) ? formatedString.lastIndexOf('-') : -1,
        utcZoneStartIndex: formatedString.indexOf('Z')
    };
    const zoneStartIndex = Object.values(indxs).find((el)=>typeof el === 'number' && el > -1);
    if (typeof zoneStartIndex === 'number') res = `${formatedString.substring(0, zoneStartIndex)}${zone}`; // e.g. 2021-12-12T12:00:00+13:00
    return res;
};
const $b2e9153dd128b1bb$export$108dbdcbc1363368 = (date, formatString = 'yyyy-MM-dd')=>{
    const defaultReturnValue = '';
    if (date == null || date === '') return defaultReturnValue;
    const parsedDate = (0, $cT05m.default)(date, formatString, new Date(0, 0, 0, 0, 0, 0));
    if (!(0, $dBLX0.default)(parsedDate)) return defaultReturnValue;
    return parsedDate.toISOString(); // formatISO can have issues with timezones: https://github.com/date-fns/date-fns/issues/2151 (
};
// this is copy of diff functions from moment.js
// @ts-expect-error - TS7023 - 'monthDiff' implicitly has return type 'any' because it does not have a return type annotation and is referenced directly or indirectly in one of its return expressions.
const $b2e9153dd128b1bb$var$monthDiff = (a, b)=>{
    if ((0, $aCFqL.default)(a) < (0, $aCFqL.default)(b)) // end-of-month calculations work correct when the start month has more
    // days than the end month.
    return -$b2e9153dd128b1bb$var$monthDiff(b, a);
    // difference in months
    const wholeMonthDiff = ((0, $hu795.default)(b) - (0, $hu795.default)(a)) * 12 + ((0, $kNfXW.default)(b) - (0, $kNfXW.default)(a));
    // b is in (anchor - 1 month, anchor + 1 month)
    const anchor = (0, $hmO6M.default)(a, wholeMonthDiff);
    let anchor2;
    let adjust;
    // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
    if (b - anchor < 0) {
        anchor2 = (0, $hmO6M.default)(a, wholeMonthDiff - 1);
        // linear across the month
        // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = (0, $hmO6M.default)(a, wholeMonthDiff + 1);
        // linear across the month
        // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
        adjust = (b - anchor) / (anchor2 - anchor);
    }
    // check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
};
const $b2e9153dd128b1bb$export$8b999908ff0a4991 = (endDate, startDate, measurement)=>{
    const zoneDelta = startDate.getTimezoneOffset() * -60000 - endDate.getTimezoneOffset() * -60000; // copied from moment
    switch(measurement){
        case 'years':
            return $b2e9153dd128b1bb$var$monthDiff(endDate, startDate) / 12;
        case 'quarters':
            return $b2e9153dd128b1bb$var$monthDiff(endDate, startDate) / 3;
        case 'months':
            return $b2e9153dd128b1bb$var$monthDiff(endDate, startDate);
        case 'weeks':
            // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
            return (endDate - startDate - zoneDelta) / $b2e9153dd128b1bb$var$milliseconds\u0421oefficients.weeks;
        // negate dst
        case 'days':
            // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
            return (endDate - startDate - zoneDelta) / $b2e9153dd128b1bb$var$milliseconds\u0421oefficients.days;
        // negate dst
        case 'hours':
            // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
            return (endDate - startDate) / $b2e9153dd128b1bb$var$milliseconds\u0421oefficients.hours;
        case 'minutes':
            // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
            return (endDate - startDate) / $b2e9153dd128b1bb$var$milliseconds\u0421oefficients.minutes;
        case 'seconds':
            // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
            return (endDate - startDate) / $b2e9153dd128b1bb$var$milliseconds\u0421oefficients.seconds;
        default:
            return (0, $e8XBu.default)(endDate, startDate);
    }
};

});



parcelRegister("7iHUq", function(module, exports) {
$parcel$export(module.exports, "default", () => $74ae8959ca8e874b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $gnQAk = parcelRequire("gnQAk");
/**
 * A boundary around an "app," where an app is a distinct piece of functionality, and could potentially be nested within another app.
 *
 * Wraps children in an error boundary (by default) and a redux store provider (if store is passed).
 */ function $74ae8959ca8e874b$var$AppBaseFC({ id: // FIXME: id should be required
id = '@atlassian/jira-app-base::unknown-app', packageName: // FIXME: packageName should be required
packageName = '@atlassian/jira-app-base', teamName: teamName, hasErrorBoundary: hasErrorBoundary = true, fallback: // JSErrorBoundary fallback default is 'page' but AppBase is used around any "app"
fallback = 'flag', store: store, children: children }) {
    let contents = children;
    if (store) contents = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gnQAk.Provider), {
        store: store
    }, contents);
    if (hasErrorBoundary) contents = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: id,
        teamName: teamName,
        fallback: fallback,
        packageName: packageName
    }, contents);
    return contents;
}
var $74ae8959ca8e874b$export$2e2bcd8739ae039 = $74ae8959ca8e874b$var$AppBaseFC;

});
parcelRegister("1KdDN", function(module, exports) {
$parcel$export(module.exports, "JSErrorBoundary", () => $82ec4e0ecf6c53fe$export$1e964c961b2b98bf);

var $eJOHy = parcelRequire("eJOHy");

var $1qbKn = parcelRequire("1qbKn");

var $h47gY = parcelRequire("h47gY");

var $cOy0I = parcelRequire("cOy0I");

var $5kYyR = parcelRequire("5kYyR");
const $82ec4e0ecf6c53fe$var$ErrorPage = ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cOy0I.JSErrorPageAsync), {
        error: error
    });
const $82ec4e0ecf6c53fe$var$Empty = ()=>null;
const $82ec4e0ecf6c53fe$var$getFallback = (fallback, ErrorFlag)=>{
    switch(fallback){
        case 'page':
            return $82ec4e0ecf6c53fe$var$ErrorPage;
        case 'flag':
            return ErrorFlag;
        case 'unmount':
            return $82ec4e0ecf6c53fe$var$Empty;
        default:
            return fallback;
    }
};
const $82ec4e0ecf6c53fe$var$DEFAULT_EXTRA_EVENT_DATA = {};
const $82ec4e0ecf6c53fe$export$1e964c961b2b98bf = ({ id: id, packageName: packageName, teamName: teamName, fallback: fallback = 'page', children: children, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk, onError: onError, extraEventData: extraEventData = $82ec4e0ecf6c53fe$var$DEFAULT_EXTRA_EVENT_DATA, ...rest })=>{
    const ErrorFlag = (0, $eJOHy.useCallback)(({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1qbKn.ErrorFlagRenderer), {
            id: id,
            error: error
        }), [
        id
    ]);
    const onErrorRef = (0, $eJOHy.useRef)(onError);
    onErrorRef.current = onError;
    const onErrorHandler = (0, $eJOHy.useCallback)((location, error, errorAttributes)=>{
        onErrorRef.current?.(location, error, errorAttributes);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: id,
        packageName: packageName,
        teamName: teamName,
        render: $82ec4e0ecf6c53fe$var$getFallback(fallback, ErrorFlag),
        onError: onErrorHandler,
        extraEventData: extraEventData,
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5kYyR.default), {
        id: id,
        packageName: packageName,
        teamName: teamName,
        attributes: attributes,
        sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk
    }, children));
};

});
parcelRegister("1qbKn", function(module, exports) {
$parcel$export(module.exports, "ErrorFlagRenderer", () => $e08c3a5c6aa7daeb$export$71d5b03f33fc194b);
$parcel$export(module.exports, "ErrorBoundaryFlag", () => $e08c3a5c6aa7daeb$export$7b744ef274d5ae99);

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $5kYyR = parcelRequire("5kYyR");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e08c3a5c6aa7daeb$var$ErrorFlagRendererLazy = (0, $bQWwW.lazy)(()=>(parcelRequire("bCIT3")), {
    moduleId: "./src/packages/platform/ui/error-flag-renderer/src/ui/index.tsx"
});
const $e08c3a5c6aa7daeb$export$71d5b03f33fc194b = (props)=>{
    const packageDetails = {
        id: 'asyncErrorFlagComponent',
        packageName: 'jiraErrorBoundary'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), packageDetails, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5kYyR.default), {
        teamName: "magma",
        ...packageDetails
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-error-flag-renderer",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e08c3a5c6aa7daeb$var$ErrorFlagRendererLazy, props))));
};
const $e08c3a5c6aa7daeb$var$renderErrorFlag = ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e08c3a5c6aa7daeb$export$71d5b03f33fc194b, {
        id: "error-boundary",
        error: error
    });
const $e08c3a5c6aa7daeb$export$7b744ef274d5ae99 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        ...props,
        render: $e08c3a5c6aa7daeb$var$renderErrorFlag
    }, children);
$e08c3a5c6aa7daeb$export$7b744ef274d5ae99.defaultProps = {
    extraEventData: {},
    id: undefined
};

});
parcelRegister("5kYyR", function(module, exports) {
$parcel$export(module.exports, "default", () => $16663dde09db3866$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $ftN6c = parcelRequire("ftN6c");
var $4J0ad = parcelRequire("4J0ad");

var $bJscI = parcelRequire("bJscI");

var $7jTnu = parcelRequire("7jTnu");

var $gYnSx = parcelRequire("gYnSx");
const $16663dde09db3866$export$7549babf6b1dfb78 = (labelStack)=>{
    const view = labelStack?.find((label)=>(0, $gYnSx.VIEW_WHITELIST).has(label.name));
    return view?.name;
};
class $16663dde09db3866$var$CatchAndReportErrors extends (0, $eJOHy.Component) {
    componentDidCatch(error, errorInfo) {
        const { packageName: packageName, teamName: teamName, id: id, attributes: attributes, createAnalyticsEvent: createAnalyticsEvent, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk, ufoLabelStack: ufoLabelStack } = this.props;
        const analyticsEvent = createAnalyticsEvent({
            action: 'failed'
        });
        (0, $gYnSx.default)({
            event: analyticsEvent,
            errorInfo: errorInfo,
            error: error,
            meta: {
                id: id,
                packageName: packageName,
                teamName: teamName
            },
            attributes: typeof attributes === 'function' ? attributes(error) : attributes,
            sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk,
            view: (0, $7jTnu.fg)('jira-report-unhandled-errors-by-view') ? $16663dde09db3866$export$7549babf6b1dfb78(ufoLabelStack) : undefined
        });
        throw error;
    }
    render() {
        return this.props.children;
    }
}
const $16663dde09db3866$var$ReportErrorsWithAnalyticsNew = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($16663dde09db3866$var$CatchAndReportErrors, {
        ...props,
        createAnalyticsEvent: createAnalyticsEvent
    });
};
const $16663dde09db3866$var$ReportErrorsWithAnalyticsOld = (0, $4J0ad.default)()($16663dde09db3866$var$CatchAndReportErrors);
// When cleaning up jfp-magma-concurrent-stability-error-boundary and jira-report-unhandled-errors-by-view combine into 1 wrapper for CatchAndReportErrors rather than 2
const $16663dde09db3866$var$ReportErrorsWithAnalytics = (0, $bJscI.componentWithFG)('jfp-magma-concurrent-stability-error-boundary', $16663dde09db3866$var$ReportErrorsWithAnalyticsNew, $16663dde09db3866$var$ReportErrorsWithAnalyticsOld);
const $16663dde09db3866$var$ReportErrorsWithUFOContext = (props)=>{
    const interactionContext = (0, $7aoMz.useInteractionContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($16663dde09db3866$var$ReportErrorsWithAnalytics, {
        ...props,
        ufoLabelStack: interactionContext?.labelStack
    });
};
var $16663dde09db3866$export$2e2bcd8739ae039 = (0, $bJscI.componentWithFG)('jira-report-unhandled-errors-by-view', $16663dde09db3866$var$ReportErrorsWithUFOContext, $16663dde09db3866$var$ReportErrorsWithAnalytics);

});
parcelRegister("bJscI", function(module, exports) {
$parcel$export(module.exports, "componentWithFG", () => $a04dd2857591b12a$export$cf56d0f54cfcce4);

var $f2JN3 = parcelRequire("f2JN3");

var $7jTnu = parcelRequire("7jTnu");
const $a04dd2857591b12a$export$cf56d0f54cfcce4 = (gateName, ComponentTrue, ComponentFalse)=>(0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)(gateName), ComponentTrue, ComponentFalse);

});
parcelRegister("f2JN3", function(module, exports) {
$parcel$export(module.exports, "componentWithCondition", () => $95df13e2d486a532$export$6e8ea24b15199873);

var $eJOHy = parcelRequire("eJOHy");
function $95df13e2d486a532$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}

});



parcelRegister("ch9En", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7de49cdbd3581da$export$2e2bcd8739ae039);
$parcel$export(module.exports, "PlaceholderWithNativeSuspense", () => $d7de49cdbd3581da$export$64cdcd2c25694f20);
$parcel$export(module.exports, "PlaceholderNew", () => $d7de49cdbd3581da$export$c6bea9996b2be30e);
$parcel$export(module.exports, "PlaceholderUFOMigration", () => $d7de49cdbd3581da$export$3e921d7b50dc3425);
// eslint-disable-next-line jira/restricted/react-suspense

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $jaNQz = parcelRequire("jaNQz");

var $hhgtU = parcelRequire("hhgtU");

var $eSXqs = parcelRequire("eSXqs");
var $iETA0 = parcelRequire("iETA0");

var $f2JN3 = parcelRequire("f2JN3");

var $7jTnu = parcelRequire("7jTnu");
function $d7de49cdbd3581da$var$Hold({ name: name }) {
    const interactionContext = (0, $eJOHy.useContext)((0, $7aoMz.default));
    const waitContext = (0, $eJOHy.useContext)((0, $iETA0.WaitContext));
    // Runs synchronously, to allow us to identify async items
    (0, $hhgtU.default)(()=>{
        // if until context exists means there is a LazyWait parent component
        // we use that value
        const shouldHold = waitContext ? !!waitContext.currentValue() : true;
        if (interactionContext != null && shouldHold) return interactionContext.hold(name);
    }, [
        interactionContext,
        name,
        waitContext
    ]);
    return null;
}
function $d7de49cdbd3581da$export$2e2bcd8739ae039({ name: name, children: children, fallback: fallback }) {
    // react-18: can use fallback directly
    const fb = fallback != null ? fallback : null;
    // react-18: can use children directly
    const kids = children != null ? children : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eSXqs.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, fb, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d7de49cdbd3581da$var$Hold, {
            name: name
        })),
        name: name
    }, kids);
}
function $d7de49cdbd3581da$export$64cdcd2c25694f20({ name: name, children: children, fallback: fallback }) {
    // react-18: can use fallback directly
    const fb = fallback != null ? fallback : null;
    // react-18: can use children directly
    const kids = children != null ? children : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, fb, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d7de49cdbd3581da$var$Hold, {
            name: name
        }))
    }, kids);
}
const $d7de49cdbd3581da$export$c6bea9996b2be30e = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('concurrent-native-suspense'), $d7de49cdbd3581da$export$64cdcd2c25694f20, $d7de49cdbd3581da$export$2e2bcd8739ae039);
const $d7de49cdbd3581da$export$3e921d7b50dc3425 = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('jfp_magma_jira-ufo-placeholder-migration'), $d7de49cdbd3581da$export$2e2bcd8739ae039, (0, $jaNQz.default));

});
parcelRegister("hhgtU", function(module, exports) {
$parcel$export(module.exports, "default", () => $da8ae9e081e62827$export$2e2bcd8739ae039);
// code-reaper-ignore-file -- Uses `useLayoutEffect` in the browser and `useEffect` in the server.

var $eJOHy = parcelRequire("eJOHy");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$da8ae9e081e62827$export$2e2bcd8739ae039 = (0, $eJOHy.useLayoutEffect);

});


parcelRegister("bCIT3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kNFvF"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("kVX56"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("1GIUR")
]).then(()=>parcelRequire('8UANz'));

});
parcelRegister("ewTvA", function(module, exports) {
"use strict";

function $a93f1ca862af756d$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("iTG8W")).resolve(id));
}
module.exports = $a93f1ca862af756d$var$load;

});
parcelRegister("iTG8W", function(module, exports) {
$parcel$export(module.exports, "register", () => $dc1e0dd440d9db39$export$6503ec6e8aabbaf, (v) => $dc1e0dd440d9db39$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $dc1e0dd440d9db39$export$f7ad0328861e2f03, (v) => $dc1e0dd440d9db39$export$f7ad0328861e2f03 = v);
var $dc1e0dd440d9db39$export$6503ec6e8aabbaf;
var $dc1e0dd440d9db39$export$f7ad0328861e2f03;
"use strict";
var $dc1e0dd440d9db39$var$mapping = new Map();
function $dc1e0dd440d9db39$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$dc1e0dd440d9db39$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $dc1e0dd440d9db39$var$resolve(id) {
    var resolved = $dc1e0dd440d9db39$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$dc1e0dd440d9db39$export$6503ec6e8aabbaf = $dc1e0dd440d9db39$var$register;
$dc1e0dd440d9db39$export$f7ad0328861e2f03 = $dc1e0dd440d9db39$var$resolve;

});




parcelRegister("cOy0I", function(module, exports) {
$parcel$export(module.exports, "JSErrorPageAsync", () => $e748d98468b322d5$export$f5794426a1f1dedd);
$parcel$export(module.exports, "NotFoundErrorPageAsync", () => $e748d98468b322d5$export$8dd04806a5b061d8);
$parcel$export(module.exports, "DashboardKnownErrorsPageAsync", () => $e748d98468b322d5$export$8d20107e5d7e92ab);
$parcel$export(module.exports, "WallboardPermissionErrorPageAsync", () => $e748d98468b322d5$export$32e11a9f76e3adb);
$parcel$export(module.exports, "GenericPermissionErrorPageAsync", () => $e748d98468b322d5$export$d9c0e71eccb9dcb3);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e748d98468b322d5$var$LazyJSErrorPage = (0, $bQWwW.lazy)(()=>(parcelRequire("5Epn0")), {
    moduleId: "./src/packages/platform/ui/error-pages/src/ui/js-error-page/JSErrorPage.tsx"
});
const $e748d98468b322d5$export$f5794426a1f1dedd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-js-error-page",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e748d98468b322d5$var$LazyJSErrorPage, props));

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e748d98468b322d5$var$LazyNotFoundErrorPage = (0, $bQWwW.lazy)(()=>(parcelRequire("1mz68")), {
    moduleId: "./src/packages/platform/ui/error-pages/src/ui/not-found-error-page/NotFoundErrorPage.tsx"
});
const $e748d98468b322d5$export$8dd04806a5b061d8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-not-found-error-page",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e748d98468b322d5$var$LazyNotFoundErrorPage, null));

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e748d98468b322d5$var$LazyDashboardKnownErrorsPage = (0, $bQWwW.lazy)(()=>(parcelRequire("zfu9v")), {
    moduleId: "./src/packages/platform/ui/error-pages/src/ui/dashboard-known-errors-page/DashboardKnownErrorsPage.tsx"
});
const $e748d98468b322d5$export$8d20107e5d7e92ab = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-dashboard-known-errors-page",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e748d98468b322d5$var$LazyDashboardKnownErrorsPage, props));

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e748d98468b322d5$var$LazyWallboardPermissionErrorPage = (0, $bQWwW.lazy)(()=>(parcelRequire("eL0d3")), {
    moduleId: "./src/packages/platform/ui/error-pages/src/ui/wallboard-permission-error-page/WallboardPermissionErrorPage.tsx"
});
const $e748d98468b322d5$export$32e11a9f76e3adb = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-wallboard-permission-error-page",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e748d98468b322d5$var$LazyWallboardPermissionErrorPage, null));

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e748d98468b322d5$var$LazyGenericPermissionErrorPage = (0, $bQWwW.lazy)(()=>(parcelRequire("8A23U")), {
    moduleId: "./src/packages/platform/ui/error-pages/src/ui/generic-permission-error-page/GenericPermissionErrorPage.tsx"
});
const $e748d98468b322d5$export$d9c0e71eccb9dcb3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "async-generic-permission-error-page",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e748d98468b322d5$var$LazyGenericPermissionErrorPage, null));

});
parcelRegister("5Epn0", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("7mIf9"),
    $ewTvA("jXweD"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("jbxE1"),
    $ewTvA("7imUH"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("kVX56"),
    $ewTvA("kNFvF"),
    $ewTvA("26POr")
]).then(()=>parcelRequire('7iFtg'));

});

parcelRegister("1mz68", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("7mIf9"),
    $ewTvA("jXweD"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("jbxE1"),
    $ewTvA("7imUH"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("kVX56"),
    $ewTvA("kNFvF"),
    $ewTvA("j8Kep")
]).then(()=>parcelRequire('ctyA0'));

});

parcelRegister("zfu9v", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("7mIf9"),
    $ewTvA("jXweD"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("jbxE1"),
    $ewTvA("7imUH"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("kVX56"),
    $ewTvA("kNFvF"),
    $ewTvA("7J54I")
]).then(()=>parcelRequire('1luVZ'));

});

parcelRegister("eL0d3", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("7mIf9"),
    $ewTvA("jXweD"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("jbxE1"),
    $ewTvA("7imUH"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("kVX56"),
    $ewTvA("kNFvF"),
    $ewTvA("1MIT2")
]).then(()=>parcelRequire('8lmNE'));

});

parcelRegister("8A23U", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("7mIf9"),
    $ewTvA("jXweD"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("jbxE1"),
    $ewTvA("7imUH"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("kVX56"),
    $ewTvA("kNFvF"),
    $ewTvA("fAYdu")
]).then(()=>parcelRequire('7ky1L'));

});




parcelRegister("6uWhG", function(module, exports) {
$parcel$export(module.exports, "getMark", () => $e5dd03c0c639e194$export$f45af69d005a6ed);
$parcel$export(module.exports, "setMark", () => $e5dd03c0c639e194$export$f7a1fb90d8604165);
$parcel$export(module.exports, "setMeasure", () => $e5dd03c0c639e194$export$3d472a4be9f2b366);
$parcel$export(module.exports, "measureFunc", () => $e5dd03c0c639e194$export$25a311d3df56652d);
/* eslint-disable no-console */ 
var $gPCSe = parcelRequire("gPCSe");
const $e5dd03c0c639e194$export$f45af69d005a6ed = (markName)=>{
    if (!(0, $gPCSe.default).getEntriesByName) return null;
    const marks = (0, $gPCSe.default).getEntriesByName(markName) || [];
    return marks.length > 0 ? marks[0] : null;
};
const $e5dd03c0c639e194$export$f7a1fb90d8604165 = (markName, markOptions)=>{
    if (!(0, $gPCSe.default).mark) return undefined;
    const entry = (0, $gPCSe.default).mark(markName, markOptions);
    if (console.timeStamp) console.timeStamp(markName);
    return entry;
};
const $e5dd03c0c639e194$export$3d472a4be9f2b366 = (measureName, start, end)=>{
    // performance.measure will throw an exception if either start/end marks are not set
    try {
        return (0, $gPCSe.default).measure(measureName, start, end);
    // eslint-disable-next-line no-empty
    } catch (_err) {}
    return undefined;
};
function $e5dd03c0c639e194$export$25a311d3df56652d(measureName, func) {
    $e5dd03c0c639e194$export$f7a1fb90d8604165(`${measureName}:start`);
    const result = func();
    $e5dd03c0c639e194$export$f7a1fb90d8604165(`${measureName}:end`);
    $e5dd03c0c639e194$export$3d472a4be9f2b366(measureName, `${measureName}:start`, `${measureName}:end`);
    return result;
}

});
parcelRegister("gPCSe", function(module, exports) {
$parcel$export(module.exports, "default", () => $7d4147290e665ee0$export$2e2bcd8739ae039);
/* eslint-disable no-restricted-properties */ 
var $12DRg = parcelRequire("12DRg");
const $7d4147290e665ee0$var$getPerf = ()=>{
    try {
        // TODO - Write up an explanation to why we are doing this, if this method is approved.
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.performance.clearResourceTimings && (window.performance.clearResourceTimings = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))));
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return window.performance;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        // no op implementation
        return {
            now: ()=>0,
            mark: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            clearMarks: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            clearResourceTimings: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            getEntriesByType: (_type)=>[],
            getEntriesByName: (_name)=>[],
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            measure: (_measureName, _start, _end)=>{}
        };
    }
};
var $7d4147290e665ee0$export$2e2bcd8739ae039 = $7d4147290e665ee0$var$getPerf();

});


parcelRegister("j500r", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a48e778f029ac9d$export$2e2bcd8739ae039);

var $hWeHP = parcelRequire("hWeHP");
const $0a48e778f029ac9d$var$fromMetaTag = (()=>{
    // ajs-fe-feature-flags contains ALL frontend flags (boolean, string and JSON flags)
    const locator = ()=>(0, $hWeHP.default)('ajs-fe-feature-flags');
    return {
        locator: locator,
        processor: ()=>{
            const featureFlags = locator();
            if (featureFlags != null && featureFlags !== '') try {
                return JSON.parse(featureFlags);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                throw new Error("Can't parse 'ajs-fe-feature-flags' value");
            }
            return undefined;
        }
    };
})();
const $0a48e778f029ac9d$var$createGlobalVarChecker = (name)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    return {
        locator: ()=>name in globalVar,
        processor: ()=>globalVar[name]
    };
};
const $0a48e778f029ac9d$var$fromFeatureFlagsGlobal = $0a48e778f029ac9d$var$createGlobalVarChecker('featureFlags');
const $0a48e778f029ac9d$var$fromSsrFeFeatureFlagsGlobal = $0a48e778f029ac9d$var$createGlobalVarChecker('ssr__feFeatureFlags');
const $0a48e778f029ac9d$var$fromSsrAllFeatureFlagsGlobal = $0a48e778f029ac9d$var$createGlobalVarChecker('ssr__allFeatureFlags');
const $0a48e778f029ac9d$var$FLAG_TEST_ORDER = [
    $0a48e778f029ac9d$var$fromFeatureFlagsGlobal,
    $0a48e778f029ac9d$var$fromMetaTag,
    $0a48e778f029ac9d$var$fromSsrAllFeatureFlagsGlobal,
    $0a48e778f029ac9d$var$fromSsrFeFeatureFlagsGlobal
];
const $0a48e778f029ac9d$export$8ece9c90e8293278 = ()=>{
    return $0a48e778f029ac9d$var$FLAG_TEST_ORDER.some((tester)=>tester.locator());
};
const $0a48e778f029ac9d$export$f71b0166412a3835 = ()=>{
    const featureFlags = $0a48e778f029ac9d$var$FLAG_TEST_ORDER.find((tester)=>tester.locator())?.processor();
    return featureFlags || {};
};
let $0a48e778f029ac9d$var$memoizedFeatureFlags;
const $0a48e778f029ac9d$var$memoizedGetAllFeatureFlags = ()=>{
    /**
	 * The following `isReorderEarlyScriptsEnabled` and `invalidateFeatureFlags_DO_NOT_USE` branch
	 * is a highly temporary (couple of weeks) block of code that is intended for use only for
	 * HOT mitigation #hot-110667 where we need for a short period (couple of weeks) to freeze
	 * a subset of the feature flags that are only used in the Issue View early entry script.
	 * The feature flags are set inside the `src/entry-fs` initially and then updated later
	 * after the early entry script has executed.
	 *
	 * The `window.isReorderEarlyScriptsEnabled` is a value that is set in the bifrost-template
	 * and is based on a bifrost-gateway feature-flag value. We are using this as a potential to
	 * mitigate further HOTs by turning it off.
	 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    if (globalVar.isReorderEarlyScriptsEnabled === true) {
        if ($0a48e778f029ac9d$var$memoizedFeatureFlags == null || globalVar.invalidateFeatureFlags_DO_NOT_USE === true) {
            globalVar.invalidateFeatureFlags_DO_NOT_USE = false;
            $0a48e778f029ac9d$var$memoizedFeatureFlags = $0a48e778f029ac9d$export$f71b0166412a3835();
        }
        return $0a48e778f029ac9d$var$memoizedFeatureFlags;
    }
    if ($0a48e778f029ac9d$var$memoizedFeatureFlags == null) $0a48e778f029ac9d$var$memoizedFeatureFlags = $0a48e778f029ac9d$export$f71b0166412a3835();
    return $0a48e778f029ac9d$var$memoizedFeatureFlags;
};
var $0a48e778f029ac9d$export$2e2bcd8739ae039 = $0a48e778f029ac9d$var$memoizedGetAllFeatureFlags;

});

parcelRegister("iZsVo", function(module, exports) {
$parcel$export(module.exports, "ssr", () => $bd622791964552f9$export$ea2375f6c0c9ffdc);
$parcel$export(module.exports, "ssrExtended", () => $bd622791964552f9$export$b821aa3bb9044abf);

var $LFmXM = parcelRequire("LFmXM");

var $hWeHP = parcelRequire("hWeHP");

var $bd1QF = parcelRequire("bd1QF");

var $d4UrD = parcelRequire("d4UrD");
const $bd622791964552f9$var$getSSRFeatureFlags = (0, $LFmXM.default)(()=>{
    try {
        const metaTagValue = (0, $hWeHP.default)('spa-service-flags');
        if (metaTagValue === null) return null;
        return JSON.parse(metaTagValue) || null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return null;
    }
});
const $bd622791964552f9$export$ea2375f6c0c9ffdc = {
    getDoneMark: (0, $bd1QF.getSSRMark),
    getTimings: (0, $d4UrD.getSSRTimings),
    getFeatureFlags: $bd622791964552f9$var$getSSRFeatureFlags
};
const $bd622791964552f9$export$b821aa3bb9044abf = {
    ...$bd622791964552f9$export$ea2375f6c0c9ffdc,
    includeFeatureFlags: 'when-available'
};

});
parcelRegister("bd1QF", function(module, exports) {
$parcel$export(module.exports, "getSSRMark", () => $f2226353914e0cfa$export$1faf7d001841a41c);

var $6uWhG = parcelRequire("6uWhG");

const $f2226353914e0cfa$export$1faf7d001841a41c = ()=>(0, $6uWhG.getMark)((0, $2e47af044bce450a$export$135c96ab5afee429))?.startTime || null;

});
const $2e47af044bce450a$export$56940a9488e85199 = 'jira.fe.spa-';
const $2e47af044bce450a$export$45c4b6bf7935c69a = `${$2e47af044bce450a$export$56940a9488e85199}start`;
const $2e47af044bce450a$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $2e47af044bce450a$export$ff834eccc35b9089 = 'appBundleReady';
const $2e47af044bce450a$export$86b05e34d462ead8 = 'prefetchApiReady';
const $2e47af044bce450a$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $2e47af044bce450a$export$3ae43cc1782d058f = 'jswRenderStart';
const $2e47af044bce450a$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $2e47af044bce450a$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $2e47af044bce450a$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $2e47af044bce450a$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $2e47af044bce450a$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $2e47af044bce450a$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $2e47af044bce450a$export$99c08ec92759c71c = 'tti-raf-mark';
const $2e47af044bce450a$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("d4UrD", function(module, exports) {
$parcel$export(module.exports, "getSSRTimings", () => $4d224cd03d50270c$export$bf7408e83532dcd0);

var $fqICx = parcelRequire("fqICx");
const $4d224cd03d50270c$export$bf7408e83532dcd0 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (!window.SPA_STATE) return null;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const detailRenderTrace = window.SPA_STATE['ssr/detail_render_trace'];
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const detailRequestTrace = window.SPA_STATE['ssr/detail_request_trace'];
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const highLevelMetrics = window.SPA_STATE['ssr/metrics'];
    const timings = (0, (/*@__PURE__*/$parcel$interopDefault($fqICx)))(detailRenderTrace?.data?.traces) || {};
    if (highLevelMetrics?.data) {
        if ('ssrTotal' in highLevelMetrics.data) timings.total = {
            startTime: 0,
            duration: highLevelMetrics.data.ssrTotal
        };
        if ('ssrGetStyle' in highLevelMetrics.data) timings.styles = {
            startTime: highLevelMetrics.data.ssrGetStyle - highLevelMetrics.data.ssrGetStyle,
            duration: highLevelMetrics.data.ssrGetStyle
        };
        if ('ssrPrefetch' in highLevelMetrics.data) {
            const prefetchStartTime = Object.values(detailRenderTrace?.data?.traces || {}).reduce((min, { startTime: startTime })=>min === -1 || min > startTime ? startTime : min, -1);
            timings.prefetch = {
                startTime: prefetchStartTime,
                duration: highLevelMetrics.data.ssrPrefetch
            };
        }
    }
    if (detailRequestTrace?.data) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(detailRequestTrace.data).forEach(([key, value])=>{
        timings[`prefetch/${key}`] = value;
    });
    return timings;
};

});


parcelRegister("1Q1XT", function(module, exports) {
$parcel$export(module.exports, "initBrowserMetrics3", () => $1bdabe384288ea4c$export$156d1d35be797a9d);

var $eJOHy = parcelRequire("eJOHy");

var $k04JP = parcelRequire("k04JP");

var $j500r = parcelRequire("j500r");

var $7jTnu = parcelRequire("7jTnu");

var $hWeHP = parcelRequire("hWeHP");

var $hVEQH = parcelRequire("hVEQH");

var $2Mqjh = parcelRequire("2Mqjh");

var $2lxLk = parcelRequire("2lxLk");
var $8tVkR = parcelRequire("8tVkR");
var $hSmZA = parcelRequire("hSmZA");

var $5d2lU = parcelRequire("5d2lU");

var $um4ng = parcelRequire("um4ng");

var $c17mK = parcelRequire("c17mK");

var $diftH = parcelRequire("diftH");

var $inFDJ = parcelRequire("inFDJ");

var $gTg7X = parcelRequire("gTg7X");

var $3bfFp = parcelRequire("3bfFp");

var $aRRWa = parcelRequire("aRRWa");
var $hXeVV = parcelRequire("hXeVV");

var $iZsVo = parcelRequire("iZsVo");
const $1bdabe384288ea4c$var$isWRMResource = (url)=>url.includes('/batch.js') || url.includes('/batch.css');
const $1bdabe384288ea4c$var$getWRMAssetName = (url)=>{
    const [, resources] = /\/([\w.\-,:]*?)(?:,-|\/batch\.)/.exec(url) || [];
    const assetName = (0, $hVEQH.sanitiseAssetName)(false)(url);
    if (!resources) return assetName;
    return `wrm/${resources}/${assetName}`;
};
const $1bdabe384288ea4c$var$getFileName = (url)=>$1bdabe384288ea4c$var$isWRMResource(url) ? $1bdabe384288ea4c$var$getWRMAssetName(url) : (0, $hVEQH.sanitiseAssetName)(false)(url);
const $1bdabe384288ea4c$export$156d1d35be797a9d = ()=>{
    (0, $hXeVV.startLSObserver)();
    (0, $hXeVV.startLTObserver)();
    const info = {
        product: 'jira',
        app: {
            version: {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                web: window.BUILD_KEY,
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                ssr: window.SSR_BUILD_KEY
            },
            framework: {
                name: 'react',
                version: $eJOHy.version
            }
        },
        region: (0, $hWeHP.default)('ajs-region') || 'unknown'
    };
    const endpoints = {
        eventPipelineClient: (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
            const instance = client.getInstance();
            if (!(0, $7jTnu.fg)('uip_bm3_stop-page-load')) return instance;
            return {
                sendOperationalEvent: (payload)=>{
                    const type = payload?.attributes?.properties?.['event:type'];
                    if (type === 'page-load') return;
                    return instance.sendOperationalEvent(payload);
                }
            };
        })
    };
    const resourceTimings = {
        sanitiseEndpoints: $gTg7X.sanitiseEndpoints,
        mapResources: $1bdabe384288ea4c$var$getFileName,
        hasTimingHeaders: (url)=>url.includes('jira-frontend-branch') || $1bdabe384288ea4c$var$isWRMResource(url),
        // @ts-expect-error - TS7006 - Parameter 'url' implicitly has an 'any' type.
        xhrFilter: (url)=>url.includes('/rest/greenhopper/')
    };
    const featureFlagClient = {
        getValue: (featureFlagName)=>{
            const allFeatureFlags = (0, $j500r.default)();
            if (!allFeatureFlags) return undefined;
            return allFeatureFlags[featureFlagName]?.value;
        }
    };
    const featureFlags = {
        client: Promise.resolve(featureFlagClient)
    };
    const plugins = {
        featureFlags: featureFlags,
        resourceTimings: resourceTimings,
        bundleEvalTimings: $5d2lU.bundleEvalTimings
    };
    (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
        (0, $8tVkR.payloadPublisher).setup({
            product: 'jira',
            app: {
                version: {
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    web: window.BUILD_KEY,
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    ssr: window.SSR_BUILD_KEY
                },
                framework: {
                    name: 'react',
                    version: $eJOHy.version
                }
            },
            region: (0, $hWeHP.default)('ajs-region') || 'unknown',
            tenantType: (0, $hWeHP.default)('ajs-is-synthetic') === 'true' ? (0, $hSmZA.TenantType).Synthetic : (0, $hSmZA.TenantType).RealUser,
            gasv3: client.getInstance(),
            bundleEvalTimings: // @ts-expect-error - TS2322 - Type '{ readonly mapPerformanceMark: (mark: string) => { name: string; type: string; } | null; }' is not assignable to type 'BundleEvalTimingsConfig'.
            $5d2lU.bundleEvalTimings,
            resourceTimings: resourceTimings,
            featureFlagClient: // @ts-expect-error - TS2322 - Type '{ getValue: (featureFlagName: string) => FeatureFlagValue | undefined; }' is not assignable to type 'FeatureFlagClient'.
            featureFlagClient,
            featureFlags: [
                ...(0, $diftH.featureFlagsAddedToEVERYJiraEvent),
                ...(0, $3bfFp.jfpPerfFeatureFlags),
                ...(0, $inFDJ.featureFlagsAddedToEVERYPageLoadEvent)
            ],
            plugins: [
                // all
                (0, $um4ng.getCustomData),
                // @ts-expect-error - TS2322 - Type '(data: {    start: number;}) => Record<string, any> | null' is not assignable to type '(data: ExperienceData | PageLoadExperienceData) => CustomData | null'.
                (0, $gTg7X.getMarks),
                (0, $gTg7X.getMemoryMetrics),
                // page-load
                (0, $c17mK.getPageSizeMetrics),
                (0, $c17mK.getExtraNavigationTimings),
                // @ts-expect-error - TS2322 - Type '() => (() => unknown)[]' is not assignable to type '(data: ExperienceData | PageLoadExperienceData) => CustomData | null'.
                (0, $gTg7X.getPageLoadPlugins)
            ],
            ssr: $iZsVo.ssr,
            performanceConfig: {
                histogram: {
                    [(0, $2lxLk.ExperiencePerformanceTypes).PageLoad]: {
                        initial: {
                            fmp: '2500_3000_3500_4000_5000_6000',
                            tti: '4000_4500_5000_6000_7000_8000_9000'
                        },
                        transition: {
                            fmp: '2500_3000_3500_4000_5000_6000',
                            tti: '2500_3000_3500_4000_5000_6000'
                        }
                    },
                    [(0, $2lxLk.ExperiencePerformanceTypes).InlineResult]: {
                        result: '100_200_500_1000_1500',
                        response: '50_100_150_200_300_500'
                    },
                    [(0, $2lxLk.ExperiencePerformanceTypes).Custom]: {
                        duration: '250_500_1000_1500_2000_3000_4000'
                    }
                }
            }
        });
    });
    (0, $k04JP.browserMetrics).init({
        info: info,
        endpoints: // @ts-expect-error - TS2322 - Type '{ eventPipelineClient: Promise<AnalyticsWebClient> | Promise<IEventPipelineClient>; metalClient: Promise<MetalClient>; }' is not assignable to type '{ eventPipelineClient: Promise<{ sendOperationalEvent: (payload: GasPurePayload) => void; }>; metalClient?: Promise<{ metric: { submit: (payload: unknown) => void; }; }> | undefined; }'.
        endpoints,
        plugins: // @ts-expect-error - TS2322 - Type '{ featureFlags: { client: Promise<{ getValue: (featureFlagName: string) => FeatureFlagValue | undefined; }>; }; resourceTimings: { sanitiseEndpoints: (url: string) => string; mapResources: (url: string) => any; hasTimingHeaders: (url: string) => boolean; xhrFilter: (url: any) => any; }; bundleEvalTimings: { ...; }; }' is not assignable to type '{ resourceTimings: ResourceTimingsConfig; bundleEvalTimings?: BundleEvalTimingsConfig | undefined; featureFlags: { client: FeatureFlagsClientPromise; }; }'.
        plugins,
        events: {
            all: {
                featureFlags: [
                    ...(0, $diftH.featureFlagsAddedToEVERYJiraEvent),
                    ...(0, $3bfFp.jfpPerfFeatureFlags)
                ],
                plugins: [
                    (0, $gTg7X.getMarks),
                    (0, $gTg7X.getMemoryMetrics),
                    (0, $aRRWa.getLighthouseMetrics),
                    (0, $um4ng.newGetCustomData)
                ]
            },
            PAGE_LOAD: {
                featureFlags: [
                    ...(0, $inFDJ.featureFlagsAddedToEVERYPageLoadEvent)
                ],
                custom: {
                    ...(0, $c17mK.getPageSizeMetrics)(),
                    ...(0, $c17mK.getExtraNavigationTimings)()
                },
                // @ts-expect-error - TS2322 - Type '(() => unknown)[]' is not assignable to type 'CustomPlugin[]'.
                plugins: (0, $gTg7X.getPageLoadPlugins)(),
                histogram: {
                    initial: {
                        fmp: '2500_3000_3500_4000_5000_6000',
                        tti: '4000_4500_5000_6000_7000_8000_9000'
                    },
                    transition: {
                        fmp: '2500_3000_3500_4000_5000_6000',
                        tti: '2500_3000_3500_4000_5000_6000'
                    }
                }
            },
            INLINE_RESULT: {
                histogram: {
                    result: '100_200_500_1000_1500',
                    response: '50_100_150_200_300_500'
                }
            },
            CUSTOM: {
                histogram: {
                    duration: '250_500_1000_1500_2000_3000_4000'
                }
            },
            WEB_VITALS: {
                enabled: !false && (0, $hWeHP.default)('ajs-is-synthetic') === 'true'
            }
        },
        // @ts-expect-error - TS2322 - Type '{ readonly includeFeatureFlags: "when-available"; readonly getDoneMark: () => number | null; readonly getTimings: () => any; readonly getFeatureFlags: MemoizedFn<() => any>; }' is not assignable to type 'SSRConfig'.
        ssr: (0, $iZsVo.ssrExtended)
    });
    (0, $k04JP.browserMetrics).startPageLoad({
        isInitial: true
    });
};

});
parcelRegister("5d2lU", function(module, exports) {
$parcel$export(module.exports, "bundleEvalTimings", () => $1b9aad173b4d116a$export$1a2bb347935fc536);

var $cJAh3 = parcelRequire("cJAh3");
const $1b9aad173b4d116a$export$1a2bb347935fc536 = {
    mapPerformanceMark: (mark)=>{
        if (mark.endsWith((0, $cJAh3.JS_EVAL_START))) return {
            name: mark.substring(0, mark.indexOf((0, $cJAh3.JS_EVAL_START))),
            type: 'start'
        };
        if (mark.endsWith((0, $cJAh3.JS_EVAL_STOP))) return {
            name: mark.substring(0, mark.indexOf((0, $cJAh3.JS_EVAL_STOP))),
            type: 'end'
        };
        return null;
    }
};

});

parcelRegister("um4ng", function(module, exports) {
$parcel$export(module.exports, "newGetCustomData", () => $dea163372c06e6a7$export$bc962f7892f5542c);
$parcel$export(module.exports, "getCustomData", () => $dea163372c06e6a7$export$c740a965f4a07e8e);

var $5PQOA = parcelRequire("5PQOA");

var $LFmXM = parcelRequire("LFmXM");

var $hWeHP = parcelRequire("hWeHP");

var $6D8kE = parcelRequire("6D8kE");

var $7jTnu = parcelRequire("7jTnu");

var $6SNzM = parcelRequire("6SNzM");

var $5Dg0E = parcelRequire("5Dg0E");

var $6hCn2 = parcelRequire("6hCn2");
const $dea163372c06e6a7$var$customData = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const commonCustomData = {};
    const shard = (0, $hWeHP.default)('ajs-shard');
    if (shard !== null && shard !== '') commonCustomData.shard = shard;
    if ((0, $7jTnu.fg)('add_editions_to_bm3_splunk_events')) commonCustomData['jira:productEditions'] = (0, $6D8kE.getProductEditions)();
    commonCustomData['network:assetEncoding'] = (0, $6SNzM.getAssetEncoding)();
    const buildVariant = (0, $5Dg0E.getBuildVariant)();
    if (buildVariant) commonCustomData['app:buildVariant'] = buildVariant;
    const bundlerVersion = (0, $6hCn2.getBundlerVersion)();
    if (bundlerVersion) commonCustomData['app:bundlerVersion'] = bundlerVersion;
    commonCustomData.httpProtocol = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    performance.getEntriesByType('resource')// @ts-expect-error - TS2339  - Property 'nextHopProtocol' does not exist on type 'PerformanceEntry'. | TS2339 - Property 'nextHopProtocol' does not exist on type 'PerformanceEntry'.
    .find(({ nextHopProtocol: nextHopProtocol })=>!!nextHopProtocol)?.nextHopProtocol ?? 'unknown';
    return commonCustomData;
};
const $dea163372c06e6a7$export$bc962f7892f5542c = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))($dea163372c06e6a7$var$customData, ()=>true);
const $dea163372c06e6a7$export$c740a965f4a07e8e = (0, $LFmXM.default)($dea163372c06e6a7$var$customData);

});
parcelRegister("6SNzM", function(module, exports) {
$parcel$export(module.exports, "getAssetEncoding", () => $6ca8f6fb1586f3a3$export$fd12d8f45e126585);
const $6ca8f6fb1586f3a3$export$fd12d8f45e126585 = ()=>{
    const assetEncodings = Array.prototype.map// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    .call(document.querySelectorAll('script[data-encoding], link[data-encoding]'), (i)=>i.getAttribute('data-encoding')) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((acc, i)=>{
        // @ts-expect-error - TS2538 - Type 'unknown' cannot be used as an index type.
        acc[i] = true;
        return acc;
    }, {});
    const uniqueEncodings = Object.keys(assetEncodings).sort();
    let result = 'unknown';
    if (uniqueEncodings.length === 1) [result] = uniqueEncodings;
    if (uniqueEncodings.length > 1) result = `mixed: ${uniqueEncodings.toString()}`;
    return result;
};

});

parcelRegister("5Dg0E", function(module, exports) {
$parcel$export(module.exports, "getBuildVariant", () => $8b4dcceb62a18a98$export$ca0c40b5b7c3b911);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $8b4dcceb62a18a98$export$ca0c40b5b7c3b911 = ()=>window.BUILD_VARIANT;

});

parcelRegister("6hCn2", function(module, exports) {
$parcel$export(module.exports, "getBundlerVersion", () => $60aa2c8ee5374db2$export$5dca7b2a9cf4f500);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $60aa2c8ee5374db2$export$5dca7b2a9cf4f500 = ()=>window.BUNDLER_VERSION;

});


parcelRegister("c17mK", function(module, exports) {
$parcel$export(module.exports, "getPageSizeMetrics", () => $7274feec32126a38$export$84e3d676f1564c75);
$parcel$export(module.exports, "getExtraNavigationTimings", () => $7274feec32126a38$export$b37a70af06e58097);
$parcel$export(module.exports, "getPageSizeInfo", () => $7274feec32126a38$export$b72e035af6568be7);

var $gPCSe = parcelRequire("gPCSe");
const $7274feec32126a38$export$84e3d676f1564c75 = ()=>{
    let maxDepth = -1;
    let maxWidth = -1;
    let numElements = 0;
    // As described in the lighthouse DOM audit - https://web.dev/dom-size/
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const calculateDOMsizeAndDepth = (el = document.body, depth = 1)=>{
        if (!el) return;
        if (depth > maxDepth) maxDepth = depth;
        if (el.children.length > maxWidth) maxWidth = el.children.length;
        let child = el.firstElementChild;
        while(child){
            // @ts-expect-error - TS2345 - Argument of type 'Element' is not assignable to parameter of type 'HTMLElement'.
            calculateDOMsizeAndDepth(child, depth + 1);
            // If element has shadow dom, traverse into that tree.
            if (child.shadowRoot) // @ts-expect-error - TS2345 - Argument of type 'ShadowRoot' is not assignable to parameter of type 'HTMLElement'.
            calculateDOMsizeAndDepth(child.shadowRoot, depth + 1);
            child = child.nextElementSibling;
            numElements += 1;
        }
    };
    calculateDOMsizeAndDepth();
    return {
        totalBodyElements: numElements,
        maxNestedLevels: maxDepth,
        maxChildElements: maxWidth
    };
};
const $7274feec32126a38$export$b37a70af06e58097 = ()=>{
    if (!(0, $gPCSe.default)) return {};
    const navigation = (0, $gPCSe.default).getEntriesByType('navigation')[0];
    if (!navigation) return {};
    return {
        // From https://www.w3.org/TR/navigation-timing-2/
        // @ts-expect-error - TS2339 - Property 'decodedBodySize' does not exist on type 'PerformanceEntry'.
        decodedBodySize: navigation.decodedBodySize,
        // @ts-expect-error - TS2339 - Property 'encodedBodySize' does not exist on type 'PerformanceEntry'.
        encodedBodySize: navigation.encodedBodySize,
        // @ts-expect-error - TS2339 - Property 'transferSize' does not exist on type 'PerformanceEntry'.
        transferSize: navigation.transferSize
    };
};
const $7274feec32126a38$var$assetsTypes = [
    'script',
    'link'
];
const $7274feec32126a38$export$b72e035af6568be7 = ({ start: start, stop: stop })=>{
    const pageSize = $7274feec32126a38$export$b37a70af06e58097();
    if (!pageSize || Object.keys(pageSize).length === 0 || pageSize.decodedBodySize === 0 || start > 0) return {};
    const decoded = {
        total: pageSize.decodedBodySize,
        pageSize: pageSize.decodedBodySize,
        assets: 0,
        endpoints: 0
    };
    const encoded = {
        total: pageSize.encodedBodySize,
        pageSize: pageSize.encodedBodySize,
        assets: 0,
        endpoints: 0
    };
    const net = {
        total: pageSize.transferSize,
        assets: 0,
        endpoints: 0
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    for (const entry of (0, $gPCSe.default).getEntriesByType('resource')){
        if (entry.startTime > stop) continue;
        if ($7274feec32126a38$var$assetsTypes.includes(entry.initiatorType)) {
            decoded.total += entry.decodedBodySize;
            decoded.assets += entry.decodedBodySize;
            encoded.total += entry.encodedBodySize;
            encoded.assets += entry.encodedBodySize;
            net.total += entry.transferSize;
            net.assets += entry.transferSize;
        } else {
            decoded.total += entry.decodedBodySize;
            decoded.endpoints += entry.decodedBodySize;
            encoded.total += entry.encodedBodySize;
            encoded.endpoints += entry.encodedBodySize;
            net.total += entry.transferSize;
            net.endpoints += entry.transferSize;
        }
    }
    const returnValue = {};
    Object.keys(decoded).forEach((key)=>{
        returnValue[`size:decoded:${key}`] = decoded[key];
    });
    Object.keys(encoded).forEach((key)=>{
        returnValue[`size:encoded:${key}`] = encoded[key];
    });
    Object.keys(net).forEach((key)=>{
        returnValue[`size:net:${key}`] = net[key];
    });
    return returnValue;
};

});

parcelRegister("diftH", function(module, exports) {
$parcel$export(module.exports, "featureFlagsAddedToEVERYJiraEvent", () => $2c7f074ae52a96b2$export$8f6204c7f33d9925);
// by adding feature flag to this array you agree that this feature flag:
// * is expected to impact all performance metrics in Jira (page load, interactions, etc)
// * is expected to be short term
const $2c7f074ae52a96b2$export$8f6204c7f33d9925 = [];

});

parcelRegister("inFDJ", function(module, exports) {
$parcel$export(module.exports, "featureFlagsAddedToEVERYPageLoadEvent", () => $9be9333e6169e995$export$85fd4da798ef108b);
// by adding feature flag to this array you agree that this feature flag:
// * is expected to impact *all page load* performance metrics in Jira
// * is expected to be short term
const $9be9333e6169e995$export$85fd4da798ef108b = [];

});

parcelRegister("gTg7X", function(module, exports) {
$parcel$export(module.exports, "getPageLoadPlugins", () => $71b5449896aa0d2f$export$4d5c3be18e81b958);
$parcel$export(module.exports, "getMemoryMetrics", () => $71b5449896aa0d2f$export$500422125b861bab);
$parcel$export(module.exports, "getMarks", () => $71b5449896aa0d2f$export$9d952633c9c2237b);
$parcel$export(module.exports, "sanitiseEndpoints", () => $71b5449896aa0d2f$export$6dfc8bfc2349f367);

var $3Q6BV = parcelRequire("3Q6BV");

var $a5R5f = parcelRequire("a5R5f");

var $cJAh3 = parcelRequire("cJAh3");

var $jmNHL = parcelRequire("jmNHL");

var $aKjW6 = parcelRequire("aKjW6");

var $c17mK = parcelRequire("c17mK");

var $84rXz = parcelRequire("84rXz");

var $cxegf = parcelRequire("cxegf");

var $9LzIn = parcelRequire("9LzIn");

var $pSnTj = parcelRequire("pSnTj");
const $71b5449896aa0d2f$var$endpointsWithOperationNameRegex = new RegExp('/rest/graphql/1/|/rest/gira/1/|/gateway/api/graphql|/jsw2/graphql');
const $71b5449896aa0d2f$export$4d5c3be18e81b958 = ()=>{
    const pageLoadCustomData = [];
    pageLoadCustomData.push((data)=>{
        // initial load only
        const startTime = data?.start || data?.result?.startTime || 0;
        if (startTime !== 0) return {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return Object.entries((0, $aKjW6.getServerDurationMetrics)()).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (acc, [key, value])=>{
            acc[key] = value;
            return acc;
        }, {});
    });
    pageLoadCustomData.push((0, $9LzIn.getRouterResourceMetrics));
    pageLoadCustomData.push((0, $pSnTj.getWRMStats));
    pageLoadCustomData.push((0, $84rXz.getCacheHitRatio));
    pageLoadCustomData.push((0, $cxegf.getCHRInfo));
    pageLoadCustomData.push((0, $c17mK.getPageSizeInfo));
    return pageLoadCustomData;
};
const $71b5449896aa0d2f$export$500422125b861bab = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const customData = {};
    const memoryUsageReport = (0, $jmNHL.getMemoryUsageReport)();
    if (memoryUsageReport) customData.memory = memoryUsageReport;
    return customData;
};
const $71b5449896aa0d2f$export$9d952633c9c2237b = (data)=>{
    const userTiming = (0, $a5R5f.getUserTiming)();
    if (userTiming === null) return null;
    const sanitizeName = (name)=>name.replace(/[\W_]+/g, '_');
    // @ts-expect-error - TS7031 - Binding element 'baseName' implicitly has an 'any' type. | TS7031 - Binding element 'collection' implicitly has an 'any' type.
    const getNextAvailableName = ({ baseName: baseName, collection: collection })=>{
        let candidateName = baseName;
        // If <name> is taken, we'll try <name>_2 and increment from there
        let counter = 2;
        let validName;
        while(!validName)if (candidateName in collection) {
            candidateName = `${baseName}_${counter}`;
            counter += 1;
        } else validName = candidateName;
        return validName;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const marks = {};
    // Excludes mark starting with '_'. This allows marks to opt-out from the report.
    userTiming.filter(// @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
    (item)=>item.type === 'mark' && !item.name.startsWith('_') && !item.name.endsWith((0, $cJAh3.JS_EVAL_START)) && !item.name.endsWith((0, $cJAh3.JS_EVAL_STOP)) && item.startTime >= data.start)// @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
    .forEach((item)=>{
        const name = getNextAvailableName({
            baseName: `mark__${sanitizeName(item.name)}`,
            collection: marks
        });
        marks[name] = Math.round(item.startTime - data.start);
    });
    return marks;
};
const $71b5449896aa0d2f$export$6dfc8bfc2349f367 = (url)=>{
    const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($3Q6BV)))(url, true);
    let fileName = parsedUrl.pathname.replace(/\/(\w+)-(\d+)\//i, '/<issue-key>/').replace(/[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}/i, '<uuid>').replace(/\/pq\/[a-fA-F0-9]+/i, '/pq/<id>') // persisted queries
    .replace(/\/\d+$/i, '/<id>');
    /**
	 * For these endpoints we make a special exception to add the query parameters so that we can distinguish calls using different queries
	 */ if ($71b5449896aa0d2f$var$endpointsWithOperationNameRegex.test(fileName)) {
        const { operation: operation } = parsedUrl.query;
        if (operation) fileName += `?operation=${operation}`;
    }
    return fileName;
};

});
parcelRegister("jmNHL", function(module, exports) {
$parcel$export(module.exports, "getMemoryUsageReport", () => $fff10ea369943f60$export$e5bd2d61c7c80651);
// This is an approximation of the start of the session
const $fff10ea369943f60$var$sessionStart = Date.now();
const $fff10ea369943f60$export$e5bd2d61c7c80651 = ()=>{
    // @ts-expect-error - TS2339 - Property 'memory' does not exist on type 'Performance'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (typeof performance === 'undefined' || performance?.memory == null) return null;
    const now = Date.now();
    const sessionTime = now - $fff10ea369943f60$var$sessionStart;
    // @ts-expect-error - TS2339 - Property 'memory' does not exist on type 'Performance'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = performance.memory;
    return {
        sessionTime: sessionTime,
        performanceMemoryEntry: {
            jsHeapSizeLimit: jsHeapSizeLimit,
            totalJSHeapSize: totalJSHeapSize,
            usedJSHeapSize: usedJSHeapSize
        }
    };
};

});

parcelRegister("aKjW6", function(module, exports) {
$parcel$export(module.exports, "getServerDurationMetrics", () => $b26b8c3fdd816f36$export$efd8b60b870e5282);
/**
 * Extracts and compiles key performance metrics from the DOM to assess server response times and request handling efficiency.
 * This includes metrics like server duration, trace IDs, concurrency levels, and timing details, which are crucial for analyzing server behavior and identifying potential bottlenecks.
 */ const $b26b8c3fdd816f36$export$efd8b60b870e5282 = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const metrics = {};
    try {
        // server duration metric is buried in a hidden form near end of </body>
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverDurationElem = document.querySelector('#jira_request_timing_info [title="jira.request.server.time"]');
        if (serverDurationElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverDuration = Number(serverDurationElem.value);
            if (serverDuration > 0) metrics.serverDuration = Math.round(serverDuration);
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverTraceIdElem = document.querySelector('#jira_request_timing_info [title="jira.request.trace.id"]');
        if (serverTraceIdElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverRequestTraceId = serverTraceIdElem.value;
            metrics.serverRequestTraceId = serverRequestTraceId;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverTraceSampledElem = document.querySelector('#jira_request_timing_info [title="jira.request.sampled"]');
        if (serverTraceSampledElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverRequestTraceSampled = serverTraceSampledElem.value;
            switch(serverRequestTraceSampled){
                case 'true':
                    metrics.serverRequestTraceSampled = true;
                    break;
                case 'false':
                    metrics.serverRequestTraceSampled = false;
                    break;
                default:
                    metrics.serverRequestTraceSampled = null;
                    break;
            }
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const concurrentRequestsElem = document.querySelector('#jira_request_timing_info [name="jira.request.concurrent.requests"]');
        if (concurrentRequestsElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const concurrentRequests = concurrentRequestsElem.value;
            metrics.concurrentRequests = concurrentRequests;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverRequestStartTimeElem = document.querySelector('#jira_request_timing_info [name="jira.request.start.millis"]');
        if (serverRequestStartTimeElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverRequestStartTime = serverRequestStartTimeElem.value;
            metrics.serverRequestStartTime = serverRequestStartTime;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const frontendFlushStartTimeElem = document.querySelector('#jira_request_timing_info [name="jira.request.frontend.flush.start"]');
        if (frontendFlushStartTimeElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const frontendFlushStartTime = frontendFlushStartTimeElem.value;
            metrics.frontendFlushStartTime = frontendFlushStartTime;
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (ignored) {
    /* noop */ }
    return metrics;
};

});

parcelRegister("84rXz", function(module, exports) {
$parcel$export(module.exports, "getCacheHitRatio", () => $1d0927e6b92a3e53$export$e8a9322c3d9da8a6);

var $gPCSe = parcelRequire("gPCSe");
/* Borrowed from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/performance/browser-metrics/src/plugins/timings/resource.ts */ const $1d0927e6b92a3e53$var$cacheableTypes = [
    'script',
    'link'
];
const $1d0927e6b92a3e53$var$CACHE_NETWORK = 'network';
const $1d0927e6b92a3e53$var$CACHE_MEMORY = 'memory';
const $1d0927e6b92a3e53$var$CACHE_DISK = 'disk';
const $1d0927e6b92a3e53$var$calculateTransferType = (type, duration, size)=>{
    if (!$1d0927e6b92a3e53$var$cacheableTypes.includes(type)) return $1d0927e6b92a3e53$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $1d0927e6b92a3e53$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $1d0927e6b92a3e53$var$CACHE_DISK;
    if (size === undefined) return null;
    return $1d0927e6b92a3e53$var$CACHE_NETWORK;
};
const $1d0927e6b92a3e53$export$e8a9322c3d9da8a6 = ({ start: start })=>{
    let fromCache = 0;
    let preloadFromCache = 0;
    let total = 0;
    let totalPreload = 0;
    // initial load only
    if (start !== 0) return {};
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        for (const entry of (0, $gPCSe.default).getEntriesByType('resource')){
            // The BM3 resource timing collector checks for whether the timing information is available,
            // but we can make the assumption that it is for this Jira specific collector.
            const transferType = $1d0927e6b92a3e53$var$calculateTransferType(entry.initiatorType, entry.duration, entry.transferSize);
            const isPreload = entry.initiatorType === 'link';
            if (transferType === 'disk' || transferType === 'memory') {
                fromCache += 1;
                if (isPreload) preloadFromCache += 1;
            }
            if (transferType !== null) {
                total += 1;
                if (isPreload) totalPreload += 1;
            }
        }
        const result = {};
        if (total > 0) result.cacheHitRatio = fromCache / total;
        if (totalPreload > 0) result.preloadCacheHitRatio = preloadFromCache / totalPreload;
        return result;
    } catch (e) {
        return {};
    }
};

});

parcelRegister("cxegf", function(module, exports) {
$parcel$export(module.exports, "getCHRInfo", () => $c4ec0f3e660c0c60$export$9e005e111be93521);

var $gPCSe = parcelRequire("gPCSe");

var $bd1QF = parcelRequire("bd1QF");

var $cKGbY = parcelRequire("cKGbY");
const $c4ec0f3e660c0c60$export$9e005e111be93521 = ({ start: start })=>{
    // initial load only
    if (start !== 0) return {};
    const ssrMark = (0, $bd1QF.getSSRMark)();
    const reporter = new (0, $cKGbY.CHRReporter)(ssrMark);
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        for (const entry of (0, $gPCSe.default).getEntriesByType('resource'))reporter.add(entry);
        const chr = reporter.get();
        return chr === null ? {} : {
            chr: chr
        };
    } catch (e) {
        return {};
    }
};

});
parcelRegister("cKGbY", function(module, exports) {
$parcel$export(module.exports, "CHRReporter", () => $dfe09da0446f84da$export$7d0d4cfb6455ffa5);

var $gi6BY = parcelRequire("gi6BY");

var $hNKFE = parcelRequire("hNKFE");
class $dfe09da0446f84da$export$7d0d4cfb6455ffa5 {
    constructor(ssrMark){
        this.preloaded = new (0, $hNKFE.CHRSummary)();
        this.all = new (0, $hNKFE.CHRSummary)();
        this.ssrMark = null;
        this.ssrMark = ssrMark;
    }
    add(item) {
        if (item.encodedBodySize === 0) return;
        if (item.initiatorType === 'link' && (0, $gi6BY.cacheableTypes).includes(item.initiatorType) && (this.ssrMark === null || item.startTime < this.ssrMark)) this.preloaded.add(item);
        this.all.add(item);
    }
    static round(n) {
        return Math.round(n * 10000) / 10000;
    }
    makePayload(summary) {
        const bundlesLoadType = {
            mem: $dfe09da0446f84da$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $hNKFE.CHRSummary).MEMORY_KEY] / summary.bundlesCount),
            disk: $dfe09da0446f84da$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $hNKFE.CHRSummary).DISK_KEY] / summary.bundlesCount),
            net: $dfe09da0446f84da$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $hNKFE.CHRSummary).NETWORK_KEY] / summary.bundlesCount)
        };
        const bundlesRatio = $dfe09da0446f84da$export$7d0d4cfb6455ffa5.round((summary.bundles[(0, $hNKFE.CHRSummary).MEMORY_KEY] + summary.bundles[(0, $hNKFE.CHRSummary).DISK_KEY]) / summary.bundlesCount);
        const sizeLoadType = {
            mem: $dfe09da0446f84da$export$7d0d4cfb6455ffa5.round(summary.size[(0, $hNKFE.CHRSummary).MEMORY_KEY] / summary.sizeTotal),
            disk: $dfe09da0446f84da$export$7d0d4cfb6455ffa5.round(summary.size[(0, $hNKFE.CHRSummary).DISK_KEY] / summary.sizeTotal),
            net: $dfe09da0446f84da$export$7d0d4cfb6455ffa5.round(summary.size[(0, $hNKFE.CHRSummary).NETWORK_KEY] / summary.sizeTotal)
        };
        const sizeRatio = $dfe09da0446f84da$export$7d0d4cfb6455ffa5.round((summary.size[(0, $hNKFE.CHRSummary).MEMORY_KEY] + summary.size[(0, $hNKFE.CHRSummary).DISK_KEY]) / summary.sizeTotal);
        return {
            bundles: {
                ratio: bundlesRatio,
                count: summary.bundlesCount,
                loadType: bundlesLoadType
            },
            size: {
                ratio: sizeRatio,
                total: summary.sizeTotal,
                loadType: sizeLoadType
            }
        };
    }
    get() {
        if (this.all.bundlesCount === 0) return null;
        return {
            preloaded: this.makePayload(this.preloaded),
            all: this.makePayload(this.all)
        };
    }
}

});
parcelRegister("gi6BY", function(module, exports) {
$parcel$export(module.exports, "cacheableTypes", () => $f8b97f5eec2b020d$export$5e1aa91d6932ddaa);
/* Borrowed from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/performance/browser-metrics/src/plugins/timings/resource.ts */ const $f8b97f5eec2b020d$export$5e1aa91d6932ddaa = [
    'script',
    'link'
];

});

parcelRegister("hNKFE", function(module, exports) {
$parcel$export(module.exports, "CHRSummary", () => $cd892e62cb703278$export$783d6618ee601ba);

var $gi6BY = parcelRequire("gi6BY");
const $cd892e62cb703278$var$calculateTransferType = (type, duration, size)=>{
    if (!(0, $gi6BY.cacheableTypes).includes(type)) return null;
    if ((size === undefined || size === 0) && duration === 0) return $cd892e62cb703278$export$783d6618ee601ba.MEMORY_KEY;
    if (size === 0 && duration > 0) return $cd892e62cb703278$export$783d6618ee601ba.DISK_KEY;
    if (size === undefined) return null;
    return $cd892e62cb703278$export$783d6618ee601ba.NETWORK_KEY;
};
class $cd892e62cb703278$export$783d6618ee601ba {
    static{
        this.MEMORY_KEY = 'mem';
    }
    static{
        this.DISK_KEY = 'disk';
    }
    static{
        this.NETWORK_KEY = 'net';
    }
    add(item) {
        const type = $cd892e62cb703278$var$calculateTransferType(item.initiatorType, item.duration, item.transferSize);
        if (type === null) return;
        this.bundles[type] += 1;
        this.bundlesCount += 1;
        this.size[type] += item.encodedBodySize;
        this.sizeTotal += item.encodedBodySize;
    }
    constructor(){
        this.bundles = {
            [$cd892e62cb703278$export$783d6618ee601ba.MEMORY_KEY]: 0,
            [$cd892e62cb703278$export$783d6618ee601ba.DISK_KEY]: 0,
            [$cd892e62cb703278$export$783d6618ee601ba.NETWORK_KEY]: 0
        };
        this.bundlesCount = 0;
        this.size = {
            [$cd892e62cb703278$export$783d6618ee601ba.MEMORY_KEY]: 0,
            [$cd892e62cb703278$export$783d6618ee601ba.DISK_KEY]: 0,
            [$cd892e62cb703278$export$783d6618ee601ba.NETWORK_KEY]: 0
        };
        this.sizeTotal = 0;
    }
}

});



parcelRegister("9LzIn", function(module, exports) {
$parcel$export(module.exports, "getRouterResourceMetrics", () => $2a301144fe2cce75$export$e703af446a67c7f4);
const $2a301144fe2cce75$export$e703af446a67c7f4 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const ssrRouterResourceTimeouts = window.SPA_STATE ? Object.keys(window.SPA_STATE).filter((key)=>{
        if (key !== key.toUpperCase()) return false;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const resource = window.SPA_STATE[key];
        if (typeof resource !== 'object') return false;
        const resourceResponse = resource[Object.keys(resource)[0]];
        return resourceResponse?.error?.name === 'TimeoutError';
    }) : [];
    return {
        ssrRouterResourceTimeouts: ssrRouterResourceTimeouts
    };
};

});

parcelRegister("pSnTj", function(module, exports) {
$parcel$export(module.exports, "getWRMStats", () => $d5b5b9a6920f5e15$export$d2d916ddd03b82bc);
const $d5b5b9a6920f5e15$export$d2d916ddd03b82bc = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const wrmStats = window.__WRM_INTERNAL_STATS__ ?? {};
    return {
        wrmStats: wrmStats
    };
};

});


parcelRegister("3bfFp", function(module, exports) {
$parcel$export(module.exports, "jfpPerfFeatureFlags", () => $e0d26cf1dda88a51$export$b1f8075e4696e880);
const $e0d26cf1dda88a51$export$b1f8075e4696e880 = [];

});

parcelRegister("aRRWa", function(module, exports) {
$parcel$export(module.exports, "getLighthouseMetrics", () => $fe842ac51cd33b8d$export$b46cecdf698e4bb5);

var $8BXTP = parcelRequire("8BXTP");

var $3b3tm = parcelRequire("3b3tm");

var $6XArn = parcelRequire("6XArn");

var $IXHjh = parcelRequire("IXHjh");

var $hXeVV = parcelRequire("hXeVV");
const $fe842ac51cd33b8d$export$b46cecdf698e4bb5 = ({ start: start, stop: stop })=>{
    const tbt = (0, $6XArn.getTBT)(start, stop, (0, $IXHjh.EntriesBuffer)[(0, $3b3tm.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, $8BXTP.getCLS)(start, stop, (0, $IXHjh.EntriesBuffer)[(0, $3b3tm.PerformanceObserverEntryTypes).LayoutShift]);
    return {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls
    };
};

});
parcelRegister("8BXTP", function(module, exports) {
$parcel$export(module.exports, "getCLS", () => $4eac4f88a1f4afec$export$fc6227831ee7c7);
const $4eac4f88a1f4afec$export$fc6227831ee7c7 = (start, stop, buffer)=>{
    const layoutShifts = buffer.getAll().filter((entry)=>entry.startTime >= start && entry.startTime <= stop);
    const sessionWindows = [];
    let currentWindow = null;
    // Group layout shifts into session windows
    for (const shift of layoutShifts){
        const { startTime: startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime: startTime,
                endTime: endTime,
                score: score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
};

});

parcelRegister("3b3tm", function(module, exports) {
$parcel$export(module.exports, "PerformanceObserverEntryTypes", () => $1ce2790a9cacf064$export$a4def92db6fc8e17);
const $1ce2790a9cacf064$export$a4def92db6fc8e17 = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};

});

parcelRegister("6XArn", function(module, exports) {
$parcel$export(module.exports, "getTBT", () => $30e934b2bd258090$export$2d6e933b35bd3407);
const $30e934b2bd258090$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
const $30e934b2bd258090$export$2d6e933b35bd3407 = (start, stop, buffer)=>buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $30e934b2bd258090$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + $30e934b2bd258090$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $30e934b2bd258090$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });

});

parcelRegister("IXHjh", function(module, exports) {
$parcel$export(module.exports, "EntriesBuffer", () => $8dad8f5b76730210$export$f7dc16cbd16f7bbe);

var $3b3tm = parcelRequire("3b3tm");
class $8dad8f5b76730210$export$2c6e86519c9e8188 {
    constructor(maxLength = 1000){
        this.buffer = [];
        this.full = false;
        this.maxLength = maxLength;
    }
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
}
const $8dad8f5b76730210$export$f7dc16cbd16f7bbe = {
    [(0, $3b3tm.PerformanceObserverEntryTypes).LongTask]: new $8dad8f5b76730210$export$2c6e86519c9e8188(),
    [(0, $3b3tm.PerformanceObserverEntryTypes).LayoutShift]: new $8dad8f5b76730210$export$2c6e86519c9e8188()
};

});

parcelRegister("hXeVV", function(module, exports) {
$parcel$export(module.exports, "startLSObserver", () => $42f94d4c8054b925$export$768ccc3ab7bac3ea);
$parcel$export(module.exports, "startLTObserver", () => $42f94d4c8054b925$export$54fb8b6aaf70ec9c);

var $3b3tm = parcelRequire("3b3tm");

var $IXHjh = parcelRequire("IXHjh");
let $42f94d4c8054b925$var$pe = null;
const $42f94d4c8054b925$var$getObserver = ()=>{
    if ($42f94d4c8054b925$var$pe !== null) return $42f94d4c8054b925$var$pe;
    $42f94d4c8054b925$var$pe = new PerformanceObserver((list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $3b3tm.PerformanceObserverEntryTypes).LayoutShift) (0, $IXHjh.EntriesBuffer)[(0, $3b3tm.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $3b3tm.PerformanceObserverEntryTypes).LongTask) (0, $IXHjh.EntriesBuffer)[(0, $3b3tm.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    });
    return $42f94d4c8054b925$var$pe;
};
const $42f94d4c8054b925$export$768ccc3ab7bac3ea = ()=>{
    $42f94d4c8054b925$var$getObserver().observe({
        type: (0, $3b3tm.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
};
const $42f94d4c8054b925$export$54fb8b6aaf70ec9c = ()=>{
    $42f94d4c8054b925$var$getObserver().observe({
        type: (0, $3b3tm.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
};

});



const $c9cb1b3997607889$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $c9cb1b3997607889$export$f005e2e9f707cb5f = 'commercial';
const $c9cb1b3997607889$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $c9cb1b3997607889$export$a739cd5aac835909 = 'stg';
const $c9cb1b3997607889$export$42dd0cdd351a4a9 = 'prod';
const $c9cb1b3997607889$export$404582bc18fe4d9e = 'dev';

const $54dbbe6dc88f8bd2$export$42f4885608027d0c = 'non_boolean';

// This constant will be true on entry-fs (modern SSR) bundles and false on jira-fe-gateway (legacy SSR) and client bundles
const $9790b8dfe6f31c81$export$19d68f5aa485d903 = false;

const $652f5f63189f3e2a$export$ef94a84e2990361c = 'ISSUE_VIEW';
const $652f5f63189f3e2a$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
const $652f5f63189f3e2a$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
const $652f5f63189f3e2a$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
const $652f5f63189f3e2a$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
const $652f5f63189f3e2a$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
const $652f5f63189f3e2a$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
const $652f5f63189f3e2a$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
const $652f5f63189f3e2a$export$4695c1a423ffe431 = 'DASHBOARD';
const $652f5f63189f3e2a$export$f999749ac7a2cd1 = 'PLAN_CALENDAR';
const $652f5f63189f3e2a$export$9a80695e72849f84 = 'X-Atlassian-Capability';

// SCREENS
const $466f60259c330878$export$f636b5b56f1d624a = 'Screen';
const $466f60259c330878$export$9d2de6eebf7462b5 = 'Drawer';
const $466f60259c330878$export$1171103ea9083ffa = 'Modal';
const $466f60259c330878$export$cae2783c9279926 = 'InlineDialog';
const $466f60259c330878$export$d1123261ca8831d2 = 'Dropdown';
const $466f60259c330878$export$238d30785c4bca84 = 'Banner';
const $466f60259c330878$export$a1562d08625f5d7e = 'UI';
const $466f60259c330878$export$947dac6c72b26f81 = 'TRACK';
const $466f60259c330878$export$f1d537d508d2945a = 'SCREEN';
const $466f60259c330878$export$12346a674644c156 = 'OPERATIONAL';

const $e9db81972dce4ebc$export$f636b5b56f1d624a = 'Screen';
const $e9db81972dce4ebc$export$9d2de6eebf7462b5 = 'Drawer';
const $e9db81972dce4ebc$export$1171103ea9083ffa = 'Modal';
const $e9db81972dce4ebc$export$cae2783c9279926 = 'InlineDialog';
const $e9db81972dce4ebc$export$d1123261ca8831d2 = 'Dropdown';
const $e9db81972dce4ebc$export$a1562d08625f5d7e = 'UI';
const $e9db81972dce4ebc$export$947dac6c72b26f81 = 'TRACK';
const $e9db81972dce4ebc$export$f1d537d508d2945a = 'SCREEN';
const $e9db81972dce4ebc$export$12346a674644c156 = 'OPERATIONAL';
const $e9db81972dce4ebc$export$2ceccf177fae277c = 'analyticsBridge';

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $5bf02ef989474068$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

// same types defined in analytics-web-client but avoid creating dependency with that
const $d6f34b7bd34f6138$export$a1562d08625f5d7e = 'ui';
const $d6f34b7bd34f6138$export$947dac6c72b26f81 = 'track';
const $d6f34b7bd34f6138$export$f1d537d508d2945a = 'screen';
const $d6f34b7bd34f6138$export$12346a674644c156 = 'operational';
const $d6f34b7bd34f6138$export$b055de0e665cb20c = 'unknown';

const $71feb0ebe2f021d7$export$cf090d5281b5ae06 = 10000;
const $71feb0ebe2f021d7$export$8575e30be0feb909 = 30000;

const $10b5883439ef237e$export$3288b14b6745c572 = 204;
const $10b5883439ef237e$export$c09e7ea0fc79f34f = 409;
const $10b5883439ef237e$export$974c37534b0191b1 = 503;

const $3e9c0e1856c1af11$export$b98e411ae80c806f = '/';

// temp solution until a proper versioning
const $c2146f5087eba60f$export$93809551debf385f = '0.1.7';

const $779a7211687b8cb3$export$b98e411ae80c806f = '/';


$parcel$global.rlb("b3QiB")
//# sourceMappingURL=shared~commons~ar.8c36dae2.js.map
